export default {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "id": 68139,
        "url": "http://www.pleanala.ie/casenum/307043.htm",
        "la": "Dun Laoghaire-Rathdown County Council",
        "dev_desc": "116 no. residential units (85 no. houses, 31 no. apartments), childcare facility and associated site works.",
        "abp_ref": "PL06D.307043",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2020-04-09 0:00:00",
        "scraped_datetime": "2020-06-13 14:56:04",
        "documents": "\"[]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Paul and David Butler \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Paul and David Butler\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-04-09 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-06-08 21:58:54",
        "updated_at": "2020-06-13 14:56:04",
        "file_num/website": "www.suttonsfieldsshd.ie",
        "area ha": "3.82",
        "no of units": "116",
        "agent": "Stephen Newell Architects Ltd ",
        "owner": "Paul and David Butler",
        "apartments": "31",
        "houses": "85",
        "student": "",
        "studio": "",
        "apt.1_bed": "13",
        "apt.2_bed": "16",
        "apt.3_bed": "2",
        "apt.4_bed": "0",
        "apt.5_bed": "0",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "7",
        "house.2_bed": "2",
        "house.3_bed": "40",
        "house.4_bed": "36",
        "house.4+_bed": "0",
        "other notes": "1 childcare 31 places (159 sqm)\r\n",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7310",
        "ref": "PL06D.307043"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.1982303,
          53.2370413
        ]
      },
      "id": 0
    },
    {
      "type": "Feature",
      "properties": {
        "id": 68290,
        "url": "http://www.pleanala.ie/casenum/307222.htm",
        "la": "South Dublin County Council",
        "dev_desc": "Demolition of existing structures, construction of 496 no. apartments, creche and associated site works.",
        "abp_ref": "PL06S.307222",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2020-05-25 0:00:00",
        "scraped_datetime": "2020-06-13 15:24:40",
        "documents": "\"[]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Shannon Homes Construction ULC \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Shannon Homes Construction ULC\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-05-25 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-06-08 22:11:25",
        "updated_at": "2020-06-13 15:24:40",
        "file_num/website": "www.taylorslaneshd.ie",
        "area ha": "3.8",
        "no of units": "496",
        "agent": "McGill Planning",
        "owner": "Shannon Homes Construction ULC",
        "apartments": "496",
        "houses": "0",
        "student": "",
        "studio": "",
        "apt.1_bed": "36",
        "apt.2_bed": "391",
        "apt.3_bed": "69",
        "apt.4_bed": "0",
        "apt.5_bed": "0",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "0",
        "house.2_bed": "0",
        "house.3_bed": "0",
        "house.4_bed": "0",
        "house.4+_bed": "0",
        "other notes": "Creche 124 (655 sqm)\r\nCommunity Facility (278sqm)\r\nRetail (278 + 97 sqm)\r\nBike Store (13 sqm)",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7311",
        "ref": "PL06S.307222"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.2960352,
          53.281048
        ]
      },
      "id": 1
    },
    {
      "type": "Feature",
      "properties": {
        "id": 68295,
        "url": "http://www.pleanala.ie/casenum/307239.htm",
        "la": "Dublin City Council",
        "dev_desc": "Demolition of existing buildings, construction of 614 no. residential units (3 no. townhouses, 611 no. apartments), childcare facilities and associated site works.",
        "abp_ref": "PL29S.307239",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2020-05-27 0:00:00",
        "scraped_datetime": "2020-06-13 15:24:45",
        "documents": "\"[]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Cairn Homes Properties Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Cairn Homes Properties Limited\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-05-27 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-06-08 22:11:33",
        "updated_at": "2020-06-13 15:24:45",
        "file_num/website": "www.montroseplanningshd.com",
        "area ha": "4.155",
        "no of units": "614",
        "agent": "Avison Young",
        "owner": "Cairn Homes Properties Limited",
        "apartments": "611",
        "houses": "3",
        "student": "",
        "studio": "",
        "apt.1_bed": "187",
        "apt.2_bed": "361",
        "apt.3_bed": "63",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "3",
        "house.4+_bed": "",
        "other notes": "Childcare 100 places (396)\r\nCafe x 2 (300sqm)\r\nResidents Gym & Clud 466sqm\r\nConcierge 185sqm\r\n\"residential amenity\" 368sqm\r\nOther (68sqm)",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7312",
        "ref": "PL29S.307239"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.227445602416992,
          53.31725553953627
        ]
      },
      "id": 2
    },
    {
      "type": "Feature",
      "properties": {
        "id": 68308,
        "url": "http://www.pleanala.ie/casenum/307197.htm",
        "la": "Dublin City Council",
        "dev_desc": "105 no. apartments, aparthotel extension and associated site works.",
        "abp_ref": "PL29S.307197",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2020-05-20 0:00:00",
        "scraped_datetime": "2020-06-13 15:24:58",
        "documents": "\"[]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Derryroe Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Derryroe Limited\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-05-20 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-06-08 22:11:59",
        "updated_at": "2020-06-13 15:24:58",
        "file_num/website": "www.herbertparkshd.com",
        "area ha": "0.5",
        "no of units": "105",
        "agent": "Stephen Little & Associates",
        "owner": "Derryroe Limited",
        "apartments": "105",
        "houses": "0",
        "student": "",
        "studio": "",
        "apt.1_bed": "37",
        "apt.2_bed": "66",
        "apt.3_bed": "2",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Aparthotel extension (600sqm)",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7313",
        "ref": "PL29S.307197"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.233161389827728,
          53.328527888422705
        ]
      },
      "id": 3
    },
    {
      "type": "Feature",
      "properties": {
        "id": 68214,
        "url": "http://www.pleanala.ie/casenum/306778.htm",
        "la": "Dublin City Council",
        "dev_desc": "Demolition of existing buildings, construction of 336 no. apartments, childcare facilities and associated site works.",
        "abp_ref": "PL29N.306778",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2020-03-03 0:00:00",
        "scraped_datetime": "2020-06-13 14:57:16",
        "documents": "\"[]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"EWR Innovation Park Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"EWR Innovation Park Limited\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-03-03 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-06-08 22:02:47",
        "updated_at": "2020-06-13 14:57:16",
        "file_num/website": "www.ewripshd.ie",
        "area ha": "1.45",
        "no of units": "336",
        "agent": "John Spain Associates",
        "owner": "EWR Innovation Park Limited",
        "apartments": "336",
        "houses": "",
        "student": "",
        "studio": "",
        "apt.1_bed": "161",
        "apt.2_bed": "171",
        "apt.3_bed": "4",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Childcare 20-40 places (120sqm)",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7314",
        "ref": "PL29N.306778"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.228405833244324,
          53.353583613542035
        ]
      },
      "id": 4
    },
    {
      "type": "Feature",
      "properties": {
        "id": 68216,
        "url": "http://www.pleanala.ie/casenum/306794.htm",
        "la": "Fingal County Council",
        "dev_desc": "144 no. apartments and associated site works.",
        "abp_ref": "PL06F.306794",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2020-03-04 0:00:00",
        "scraped_datetime": "2020-06-13 14:57:18",
        "documents": "\"[]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Elchoir Construction Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Elchoir Construction Limited\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-03-04 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-06-08 22:02:56",
        "updated_at": "2020-06-13 14:57:18",
        "file_num/website": "www.turveyavenueshd.ie",
        "area ha": "1.16",
        "no of units": "144",
        "agent": "Downey Planning",
        "owner": "Elchior Construction Ltd.",
        "apartments": "144",
        "houses": "",
        "student": "",
        "studio": "",
        "apt.1_bed": "26",
        "apt.2_bed": "100",
        "apt.3_bed": "18",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Retail unit (382sqm)",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7315",
        "ref": "PL06F.306794"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.153271794319153,
          53.48659325232447
        ]
      },
      "id": 5
    },
    {
      "type": "Feature",
      "properties": {
        "id": 68229,
        "url": "http://www.pleanala.ie/casenum/306771.htm",
        "la": "Fingal County Council",
        "dev_desc": "Demolition of existing buildings, construction of 172 no. apartments, childcare facility and associated site works.",
        "abp_ref": "PL06F.306771",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2020-02-27 0:00:00",
        "scraped_datetime": "2020-06-13 14:57:29",
        "documents": "\"[]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Jacko Investments Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Jacko Investments Limited\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-02-27 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-06-08 22:04:01",
        "updated_at": "2020-06-13 14:57:29",
        "file_num/website": "www.mainstreetswordsshd.com",
        "area ha": "1.4",
        "no of units": "172",
        "agent": "Hughes Planning and Development\r\nConsultants",
        "owner": "Jacko Investments Limited",
        "apartments": "172",
        "houses": "",
        "student": "",
        "studio": "",
        "apt.1_bed": "67",
        "apt.2_bed": "101",
        "apt.3_bed": "4",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Childcare (242)\r\nRetail x 2 (698)",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7316",
        "ref": "PL06F.306771"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.2237902,
          53.4555948
        ]
      },
      "id": 6
    },
    {
      "type": "Feature",
      "properties": {
        "id": 68259,
        "url": "http://www.pleanala.ie/casenum/306626.htm",
        "la": "Dun Laoghaire-Rathdown County Council",
        "dev_desc": "Demolition of 'Chareville', 'Coach House' and ancillary buildings, construction of 105 no. apartments and associated site works.",
        "abp_ref": "PL06D.306626",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2020-02-12 0:00:00",
        "scraped_datetime": "2020-06-13 14:58:00",
        "documents": "\"[]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Winterbrook Homes Ltd \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Winterbrook Homes Ltd\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-02-12 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-06-08 22:05:46",
        "updated_at": "2020-06-13 14:58:00",
        "file_num/website": "http://harbourroadshd.ie/",
        "area ha": "0.69",
        "no of units": "105",
        "agent": "Brock McClure Planning and Development\r\nConsultants",
        "owner": "Winterbrook Homes (Dalkey) Ltd",
        "apartments": "105",
        "houses": "",
        "student": "",
        "studio": "",
        "apt.1_bed": "49",
        "apt.2_bed": "54",
        "apt.3_bed": "2",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Residential Amenity (195sqm)",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7317",
        "ref": "PL06D.306626"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.1118841,
          53.2811852
        ]
      },
      "id": 7
    },
    {
      "type": "Feature",
      "properties": {
        "id": 68123,
        "url": "http://www.pleanala.ie/casenum/307092.htm",
        "la": "South Dublin County Council",
        "dev_desc": "Demolition of existing structures, construction of 250 no. Build to Rent apartments and associated site works.",
        "abp_ref": "PL06S.307092",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2020-04-21 0:00:00",
        "scraped_datetime": "2020-06-13 15:25:23",
        "documents": "\"[]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Randelswood Holdings Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Randelswood Holdings Limited\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-04-21 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-06-08 21:58:07",
        "updated_at": "2020-06-13 15:25:23",
        "file_num/website": "www.palmerstownshd2.ie",
        "area ha": "1.27",
        "no of units": "250",
        "agent": "Downey Planning",
        "owner": "Randelswood Holdings Ltd.",
        "apartments": "250",
        "houses": "",
        "student": "",
        "studio": "",
        "apt.1_bed": "134",
        "apt.2_bed": "116",
        "apt.3_bed": "",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Cafe 133\r\nAncilarry Residential (493sqm)",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7318",
        "ref": "PL06S.307092"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.372370719909668,
          53.355552728755264
        ]
      },
      "id": 8
    },
    {
      "type": "Feature",
      "properties": {
        "id": 68132,
        "url": "http://www.pleanala.ie/casenum/307067.htm",
        "la": "Dublin City Council",
        "dev_desc": "413 no.  Build to Rent apartments and associated site works.",
        "abp_ref": "PL29S.307067",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2020-04-17 0:00:00",
        "scraped_datetime": "2020-06-13 15:24:01",
        "documents": "\"[]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Carrey Issuer DAC \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Carrey Issuer DAC\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-04-17 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-06-08 21:58:32",
        "updated_at": "2020-06-13 15:24:01",
        "file_num/website": "https://newmarketsquareshd.ie/",
        "area ha": "0.66",
        "no of units": "413",
        "agent": "BMA Planning",
        "owner": "Carrey Issuer DAC",
        "apartments": "413",
        "houses": "",
        "student": "",
        "studio": "203",
        "apt.1_bed": "136",
        "apt.2_bed": "72",
        "apt.3_bed": "2",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Ancillary Residential (gym, support facilities etc) 2129 sqm\r\nCafe 216sqm\r\nRetail x 2 490sqm\r\nArtist Studio 129sqm",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7319",
        "ref": "PL29S.307067"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.27694845199585,
          53.33846802600639
        ]
      },
      "id": 9
    },
    {
      "type": "Feature",
      "properties": {
        "id": 68227,
        "url": "http://www.pleanala.ie/casenum/306721.htm",
        "la": "Dublin City Council",
        "dev_desc": "124 no. apartments and all assocaited site works.",
        "abp_ref": "PL29N.306721",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2020-02-24 0:00:00",
        "scraped_datetime": "2020-06-13 14:57:28",
        "documents": "\"[]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Roseberry Investments Limited \\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Roseberry Investments Limited\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Roseberry Investments Limited\\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Roseberry Investments Limited\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-02-24 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-06-08 22:03:37",
        "updated_at": "2020-06-13 14:57:28",
        "file_num/website": "www.ocaverdedublin.com",
        "area ha": "0.65",
        "no of units": "124",
        "agent": "John Spain Associates ",
        "owner": "Roseberry Investments Limited",
        "apartments": "124",
        "houses": "",
        "student": "",
        "studio": "",
        "apt.1_bed": "48",
        "apt.2_bed": "76",
        "apt.3_bed": "",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "No other development",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7320",
        "ref": "PL29N.306721"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.247165203094482,
          53.37767100621146
        ]
      },
      "id": 10
    },
    {
      "type": "Feature",
      "properties": {
        "id": 68293,
        "url": "http://www.pleanala.ie/casenum/307236.htm",
        "la": "Dublin City Council",
        "dev_desc": "296 no. student bedspace accommodation and associated site works.",
        "abp_ref": "PL29N.307236",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2020-05-27 0:00:00",
        "scraped_datetime": "2020-06-13 15:24:44",
        "documents": "\"[]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Prussia Properties Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Prussia Properties Limited\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-05-27 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-06-08 22:11:31",
        "updated_at": "2020-06-13 15:24:44",
        "file_num/website": "www.prussia.ie",
        "area ha": "0.285",
        "no of units": "296",
        "agent": "Simon Clear & Associates",
        "owner": "Prussia Properties Limited",
        "apartments": "",
        "houses": "",
        "student": "",
        "studio": "",
        "apt.1_bed": "",
        "apt.2_bed": "",
        "apt.3_bed": "",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Student Acc\r\n6 3 bed\r\n1 4 bed\r\n36 5 bed\r\nRetail 204sqm\r\nStudent internal amenity 1308sqm\r\nServices 251",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7321",
        "ref": "PL29N.307236"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.286732,
          53.3553633
        ]
      },
      "id": 11
    },
    {
      "type": "Feature",
      "properties": {
        "id": 68299,
        "url": "http://www.pleanala.ie/casenum/307257.htm",
        "la": "Dublin City Council",
        "dev_desc": "Demolition of existing buildings, construction of 438 no. apartments, childcare facility and associated site works.",
        "abp_ref": "PL29N.307257",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2020-05-29 0:00:00",
        "scraped_datetime": "2020-06-13 15:24:49",
        "documents": "\"[]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Belwall Limited \\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Belwall Limited\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Belwall Limited\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Belwall Limited\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Belwall Limited\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-05-29 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-06-08 22:11:40",
        "updated_at": "2020-06-13 15:24:49",
        "file_num/website": "https://www.holeinthewallroadshd.ie/",
        "area ha": "1.96",
        "no of units": "438",
        "agent": "Downey Planning",
        "owner": "Belwall Limited",
        "apartments": "",
        "houses": "",
        "student": "",
        "studio": "55",
        "apt.1_bed": "150",
        "apt.2_bed": "233",
        "apt.3_bed": "",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Childcare 65 places 268.8sqm\r\nResidential Amenity (ancillary to residential use)  671sqm",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7322",
        "ref": "PL29N.307257"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.162986755371094,
          53.399867357488134
        ]
      },
      "id": 12
    },
    {
      "type": "Feature",
      "properties": {
        "id": 68199,
        "url": "http://www.pleanala.ie/casenum/306837.htm",
        "la": "Dublin City Council",
        "dev_desc": "Demolition of existing structures within the curtilage of Greenane House (a protected structure), construction of 4 no. apartments, 358 no. student accommodation bedspaces and associated site works.",
        "abp_ref": "PL29S.306837",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2020-03-09 0:00:00",
        "scraped_datetime": "2020-06-13 14:57:00",
        "documents": "\"[]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Trinity College Dublin \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Trinity College Dublin\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-03-09 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-06-08 22:01:48",
        "updated_at": "2020-06-13 14:57:00",
        "file_num/website": "www.tcdplanning.ie",
        "area ha": "1.07",
        "no of units": "462",
        "agent": "Reddy Architecture + Urbanism",
        "owner": "Trinity College Dublin ",
        "apartments": "4",
        "houses": "",
        "student": "358",
        "studio": "",
        "apt.1_bed": "",
        "apt.2_bed": "3",
        "apt.3_bed": "1",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "50 units with 358 spaces\r\nClassrooms 68m²\r\nSports Hall (Internal Amenity Space) 494m²\r\nSecurity Hall 10m²",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7323",
        "ref": "PL29S.306837"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.2606635,
          53.3122745
        ]
      },
      "id": 13
    },
    {
      "type": "Feature",
      "properties": {
        "id": 68201,
        "url": "http://www.pleanala.ie/casenum/306872.htm",
        "la": "Fingal County Council",
        "dev_desc": "Alterations to a previously permitted development of 96 no. units under (Reg, Ref: F17A/0615) to provide 143 no. apartments. The total number of additional/altered residential units subject to this application is 102 no. units with all associated site works.",
        "abp_ref": "PL06F.306872",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2020-03-11 0:00:00",
        "scraped_datetime": "2020-06-13 14:57:03",
        "documents": "\"[]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Parsis Ltd \\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Parsis Ltd\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Parsis Ltd\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Parsis Ltd\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Parsis Ltd\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Parsis Ltd\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Parsis Ltd\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-03-11 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-06-08 22:02:01",
        "updated_at": "2020-06-13 14:57:03",
        "file_num/website": "www.seafieldshd.ie",
        "area ha": "2.46",
        "no of units": "102",
        "agent": "John Spain Associates",
        "owner": "Parsis Ltd",
        "apartments": "",
        "houses": "",
        "student": "",
        "studio": "15",
        "apt.1_bed": "78",
        "apt.2_bed": "9",
        "apt.3_bed": "",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Previously permitted creche (95sqm)",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7324",
        "ref": "PL06F.306872"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.102207899093628,
          53.38746851654844
        ]
      },
      "id": 14
    },
    {
      "type": "Feature",
      "properties": {
        "id": 68258,
        "url": "http://www.pleanala.ie/casenum/306602.htm",
        "la": "South Dublin County Council",
        "dev_desc": "463 no. residential units (89 no. houses, 353 no. apartments, 21 no. duplex apartments), creche and associated site works.",
        "abp_ref": "PL06S.306602",
        "app_type": "Strategic Housing Development - Application",
        "decision": "Grant Perm. w   Conditions",
        "signed": "26/05/2020",
        "lodged": "2020-02-10 0:00:00",
        "scraped_datetime": "2020-06-13 14:57:58",
        "documents": "\"[{\\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/306/R306602.pdf\\\", \\\"url_hash\\\": \\\"f140ecdbaeaa9a0346c279c175222d72\\\", \\\"name\\\": \\\"Inspectors report (306/R306602.pdf, PDF format 578kB)\\\"}, {\\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/306/D306602.pdf\\\", \\\"url_hash\\\": \\\"bd10c3432c592523ad5c82d7981052fd\\\", \\\"name\\\": \\\"Order (306/D306602.pdf, PDF format 147kB)\\\"}, {\\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/306/S306602.pdf\\\", \\\"url_hash\\\": \\\"7833d64dbf93b8b0e852e8f86fabfdff\\\", \\\"name\\\": \\\"Direction (306/S306602.pdf, PDF format 182kB)\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Glenveagh Homes Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Glenveagh Homes Limited\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Grant Perm. w   Conditions\\\", \\\"date\\\": \\\"2020-05-26 00:00:00+00:00\\\"}, {\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-02-10 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-06-08 22:05:37",
        "updated_at": "2020-06-13 14:57:58",
        "file_num/website": "www.citywestroadshd.ie",
        "area ha": "7.4",
        "no of units": "463",
        "agent": "John Spain Associates",
        "owner": "Glenveagh Homes Limited",
        "apartments": "374",
        "houses": "89",
        "student": "",
        "studio": "22",
        "apt.1_bed": "65",
        "apt.2_bed": "256",
        "apt.3_bed": "31",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "51",
        "house.3_bed": "20",
        "house.4_bed": "18",
        "house.4+_bed": "",
        "other notes": "Creche 587.8sq. m\r\nCommunity Building 141sq. m",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7325",
        "ref": "PL06S.306602"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.4198994636535645,
          53.28108575072854
        ]
      },
      "id": 15
    },
    {
      "type": "Feature",
      "properties": {
        "id": 68289,
        "url": "http://www.pleanala.ie/casenum/307221.htm",
        "la": "Dublin City Council",
        "dev_desc": "Demolition of all structures, construction of 416 no. residential units (4 no. houses, 412 no. apartments) and associated site works.",
        "abp_ref": "PL29S.307221",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2020-05-25 0:00:00",
        "scraped_datetime": "2020-06-13 15:24:39",
        "documents": "\"[]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"DBTR-SCR1 Fund aSub-Fund of the CWTC Multi Family ICAV \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"DBTR-SCR1 Fund aSub-Fund of the CWTC Multi Family ICAV\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-05-25 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-06-08 22:11:25",
        "updated_at": "2020-06-13 15:24:39",
        "file_num/website": "https://bgscr1shd.ie",
        "area ha": "2.18",
        "no of units": "412",
        "agent": "McCutcheon Halley Planning Consultants",
        "owner": "DBTR-SCR1 Fund, a Sub-Fund of the CWTC\r\nMulti Family ICAV",
        "apartments": "412",
        "houses": "4",
        "student": "",
        "studio": "19",
        "apt.1_bed": "251",
        "apt.2_bed": "136",
        "apt.3_bed": "6",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "4",
        "house.4+_bed": "",
        "other notes": "Childcare facilities (54 no. of childcare spaces) 233\r\nCommercial floorspace to facilitate a restaurant/cáfe/bar\r\nand commercial floorspace to facilitate a range of uses\r\nincluding Class 1 (shop), Class 2 (financial/professional\r\nservices) , Class 8 (health services), Class 10\r\n(community/arts) and Class 11 (bingo hall);\r\n388\r\nTenant Amenities 812",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7326",
        "ref": "PL29S.307221"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.28792405128479,
          53.33341656009183
        ]
      },
      "id": 16
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64340,
        "url": "http://www.pleanala.ie/casenum/306421.htm",
        "la": "Dun Laoghaire-Rathdown County Council",
        "dev_desc": "101 no. apartments and associated site works.",
        "abp_ref": "PL06D.306421",
        "app_type": "Strategic Housing Development - Application",
        "decision": "Grant Perm. w   Conditions",
        "signed": "05/05/2020",
        "lodged": "2020-01-17 0:00:00",
        "scraped_datetime": "2020-06-13 14:58:53",
        "documents": "\"[{\\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/306/R306421.pdf\\\", \\\"url_hash\\\": \\\"f8b8d60bbbf969926239541ff413abb2\\\", \\\"name\\\": \\\"Inspectors report (306/R306421.pdf, PDF format 557kB)\\\"}, {\\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/306/D306421.pdf\\\", \\\"url_hash\\\": \\\"f31a9688ae18ee85cbc0efd15a0d8025\\\", \\\"name\\\": \\\"Order (306/D306421.pdf, PDF format 142kB)\\\"}, {\\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/306/S306421.pdf\\\", \\\"url_hash\\\": \\\"00bb2ce2a6aa14e1caaccca08fec9e0d\\\", \\\"name\\\": \\\"Direction (306/S306421.pdf, PDF format 184kB)\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Curve Devco Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Curve Devco Limited\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Grant Perm. w   Conditions\\\", \\\"date\\\": \\\"2020-05-05 00:00:00+00:00\\\"}, {\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-01-17 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-02-06 14:01:47",
        "updated_at": "2020-06-13 14:58:53",
        "file_num/website": "www.castleparkroadshd.com",
        "area ha": "1.27",
        "no of units": "101",
        "agent": "STEPHEN LITTLE & ASSOCIATES",
        "owner": "Curve Devco\r\nLimited ",
        "apartments": "101",
        "houses": "",
        "student": "",
        "studio": "11",
        "apt.1_bed": "26",
        "apt.2_bed": "64",
        "apt.3_bed": "",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Website of application is hacked so cannot determine full details",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7327",
        "ref": "PL06D.306421"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.11038327217102,
          53.28315122184075
        ]
      },
      "id": 17
    },
    {
      "type": "Feature",
      "properties": {
        "id": 68158,
        "url": "http://www.pleanala.ie/casenum/306987.htm",
        "la": "Dublin City Council",
        "dev_desc": "120 no. apartments and associated site works. The proposed development will amend and supersede the development currently being undertaken on site permitted under ABP-303358-19.",
        "abp_ref": "PL29N.306987",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2020-03-23 0:00:00",
        "scraped_datetime": "2020-06-13 14:56:23",
        "documents": "\"[]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Cinamol Ltd. \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Cinamol Ltd.\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-03-23 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-06-08 21:59:58",
        "updated_at": "2020-06-13 14:56:23",
        "file_num/website": "www.swisscottagesantry2shd.ie",
        "area ha": "0.48",
        "no of units": "120",
        "agent": "John Spain Associates",
        "owner": "Cinamol Ltd",
        "apartments": "120",
        "houses": "",
        "student": "",
        "studio": "",
        "apt.1_bed": "26",
        "apt.2_bed": "91",
        "apt.3_bed": "3",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Retail 89 sq.m.\r\nRestaurant (Licenced) 155 sq.m.\r\nCafé 148 sq.m. ",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7328",
        "ref": "PL29N.306987"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.245019435882568,
          53.39584036946791
        ]
      },
      "id": 18
    },
    {
      "type": "Feature",
      "properties": {
        "id": 68166,
        "url": "http://www.pleanala.ie/casenum/307011.htm",
        "la": "Dublin City Council",
        "dev_desc": "Demolition of existing structures, construction of 324 no. apartments, creche and associated site works.",
        "abp_ref": "PL29N.307011",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2020-03-27 0:00:00",
        "scraped_datetime": "2020-06-13 14:56:32",
        "documents": "\"[]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Omni Park Shopping Centre Consortium \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Omni Park Shopping Centre Consortium\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-03-27 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-06-08 22:00:14",
        "updated_at": "2020-06-13 14:56:32",
        "file_num/website": "www.omnilivingshd.ie",
        "area ha": "1.29",
        "no of units": "324",
        "agent": "John Spain Associates",
        "owner": "MKN Investments Limited & Caltrack Limited\r\n(trading as Omni Shopping centre Consortium)",
        "apartments": "324",
        "houses": "",
        "student": "",
        "studio": "19",
        "apt.1_bed": "126",
        "apt.2_bed": "179",
        "apt.3_bed": "",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Creche 258\r\nAparthotel 4,020\r\nCafé. Restaurant/ Retail 186",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7329",
        "ref": "PL29N.307011"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.246618032455444,
          53.39386671832711
        ]
      },
      "id": 19
    },
    {
      "type": "Feature",
      "properties": {
        "id": 68245,
        "url": "http://www.pleanala.ie/casenum/306705.htm",
        "la": "South Dublin County Council",
        "dev_desc": "502 no. apartments with a creche and all associated site works. \r\n(www.gallahersiteshd.ie)",
        "abp_ref": "PL06S.306705",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2020-02-18 0:00:00",
        "scraped_datetime": "2020-06-13 14:57:46",
        "documents": "\"[]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Greenleaf Homes Ltd \\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Greenleaf Homes Ltd\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-02-18 00:00:00+00:00\\\"}, {\\\"state\\\": \\\"The application is subject to an EIA procedure. Application documentation associated with\\\", \\\"date\\\": \\\"2020-02-18 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-06-08 22:04:56",
        "updated_at": "2020-06-13 14:57:46",
        "file_num/website": "https://www.gallahersiteshd.ie/",
        "area ha": "2.79",
        "no of units": "502",
        "agent": "McGill Planning",
        "owner": "Greenleaf Homes Ltd",
        "apartments": "502",
        "houses": "",
        "student": "",
        "studio": "",
        "apt.1_bed": "197",
        "apt.2_bed": "257",
        "apt.3_bed": "48",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Creche (44 Children) 329\r\nCommunal facilities 704 in total\r\nRetail units (3 No.) 482 in total\r\nBin stores, Services 324 in total",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7330",
        "ref": "PL06S.306705"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.357908248901367,
          53.293220567195036
        ]
      },
      "id": 20
    },
    {
      "type": "Feature",
      "properties": {
        "id": 68246,
        "url": "http://www.pleanala.ie/casenum/306722.htm",
        "la": "Dublin City Council",
        "dev_desc": "548 no. residential units (464 no. apartments, 84 no. shared accommodation) and associated site works.",
        "abp_ref": "PL29N.306722",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2020-02-21 0:00:00",
        "scraped_datetime": "2020-06-13 14:57:47",
        "documents": "\"[]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Spencer Place Development Company Limited \\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Spencer Place Development Company Limited\\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Spencer Place Development Company Limited\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Spencer Place Development Company Limited\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Reactivated case, Old Number ABP-305219-19.\\\", \\\"date\\\": \\\"2020-02-21 00:00:00+00:00\\\"}, {\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-02-21 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-06-08 22:04:59",
        "updated_at": "2020-06-13 14:57:47",
        "file_num/website": "https://www.spencernorthshd.ie/",
        "area ha": "1.26",
        "no of units": "548",
        "agent": "John Spain Associates",
        "owner": "Spencer Place Development Company Ltd",
        "apartments": "464",
        "houses": "",
        "student": "84",
        "studio": "",
        "apt.1_bed": "229",
        "apt.2_bed": "235",
        "apt.3_bed": "",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "84 units shared accomondation\r\n200 bed spaces\r\nCafé 114 sq.m.",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7331",
        "ref": "PL29N.306722"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.2358033657073975,
          53.349846847257574
        ]
      },
      "id": 21
    },
    {
      "type": "Feature",
      "properties": {
        "id": 68181,
        "url": "http://www.pleanala.ie/casenum/306949.htm",
        "la": "Dun Laoghaire-Rathdown County Council",
        "dev_desc": "Demolition of existing dwelling and other structures, conversion of Dalguise House to 2 no. houses, construction of 298 no. residential units (22 no. houses, 276 no. apartments), creche and associated site works.",
        "abp_ref": "PL06D.306949",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2020-03-20 0:00:00",
        "scraped_datetime": "2020-06-13 14:56:45",
        "documents": "\"[]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Lulani Dalguise Ltd \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Lulani Dalguise Ltd\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-03-20 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-06-08 22:01:02",
        "updated_at": "2020-06-13 14:56:45",
        "file_num/website": "www.dalguiseshd.com",
        "area ha": "3.66",
        "no of units": "300",
        "agent": "John Spain Associates",
        "owner": "Lulani Dalguise Ltd",
        "apartments": "276",
        "houses": "24",
        "student": "",
        "studio": "",
        "apt.1_bed": "105",
        "apt.2_bed": "150",
        "apt.3_bed": "21",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "1",
        "house.2_bed": "",
        "house.3_bed": "14",
        "house.4_bed": "9",
        "house.4+_bed": "",
        "other notes": "Creche 195 sqm",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7333",
        "ref": "PL06D.306949"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.158137321472168,
          53.29175841464894
        ]
      },
      "id": 22
    },
    {
      "type": "Feature",
      "properties": {
        "id": 68266,
        "url": "http://www.pleanala.ie/casenum/306569.htm",
        "la": "Dublin City Council",
        "dev_desc": "481 no. Build to Rent apartments and associated site works.",
        "abp_ref": "PL29S.306569",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2020-02-05 0:00:00",
        "scraped_datetime": "2020-06-13 14:58:07",
        "documents": "\"[{\\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/306/R306569.pdf\\\", \\\"url_hash\\\": \\\"96f4c35abf562e892f59502d0d6cbc96\\\", \\\"name\\\": \\\"Inspectors report (306/R306569.pdf, PDF format 795kB)\\\"}, {\\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/306/D306569.pdf\\\", \\\"url_hash\\\": \\\"d96642c2e38bebcfd97447bc0cbebe7e\\\", \\\"name\\\": \\\"Order (306/D306569.pdf, PDF format 190kB)\\\"}, {\\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/306/S306569.pdf\\\", \\\"url_hash\\\": \\\"85dadc6d1f1d7b9678cefd60bd9a1d4e\\\", \\\"name\\\": \\\"Direction (306/S306569.pdf, PDF format 178kB)\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Ruirside Developments Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Ruirside Developments Limited\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Susan Byrne\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Susan Byrne\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Susan Byrne\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Susan Byrne\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Grant Perm. w   Conditions\\\", \\\"date\\\": \\\"2020-05-28 00:00:00+00:00\\\"}, {\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2020-02-05 00:00:00+00:00\\\"}, {\\\"state\\\": \\\"The application is subject to an EIA procedure. Application documentation associated with\\\", \\\"date\\\": \\\"2020-02-05 00:00:00+00:00\\\"}]\"",
        "created_at": "2020-06-08 22:06:28",
        "updated_at": "2020-06-13 14:58:07",
        "file_num/website": "www.parkgatestreetshd.ie",
        "area ha": "0.82",
        "no of units": "481",
        "agent": "STEPHEN LITTLE & ASSOCIATES",
        "owner": "Ruirside Developments Ltd",
        "apartments": "481",
        "houses": "",
        "student": "",
        "studio": "66",
        "apt.1_bed": "298",
        "apt.2_bed": "117",
        "apt.3_bed": "",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Office 3698sqm\r\nCafe 444sqm\r\nRetail 214",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7334",
        "ref": "PL29S.306569"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.29301220178604,
          53.347659710399526
        ]
      },
      "id": 23
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64414,
        "url": "http://www.pleanala.ie/casenum/306225.htm",
        "la": "Dun Laoghaire-Rathdown County Council",
        "dev_desc": "468 no. residential units (16 no. houses, 452 no. apartments) and associated site works.",
        "abp_ref": "PL06D.306225",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2019-12-20 0:00:00",
        "scraped_datetime": "2020-06-27 15:16:31",
        "documents": "\"[{\\\"url_hash\\\": \\\"d2444103acbc61ae5bc08b5d8ba6eb28\\\", \\\"name\\\": \\\"Inspectors report (306/R306225.pdf, PDF format 693kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/306/R306225.pdf\\\"}, {\\\"url_hash\\\": \\\"c0ba5805a9ecc5f3a34ad2c9b07693db\\\", \\\"name\\\": \\\"Order (306/D306225.pdf, PDF format 48kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/306/D306225.pdf\\\"}, {\\\"url_hash\\\": \\\"abd0e7b84bf9d161c79f9d7bb12df085\\\", \\\"name\\\": \\\"Direction (306/S306225.pdf, PDF format 138kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/306/S306225.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Cornel Living Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Cornel Living Limited\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-04-16 00:00:00+00:00\\\", \\\"state\\\": \\\"Refuse Perm.\\\"}, {\\\"date\\\": \\\"2019-12-20 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}, {\\\"date\\\": \\\"2019-12-20 00:00:00+00:00\\\", \\\"state\\\": \\\"The application is subject to an EIA procedure. Application documentation associated with\\\"}]\"",
        "created_at": "2020-02-06 16:59:03",
        "updated_at": "2020-06-27 15:16:31",
        "file_num/website": "www.cornelscourtplanning.ie",
        "area ha": "2.14",
        "no of units": "469",
        "agent": "Brock McClure Consultants",
        "owner": "Cornel Living Limited",
        "apartments": "453",
        "houses": "16",
        "student": "",
        "studio": "41",
        "apt.1_bed": "257",
        "apt.2_bed": "136",
        "apt.3_bed": "18",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "6",
        "house.2_bed": "",
        "house.3_bed": "10",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Class 4 - Office 149 sq m\r\nClass 4 - Café/Restaurant 140 sq m\r\nClass 4 - Concierge 149 sq m\r\nClass 4 - Residential Tenant Amenity Space 458 sq m",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7310",
        "ref": "PL06D.306225"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.164950132369994,
          53.26890898873609
        ]
      },
      "id": 24
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64407,
        "url": "http://www.pleanala.ie/casenum/306182.htm",
        "la": "Fingal County Council",
        "dev_desc": "Demolition of existing structures, construction of 130 no. houses, creche and associated site works.",
        "abp_ref": "PL06F.306182",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2019-12-17 0:00:00",
        "scraped_datetime": "2020-06-27 15:16:55",
        "documents": "\"[{\\\"url_hash\\\": \\\"54db8271b2c563c8077cead5fbaa91ab\\\", \\\"name\\\": \\\"Inspectors report (306/R306182.pdf, PDF format 488kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/306/R306182.pdf\\\"}, {\\\"url_hash\\\": \\\"37816a63774466cc7137ede62b92c4b3\\\", \\\"name\\\": \\\"Order (306/D306182.pdf, PDF format 147kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/306/D306182.pdf\\\"}, {\\\"url_hash\\\": \\\"1fc441c2c27ab45b5674e1cf9a9f24eb\\\", \\\"name\\\": \\\"Direction (306/S306182.pdf, PDF format 165kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/306/S306182.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Chilldale Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Chilldale Limited\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Rolestown National School PArents Association\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Rolestown National School PArents Association\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Rolestown National School PArents Association\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Rolestown National School PArents Association\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-04-09 00:00:00+00:00\\\", \\\"state\\\": \\\"Grant Perm. w   Conditions\\\"}, {\\\"date\\\": \\\"2019-12-17 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}]\"",
        "created_at": "2020-02-06 16:58:51",
        "updated_at": "2020-06-27 15:16:55",
        "file_num/website": "www.ravensmillrowlestownshd.com",
        "area ha": "8.48",
        "no of units": "130",
        "agent": "Adrian Hill Architects ",
        "owner": "Chillidale Limited ",
        "apartments": "",
        "houses": "130",
        "student": "",
        "studio": "",
        "apt.1_bed": "",
        "apt.2_bed": "",
        "apt.3_bed": "",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "7",
        "house.3_bed": "119",
        "house.4_bed": "13",
        "house.4+_bed": "",
        "other notes": "Créche (singe storey, for 35 children, see Item 12 for full description) 256 sqm ",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7310",
        "ref": "PL06F.306182"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.295938491821289,
          53.49121166139267
        ]
      },
      "id": 25
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64406,
        "url": "http://www.pleanala.ie/casenum/306167.htm",
        "la": "Dublin City Council",
        "dev_desc": "435 no. apartments and associated site works.",
        "abp_ref": "PL29N.306167",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2019-12-16 0:00:00",
        "scraped_datetime": "2020-06-27 15:42:49",
        "documents": "\"[{\\\"url_hash\\\": \\\"788215ff7a327af51a69151e1f97e6a5\\\", \\\"name\\\": \\\"Inspectors report (306/R306167.pdf, PDF format 422kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/306/R306167.pdf\\\"}, {\\\"url_hash\\\": \\\"f38c393705e9a0bfa584981cc3be5f91\\\", \\\"name\\\": \\\"Order (306/D306167.pdf, PDF format 152kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/306/D306167.pdf\\\"}, {\\\"url_hash\\\": \\\"367ff8410be68e9043e9e505bb465d8c\\\", \\\"name\\\": \\\"Direction (306/S306167.pdf, PDF format 170kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/306/S306167.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Ballymore Property Developments Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Ballymore Property Developments Limited\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Inna Marushchenko\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Nick Grantham\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Inna Marushchenko\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Nick Grantham\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Inna Marushchenko\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Nick Grantham\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Inna Marushchenko\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Nick Grantham\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Inna Marushchenko\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Nick Grantham\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Inna Marushchenko\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Nick Grantham\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-05-12 00:00:00+00:00\\\", \\\"state\\\": \\\"Grant Perm. w   Conditions\\\"}, {\\\"date\\\": \\\"2019-12-16 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}]\"",
        "created_at": "2020-02-06 16:58:45",
        "updated_at": "2020-06-27 15:42:49",
        "file_num/website": "www.royalcanalbankphase4shd.ie",
        "area ha": "1.88",
        "no of units": "435",
        "agent": "",
        "owner": "Ballymore Property Developments Limited",
        "apartments": "",
        "houses": "",
        "student": "435",
        "studio": "",
        "apt.1_bed": "217",
        "apt.2_bed": "218",
        "apt.3_bed": "",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Employment uses 4162 sqm",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7310",
        "ref": "PL29N.306167"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.308898925781249,
          53.375450094455765
        ]
      },
      "id": 26
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64448,
        "url": "http://www.pleanala.ie/casenum/306160.htm",
        "la": "Dun Laoghaire-Rathdown County Council",
        "dev_desc": "Demolition of 'Greenmount' and 'Dun Oir', construction of 197 no. residential units (62 no. houses, 135 no. apartments) and associated site works.",
        "abp_ref": "PL06D.306160",
        "app_type": "Strategic Housing Development - Application",
        "decision": "Grant Perm. w   Conditions",
        "signed": "06/04/2020",
        "lodged": "2019-12-13 0:00:00",
        "scraped_datetime": "2020-06-27 15:16:54",
        "documents": "\"[{\\\"url_hash\\\": \\\"b3fd80d52007c21f730a9eabfce018ea\\\", \\\"name\\\": \\\"Inspectors report (306/R306160.pdf, PDF format 639kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/306/R306160.pdf\\\"}, {\\\"url_hash\\\": \\\"945c7f0727bac5ccc41a8a41f86de3ba\\\", \\\"name\\\": \\\"Order (306/D306160.pdf, PDF format 155kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/306/D306160.pdf\\\"}, {\\\"url_hash\\\": \\\"01dccba92da4818bf54a99caa8a10a60\\\", \\\"name\\\": \\\"Direction (306/S306160.pdf, PDF format 189kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/306/S306160.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Declan Taite & Anne O'Dwyer \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Declan Taite & Anne O'Dwyer\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-04-06 00:00:00+00:00\\\", \\\"state\\\": \\\"Grant Perm. w   Conditions\\\"}, {\\\"date\\\": \\\"2019-12-13 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}]\"",
        "created_at": "2020-02-06 17:00:20",
        "updated_at": "2020-06-27 15:16:54",
        "file_num/website": "www.kilternandoranplanning.com",
        "area ha": "4.52",
        "no of units": "197",
        "agent": "IMG Planning Limited",
        "owner": "Declan Taite and Anne O’Dwyer, Joint Statutory\r\nReceivers to Certain Assets of Michael Doran and\r\nMartin Doran",
        "apartments": "",
        "houses": "62",
        "student": "135",
        "studio": "",
        "apt.1_bed": "65",
        "apt.2_bed": "50",
        "apt.3_bed": "10",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "25",
        "house.4_bed": "25",
        "house.4+_bed": "12",
        "other notes": "Crèche (c. 50 spaces) 275 ",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7310",
        "ref": "PL06D.306160"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.194636821746826,
          53.24151464177184
        ]
      },
      "id": 27
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64463,
        "url": "http://www.pleanala.ie/casenum/306075.htm",
        "la": "Fingal County Council",
        "dev_desc": "331 no. apartments a creche and all associated site works.",
        "abp_ref": "PL06F.306075",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2019-12-04 0:00:00",
        "scraped_datetime": "2020-06-27 15:17:56",
        "documents": "\"[{\\\"url_hash\\\": \\\"05fa59550ec3f17fcf799c3acd0b4ea5\\\", \\\"name\\\": \\\"Inspectors report (306/R306075.pdf, PDF format 552kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/306/R306075.pdf\\\"}, {\\\"url_hash\\\": \\\"ac331f784c08fe7a9885a8227e76d528\\\", \\\"name\\\": \\\"Order (306/D306075.pdf, PDF format 160kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/306/D306075.pdf\\\"}, {\\\"url_hash\\\": \\\"63738dfa543f7b8e7b33ce3129d21f7a\\\", \\\"name\\\": \\\"Direction (306/S306075.pdf, PDF format 207kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/306/S306075.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Cosgrave Developments \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Cosgrave Developments\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-03-24 00:00:00+00:00\\\", \\\"state\\\": \\\"Grant Perm. w   Conditions\\\"}, {\\\"date\\\": \\\"2019-12-04 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}, {\\\"date\\\": \\\"2019-12-04 00:00:00+00:00\\\", \\\"state\\\": \\\"The application is subject to an EIA procedure. Application documentation associated with\\\"}]\"",
        "created_at": "2020-02-06 17:01:05",
        "updated_at": "2020-06-27 15:17:56",
        "file_num/website": "www.blackwoodsquareplanning.com",
        "area ha": "2.1",
        "no of units": "331",
        "agent": "RPS Group Ltd.",
        "owner": "Cosgrave Developments",
        "apartments": "331",
        "houses": "",
        "student": "",
        "studio": "6",
        "apt.1_bed": "292",
        "apt.2_bed": "33",
        "apt.3_bed": "",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Childcare Facility 224m2\r\nCommercial units (5 no.) 939 m2",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7310",
        "ref": "PL06F.306075"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.259342432022095,
          53.40465830509355
        ]
      },
      "id": 28
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64462,
        "url": "http://www.pleanala.ie/casenum/306074.htm",
        "la": "Fingal County Council",
        "dev_desc": "211 no. apartments and all associated site works.",
        "abp_ref": "PL06F.306074",
        "app_type": "Strategic Housing Development - Application",
        "decision": "Grant Perm. w   Conditions",
        "signed": "30/03/2020",
        "lodged": "2019-12-02 0:00:00",
        "scraped_datetime": "2020-06-27 15:17:13",
        "documents": "\"[{\\\"url_hash\\\": \\\"cf4d48d3e826ad4710fbd48a3129ff7c\\\", \\\"name\\\": \\\"Inspectors report (306/R306074.pdf, PDF format 570kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/306/R306074.pdf\\\"}, {\\\"url_hash\\\": \\\"45807248f3167532f535a8b911c98e80\\\", \\\"name\\\": \\\"Order (306/D306074.pdf, PDF format 150kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/306/D306074.pdf\\\"}, {\\\"url_hash\\\": \\\"a617276fffb6a1da5664ac91dbb0fdd0\\\", \\\"name\\\": \\\"Direction (306/S306074.pdf, PDF format 192kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/306/S306074.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Kimpton Vale Ltd \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Kimpton Vale Ltd\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-03-30 00:00:00+00:00\\\", \\\"state\\\": \\\"Grant Perm. w   Conditions\\\"}, {\\\"date\\\": \\\"2019-12-02 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}]\"",
        "created_at": "2020-02-06 17:01:04",
        "updated_at": "2020-06-27 15:17:13",
        "file_num/website": "www.windmillshd.ie",
        "area ha": "3.73",
        "no of units": "211",
        "agent": "John Spain Associates",
        "owner": "Kimpton Vale Limited ",
        "apartments": "211",
        "houses": "",
        "student": "",
        "studio": "10",
        "apt.1_bed": "68",
        "apt.2_bed": "133",
        "apt.3_bed": "",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Ancillary- Resident’s Community Facility 211",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7310",
        "ref": "PL06F.306074"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.4001476764678955,
          53.379181416047935
        ]
      },
      "id": 29
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64497,
        "url": "http://www.pleanala.ie/casenum/305980.htm",
        "la": "Fingal County Council",
        "dev_desc": "192 no. apartments, creche and all associated site works.",
        "abp_ref": "PL06F.305980",
        "app_type": "Strategic Housing Development - Application",
        "decision": "Grant Perm. w   Conditions",
        "signed": "16/03/2020",
        "lodged": "2019-11-20 0:00:00",
        "scraped_datetime": "2020-06-27 15:19:13",
        "documents": "\"[{\\\"url_hash\\\": \\\"8f4bce7420e3afe77a01737593703394\\\", \\\"name\\\": \\\"Inspectors report (305/R305980.pdf, PDF format 567kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/305/R305980.pdf\\\"}, {\\\"url_hash\\\": \\\"9274c411b63ad1775781cc513d4cd79e\\\", \\\"name\\\": \\\"Order (305/D305980.pdf, PDF format 147kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/305/D305980.pdf\\\"}, {\\\"url_hash\\\": \\\"6319bd445511bf49ea8f172ea26e4a4a\\\", \\\"name\\\": \\\"Direction (305/S305980.pdf, PDF format 189kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/305/S305980.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Glenveagh Homes Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Glenveagh Homes Limited\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-03-16 00:00:00+00:00\\\", \\\"state\\\": \\\"Grant Perm. w   Conditions\\\"}, {\\\"date\\\": \\\"2019-11-20 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}]\"",
        "created_at": "2020-02-06 17:03:07",
        "updated_at": "2020-06-27 15:19:13",
        "file_num/website": "www.carpenterstownroadshd.ie",
        "area ha": "1.77",
        "no of units": "192",
        "agent": "John Spain Associates",
        "owner": "Glenveagh Homes Limited",
        "apartments": "192",
        "houses": "",
        "student": "",
        "studio": "",
        "apt.1_bed": "67",
        "apt.2_bed": "104",
        "apt.3_bed": "21",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Creche 174 sq. m\r\nGym 114 sq. m\r\nResidential Amenity Room 40 sq. m\r\nSecurity Office 22 sq. m",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7310",
        "ref": "PL06F.305980"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.3812971115112305,
          53.37109753958082
        ]
      },
      "id": 30
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64496,
        "url": "http://www.pleanala.ie/casenum/305979.htm",
        "la": "Dublin City Council",
        "dev_desc": "485 no. residential units (484 no. apartments and 1 no. house), creche and all associated site works.",
        "abp_ref": "PL29N.305979",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2019-11-19 0:00:00",
        "scraped_datetime": "2020-06-27 15:19:12",
        "documents": "\"[{\\\"url_hash\\\": \\\"bf50d95c8900430ae0a6ba468b03b5b3\\\", \\\"name\\\": \\\"Inspectors report (305/R305979.pdf, PDF format 482kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/305/R305979.pdf\\\"}, {\\\"url_hash\\\": \\\"f046de4b5ee75b332325d2c1e94841b3\\\", \\\"name\\\": \\\"Order (305/D305979.pdf, PDF format 154kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/305/D305979.pdf\\\"}, {\\\"url_hash\\\": \\\"927d5ea940215e2417f730ab27d1f2f1\\\", \\\"name\\\": \\\"Direction (305/S305979.pdf, PDF format 188kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/305/S305979.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Seven Cabra Real Estate Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Seven Cabra Real Estate Limited\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-03-18 00:00:00+00:00\\\", \\\"state\\\": \\\"Grant Perm. w   Conditions\\\"}, {\\\"date\\\": \\\"2019-11-19 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}]\"",
        "created_at": "2020-02-06 17:03:07",
        "updated_at": "2020-06-27 15:19:12",
        "file_num/website": "www.hamiltongardensshd.ie",
        "area ha": "3.89",
        "no of units": "485",
        "agent": "John Spain Associates",
        "owner": "Seven Cabra Real Estate Limited",
        "apartments": "484",
        "houses": "1",
        "student": "",
        "studio": "33",
        "apt.1_bed": "137",
        "apt.2_bed": "271",
        "apt.3_bed": "43",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "1",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Childcare facilities (70-117* no. of childcare spaces)\r\n*insert no. of childcare spaces\r\n351.9 sq.m.\r\nCafé / Restaurant/ Shop 350.6 sq.m.\r\nConvenience Supermarket including ancillary off-licence 1,627 sq.m.\r\nGym 617.9 sq.m. ",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7311",
        "ref": "PL29N.305979"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.292140483856201,
          53.36468951345937
        ]
      },
      "id": 31
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64490,
        "url": "http://www.pleanala.ie/casenum/305940.htm",
        "la": "Dun Laoghaire-Rathdown County Council",
        "dev_desc": "Demolition of existing structures on site and construction of 564 no. build to rent apartments, creche and associated site works.",
        "abp_ref": "PL06D.305940",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2019-11-19 0:00:00",
        "scraped_datetime": "2020-06-27 15:20:19",
        "documents": "\"[{\\\"url_hash\\\": \\\"7fb85616965418a6d047f9478f9d2f51\\\", \\\"name\\\": \\\"Inspectors report (305/R305940.pdf, PDF format 770kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/305/R305940.pdf\\\"}, {\\\"url_hash\\\": \\\"5f193f5f100068c8fbada949327fb976\\\", \\\"name\\\": \\\"Order (305/D305940.pdf, PDF format 174kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/305/D305940.pdf\\\"}, {\\\"url_hash\\\": \\\"c6387eaa0b465ca55513115a1584f62a\\\", \\\"name\\\": \\\"Direction (305/S305940.pdf, PDF format 208kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/305/S305940.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Sandyford GP Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Sandyford GP Limited\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-03-12 00:00:00+00:00\\\", \\\"state\\\": \\\"Grant Perm. w   Conditions\\\"}, {\\\"date\\\": \\\"2019-11-19 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}, {\\\"date\\\": \\\"2019-11-19 00:00:00+00:00\\\", \\\"state\\\": \\\"The application is subject to an EIA procedure. Application documentation associated with\\\"}]\"",
        "created_at": "2020-02-06 17:02:51",
        "updated_at": "2020-06-27 15:20:19",
        "file_num/website": "www.sandyfordcentralshd.ie",
        "area ha": "1.56",
        "no of units": "564",
        "agent": "Thornton O'Connor",
        "owner": "Sandyford GP Limited",
        "apartments": "564",
        "houses": "",
        "student": "",
        "studio": "45",
        "apt.1_bed": "205",
        "apt.2_bed": "295",
        "apt.3_bed": "18",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "crèche of 354 sq. metres.\r\nCafé of 141 sq. metres",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7311",
        "ref": "PL06D.305940"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.212468147277831,
          53.278814900201795
        ]
      },
      "id": 32
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64491,
        "url": "http://www.pleanala.ie/casenum/305943.htm",
        "la": "Dublin City Council",
        "dev_desc": "Demolition of all existing structures on site, construction of 331 no. build to rent apartments, childcare facility and associated site works.",
        "abp_ref": "PL29N.305943",
        "app_type": "Strategic Housing Development - Application",
        "decision": "Grant Perm. w   Conditions",
        "signed": "18/03/2020",
        "lodged": "2019-11-18 0:00:00",
        "scraped_datetime": "2020-06-27 15:19:09",
        "documents": "\"[{\\\"url_hash\\\": \\\"d6b99432e77daf884b03b9c3c4cff00c\\\", \\\"name\\\": \\\"Inspectors report (305/R305943.pdf, PDF format 917kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/305/R305943.pdf\\\"}, {\\\"url_hash\\\": \\\"f72e96b298f5817097c136cf3ec38607\\\", \\\"name\\\": \\\"Order (305/D305943.pdf, PDF format 150kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/305/D305943.pdf\\\"}, {\\\"url_hash\\\": \\\"730b111369eb128d019a641c6906f0a8\\\", \\\"name\\\": \\\"Direction (305/S305943.pdf, PDF format 158kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/305/S305943.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Claregrove Developments Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Claregrove Developments Limited\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-03-18 00:00:00+00:00\\\", \\\"state\\\": \\\"Grant Perm. w   Conditions\\\"}, {\\\"date\\\": \\\"2019-11-18 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}]\"",
        "created_at": "2020-02-06 17:02:55",
        "updated_at": "2020-06-27 15:19:09",
        "file_num/website": "www.malahideroadshd.ie",
        "area ha": "1.22",
        "no of units": "331",
        "agent": "John Spain Associates",
        "owner": "Claregrove Developments Limited ",
        "apartments": "",
        "houses": "",
        "student": "",
        "studio": "",
        "apt.1_bed": "82",
        "apt.2_bed": "247",
        "apt.3_bed": "2",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Other- Commercial Units and Childcare Facility 659 sq.m",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7311",
        "ref": "PL29N.305943"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.183532476425171,
          53.399771405096764
        ]
      },
      "id": 33
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64506,
        "url": "http://www.pleanala.ie/casenum/305878.htm",
        "la": "South Dublin County Council",
        "dev_desc": "Demolition of existing structures on site, construction of 590 no. residential units (480 no. Build to Rent units, 110 no. Build to Sell units), creche and associated site works.",
        "abp_ref": "PL06S.305878",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2019-11-11 0:00:00",
        "scraped_datetime": "2020-06-27 15:20:18",
        "documents": "\"[{\\\"url_hash\\\": \\\"d2be1a6b082af4aef6fd0265b1cb41d9\\\", \\\"name\\\": \\\"Inspectors report (305/R305878.pdf, PDF format 573kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/305/R305878.pdf\\\"}, {\\\"url_hash\\\": \\\"0e91d2276287cf67f3b5dcd728efc235\\\", \\\"name\\\": \\\"Order (305/D305878.pdf, PDF format 174kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/305/D305878.pdf\\\"}, {\\\"url_hash\\\": \\\"b2b95cc4c405ff50772c38bd00fde723\\\", \\\"name\\\": \\\"Direction (305/S305878.pdf, PDF format 190kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/305/S305878.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Ardstone Homes Ltd \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Ardstone Homes Ltd\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-03-09 00:00:00+00:00\\\", \\\"state\\\": \\\"Grant Perm. w   Conditions\\\"}, {\\\"date\\\": \\\"2019-11-11 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}, {\\\"date\\\": \\\"2019-11-11 00:00:00+00:00\\\", \\\"state\\\": \\\"The application is subject to an EIA procedure. Application documentation associated with\\\"}]\"",
        "created_at": "2020-02-06 17:03:47",
        "updated_at": "2020-06-27 15:20:18",
        "file_num/website": "www.scholarstownplanning.ie",
        "area ha": "5.35",
        "no of units": "590",
        "agent": "Thornton O'Connor",
        "owner": "Ardstone Homes Limited",
        "apartments": "",
        "houses": "",
        "student": "",
        "studio": "",
        "apt.1_bed": "246",
        "apt.2_bed": "289",
        "apt.3_bed": "55",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Créche 438 sq m\r\n2 No. Café/Restaurant units 616.5 sq m\r\n2 No. Retail units 328.5 sq m",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7311",
        "ref": "PL06S.305878"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.313877105712891,
          53.279841288264535
        ]
      },
      "id": 34
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64513,
        "url": "http://www.pleanala.ie/casenum/305857.htm",
        "la": "South Dublin County Council",
        "dev_desc": "252 no. residential units (5 no. houses, 247 no. apartments), creche and associated site works.",
        "abp_ref": "PL06S.305857",
        "app_type": "Strategic Housing Development - Application",
        "decision": "Grant Perm. w   Conditions",
        "signed": "06/03/2020",
        "lodged": "2019-11-07 0:00:00",
        "scraped_datetime": "2020-06-27 15:21:05",
        "documents": "\"[{\\\"url_hash\\\": \\\"815a6fa288435b65e0c7e5b22cdaf8f9\\\", \\\"name\\\": \\\"Inspectors report (305/R305857.pdf, PDF format 314kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/305/R305857.pdf\\\"}, {\\\"url_hash\\\": \\\"64edc629f7d91de07031fc2264481a52\\\", \\\"name\\\": \\\"Order (305/D305857.pdf, PDF format 148kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/305/D305857.pdf\\\"}, {\\\"url_hash\\\": \\\"a1c82ab79834f10794ede3cf70be533c\\\", \\\"name\\\": \\\"Direction (305/S305857.pdf, PDF format 169kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/305/S305857.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"St. Edmunds Phase 3 Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"St. Edmunds Phase 3 Limited\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-03-06 00:00:00+00:00\\\", \\\"state\\\": \\\"Grant Perm. w   Conditions\\\"}, {\\\"date\\\": \\\"2019-11-07 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}]\"",
        "created_at": "2020-02-06 17:04:43",
        "updated_at": "2020-06-27 15:21:05",
        "file_num/website": "www.stedmundsphase3shd.ie",
        "area ha": "2.6",
        "no of units": "252",
        "agent": "McGill Planning Limited",
        "owner": "St. Edmunds Phase 3 Limited",
        "apartments": "247",
        "houses": "5",
        "student": "",
        "studio": "",
        "apt.1_bed": "119",
        "apt.2_bed": "125",
        "apt.3_bed": "3",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "5",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Childcare facilities (84 no. of childcare spaces) c. 430\r\nGym c.152\r\nRetail c. 269\r\nCommunity Room c. 231\r\nConcierge c. 36\r\nBin stores/ bike stores/ plant/ other ancillary c. 500",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7311",
        "ref": "PL06S.305857"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.405243873596191,
          53.354400086987546
        ]
      },
      "id": 35
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64512,
        "url": "http://www.pleanala.ie/casenum/305844.htm",
        "la": "Dun Laoghaire-Rathdown County Council",
        "dev_desc": "685 no. residential units (207 no. houses, 478 no. apartments), creche and associated site works.",
        "abp_ref": "PL06D.305844",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2019-11-06 0:00:00",
        "scraped_datetime": "2020-06-27 15:22:03",
        "documents": "\"[{\\\"url_hash\\\": \\\"5ffb89bb696db113b07160ffebe99fa8\\\", \\\"name\\\": \\\"Inspectors report (305/R305844.pdf, PDF format 414kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/305/R305844.pdf\\\"}, {\\\"url_hash\\\": \\\"7eb2efb3419ab59c02fd527968b5ab6c\\\", \\\"name\\\": \\\"Order (305/D305844.pdf, PDF format 170kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/305/D305844.pdf\\\"}, {\\\"url_hash\\\": \\\"48b33a7061c85608f3cbf3ebb762562e\\\", \\\"name\\\": \\\"Direction (305/S305844.pdf, PDF format 198kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/305/S305844.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Aeval Unlimited Company \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Aeval Unlimited Company\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-02-27 00:00:00+00:00\\\", \\\"state\\\": \\\"Grant Perm. w   Conditions\\\"}, {\\\"date\\\": \\\"2019-11-06 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}, {\\\"date\\\": \\\"2019-11-06 00:00:00+00:00\\\", \\\"state\\\": \\\"The application is subject to an EIA procedure. Application documentation associated with\\\"}]\"",
        "created_at": "2020-02-06 17:04:38",
        "updated_at": "2020-06-27 15:22:03",
        "file_num/website": "www.woodbrook1shd.com",
        "area ha": "21.9",
        "no of units": "685",
        "agent": "Stephen Little and Associates",
        "owner": "Aevel Unlimited Company",
        "apartments": "478",
        "houses": "207",
        "student": "",
        "studio": "",
        "apt.1_bed": "130",
        "apt.2_bed": "319",
        "apt.3_bed": "29",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "134",
        "house.4_bed": "48",
        "house.4+_bed": "25",
        "other notes": "Childcare 63 spaces 429 sqm",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7311",
        "ref": "PL06D.305844"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.117410659790038,
          53.21780322271204
        ]
      },
      "id": 36
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64511,
        "url": "http://www.pleanala.ie/casenum/305828.htm",
        "la": "Fingal County Council",
        "dev_desc": "Demolition of existing structures, construction of 177 no. apartments and associated site works.",
        "abp_ref": "PL06F.305828",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2019-11-04 0:00:00",
        "scraped_datetime": "2020-06-27 15:21:03",
        "documents": "\"[{\\\"url_hash\\\": \\\"cb753a925dd19190007c59b1cfd10948\\\", \\\"name\\\": \\\"Inspectors report (305/R305828.pdf, PDF format 265kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/305/R305828.pdf\\\"}, {\\\"url_hash\\\": \\\"f7141c146277dbe1c37598201ef3b690\\\", \\\"name\\\": \\\"Order (305/D305828.pdf, PDF format 148kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/305/D305828.pdf\\\"}, {\\\"url_hash\\\": \\\"ef22b22ed7532a7c1e5525edd377e416\\\", \\\"name\\\": \\\"Direction (305/S305828.pdf, PDF format 165kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/305/S305828.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Crekav Trading GP Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Crekav Trading GP Limited\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Crekav Trading GP Limited\\\"}, {\\\"_type\\\": \\\"()\\\", \\\"name\\\": \\\"Crekav Trading GP Limited\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-03-02 00:00:00+00:00\\\", \\\"state\\\": \\\"Grant Perm. w   Conditions\\\"}, {\\\"date\\\": \\\"2019-11-04 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}]\"",
        "created_at": "2020-02-06 17:04:30",
        "updated_at": "2020-06-27 15:21:03",
        "file_num/website": "www.rennieplaceshd.ie",
        "area ha": "1.55",
        "no of units": "177",
        "agent": "",
        "owner": "Crekav Trading GP Ltd. ",
        "apartments": "177",
        "houses": "",
        "student": "",
        "studio": "",
        "apt.1_bed": "44",
        "apt.2_bed": "103",
        "apt.3_bed": "30",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "\"Childcare facilities (84 no. of childcare spaces) c. 430\r\nGym c.152\r\nRetail c. 269\r\nCommunity Room c. 231\r\nConcierge c. 36\r\nBin stores/ bike stores/ plant/ other ancillary c. 500\"",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7311",
        "ref": "PL06F.305828"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.064399480819702,
          53.38704620139897
        ]
      },
      "id": 37
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64534,
        "url": "http://www.pleanala.ie/casenum/305763.htm",
        "la": "South Dublin County Council",
        "dev_desc": "Demolition of existing buildings, construction of 328 no. apartments, creche and associated site works.",
        "abp_ref": "PL06S.305763",
        "app_type": "Strategic Housing Development - Application",
        "decision": "Grant Perm. w   Conditions",
        "signed": "20/02/2020",
        "lodged": "2019-10-25 0:00:00",
        "scraped_datetime": "2020-06-27 15:22:47",
        "documents": "\"[{\\\"url_hash\\\": \\\"a6cd3e0c843e51c679c140a860def1d2\\\", \\\"name\\\": \\\"Inspectors report (305/R305763.pdf, PDF format 344kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/305/R305763.pdf\\\"}, {\\\"url_hash\\\": \\\"af74edc0f9b9c44aa0309b15374738e9\\\", \\\"name\\\": \\\"Order (305/D305763.pdf, PDF format 150kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/305/D305763.pdf\\\"}, {\\\"url_hash\\\": \\\"452b3035079487fe9c0572f05ae5adaf\\\", \\\"name\\\": \\\"Direction (305/S305763.pdf, PDF format 179kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/305/S305763.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Power Scaffolding Supplies Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Power Scaffolding Supplies Limited\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-02-20 00:00:00+00:00\\\", \\\"state\\\": \\\"Grant Perm. w   Conditions\\\"}, {\\\"date\\\": \\\"2019-10-25 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}]\"",
        "created_at": "2020-02-06 17:06:29",
        "updated_at": "2020-06-27 15:22:47",
        "file_num/website": "www.airtonplazashd.ie",
        "area ha": "1.19",
        "no of units": "328",
        "agent": "Thornton O'Connor",
        "owner": "Power Scaffolding Supplies Limited",
        "apartments": "328",
        "houses": "",
        "student": "",
        "studio": "",
        "apt.1_bed": "93",
        "apt.2_bed": "222",
        "apt.3_bed": "13",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Class 1 / 2 Commercial/ Retail Space 354 sq m\r\nOffice 222 sq m\r\nRestaurant/ Café 313 sq m",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7311",
        "ref": "PL06S.305763"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.36782169342041,
          53.29252797485898
        ]
      },
      "id": 38
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64532,
        "url": "http://www.pleanala.ie/casenum/305728.htm",
        "la": "Dublin City Council",
        "dev_desc": "Alterations to previously permitted development Reg.Ref:2186/15 (PL29S.245164) increasing the total number of units from 220 no. units to 248 no. units.",
        "abp_ref": "PL29S.305728",
        "app_type": "Strategic Housing Development - Application",
        "decision": "Grant Perm. w   Conditions",
        "signed": "14/02/2020",
        "lodged": "2019-10-21 0:00:00",
        "scraped_datetime": "2020-06-27 15:23:41",
        "documents": "\"[{\\\"url_hash\\\": \\\"f61c2c88b8264a906b6936c3ade8885f\\\", \\\"name\\\": \\\"Inspectors report (305/R305728.pdf, PDF format 283kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/305/R305728.pdf\\\"}, {\\\"url_hash\\\": \\\"d3e70dd917d04bf9df25eca112f246e0\\\", \\\"name\\\": \\\"Order (305/D305728.pdf, PDF format 125kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/305/D305728.pdf\\\"}, {\\\"url_hash\\\": \\\"f6ec750983570088b09ae8a5a6c1e90c\\\", \\\"name\\\": \\\"Direction (305/S305728.pdf, PDF format 167kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/305/S305728.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"St Clares GP3 Ltd \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"St Clares GP3 Ltd\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-02-14 00:00:00+00:00\\\", \\\"state\\\": \\\"Grant Perm. w   Conditions\\\"}, {\\\"date\\\": \\\"2019-10-21 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}]\"",
        "created_at": "2020-02-06 17:06:19",
        "updated_at": "2020-06-27 15:23:41",
        "file_num/website": "www.stclaresshd.ie",
        "area ha": "1.7",
        "no of units": "197",
        "agent": "",
        "owner": "St. Clare’s GB3 Limited",
        "apartments": "195",
        "houses": "",
        "student": "",
        "studio": "",
        "apt.1_bed": "41",
        "apt.2_bed": "123",
        "apt.3_bed": "31",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Alterations to existing applicatoin",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7311",
        "ref": "PL29S.305728"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.2763047218322745,
          53.32669529308478
        ]
      },
      "id": 39
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64559,
        "url": "http://www.pleanala.ie/casenum/305725.htm",
        "la": "South Dublin County Council",
        "dev_desc": "Demolition of existing industrial buildings, construction of 245 no. Build to Rent apartments and associated site works.",
        "abp_ref": "PL06S.305725",
        "app_type": "Strategic Housing Development - Application",
        "decision": "Refuse Perm.",
        "signed": "13/02/2020",
        "lodged": "2019-10-18 0:00:00",
        "scraped_datetime": "2020-06-27 15:23:40",
        "documents": "\"[{\\\"url_hash\\\": \\\"ee720abc07bf787c33e665db5c7d9bd7\\\", \\\"name\\\": \\\"Inspectors report (305/R305725.pdf, PDF format 172kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/305/R305725.pdf\\\"}, {\\\"url_hash\\\": \\\"d5a950fde762589e6ae568f14d534ee8\\\", \\\"name\\\": \\\"Order (305/D305725.pdf, PDF format 101kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/305/D305725.pdf\\\"}, {\\\"url_hash\\\": \\\"82ec6ebc53878910c6cf8579d3f07941\\\", \\\"name\\\": \\\"Direction (305/S305725.pdf, PDF format 119kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/305/S305725.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Steelworks Property Developments Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Steelworks Property Developments Limited\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-02-13 00:00:00+00:00\\\", \\\"state\\\": \\\"Refuse Perm.\\\"}, {\\\"date\\\": \\\"2019-10-18 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}]\"",
        "created_at": "2020-02-06 17:07:39",
        "updated_at": "2020-06-27 15:23:40",
        "file_num/website": "www.cookstowncrossshd1.com",
        "area ha": "0.71",
        "no of units": "245",
        "agent": "Hughes Planning and Development\r\nConsultants",
        "owner": "Steelworks Property Developments Limited",
        "apartments": "245",
        "houses": "",
        "student": "",
        "studio": "69",
        "apt.1_bed": "56",
        "apt.2_bed": "120",
        "apt.3_bed": "",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Commercial Space 256",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7311",
        "ref": "PL06S.305725"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.374720335006714,
          53.29164939249808
        ]
      },
      "id": 40
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64558,
        "url": "http://www.pleanala.ie/casenum/305713.htm",
        "la": "Fingal County Council",
        "dev_desc": "359 no. residential units ( 223 no. houses and 136 no. apartments), creche and associated site works.",
        "abp_ref": "PL06F.305713",
        "app_type": "Strategic Housing Development - Application",
        "decision": "Refuse Perm.",
        "signed": "13/02/2020",
        "lodged": "2019-10-17 0:00:00",
        "scraped_datetime": "2020-06-27 15:23:40",
        "documents": "\"[{\\\"url_hash\\\": \\\"53f990a58a52a2d27e10f4a3605d7ed6\\\", \\\"name\\\": \\\"Inspectors report (305/R305713.pdf, PDF format 328kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/305/R305713.pdf\\\"}, {\\\"url_hash\\\": \\\"642ae9801e986a6e4e8de6475efff572\\\", \\\"name\\\": \\\"Order (305/D305713.pdf, PDF format 96kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/305/D305713.pdf\\\"}, {\\\"url_hash\\\": \\\"ee891600f8d92c2a814db8117f20d7b0\\\", \\\"name\\\": \\\"Direction (305/S305713.pdf, PDF format 114kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/305/S305713.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Dwyer Nolan Developments Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Dwyer Nolan Developments Limited\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-02-13 00:00:00+00:00\\\", \\\"state\\\": \\\"Refuse Perm.\\\"}, {\\\"date\\\": \\\"2019-10-17 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}]\"",
        "created_at": "2020-02-06 17:07:38",
        "updated_at": "2020-06-27 15:23:40",
        "file_num/website": "www.luskreglesshd.ie",
        "area ha": "8.44",
        "no of units": "359",
        "agent": "Delphi Design",
        "owner": "Dwyer Nolan Developments Ltd",
        "apartments": "136",
        "houses": "223",
        "student": "",
        "studio": "",
        "apt.1_bed": "34",
        "apt.2_bed": "90",
        "apt.3_bed": "12",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "42",
        "house.3_bed": "100",
        "house.4_bed": "41",
        "house.4+_bed": "",
        "other notes": "Childcare facilities (95 no. childcare spaces) 484.6m",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7311",
        "ref": "PL06F.305713"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.18281364440918,
          53.52754134116769
        ]
      },
      "id": 41
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64552,
        "url": "http://www.pleanala.ie/casenum/305680.htm",
        "la": "Dublin City Council",
        "dev_desc": "Construction of 657 no. apartments, creche and associated site works.",
        "abp_ref": "PL29N.305680",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2019-10-16 0:00:00",
        "scraped_datetime": "2020-06-27 15:23:38",
        "documents": "\"[{\\\"url_hash\\\": \\\"e21ae7d09b34e6995f08a4740b2932fb\\\", \\\"name\\\": \\\"Inspectors report (305/R305680.pdf, PDF format 1248kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/305/R305680.pdf\\\"}, {\\\"url_hash\\\": \\\"b56ae134061d2652d2f07a6ed0c2cd17\\\", \\\"name\\\": \\\"Order 1  (305/D305680.pdf, PDF format 179kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/305/D305680.pdf\\\"}, {\\\"url_hash\\\": \\\"34a8497636e8b9304d69b17e908d0b92\\\", \\\"name\\\": \\\"Order 2  (305/D305680A.pdf, PDF format 79kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/305/D305680A.pdf\\\"}, {\\\"url_hash\\\": \\\"63b47ab597650fcfb6af4372e678af94\\\", \\\"name\\\": \\\"Direction 1  (305/S305680.pdf, PDF format 252kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/305/S305680.pdf\\\"}, {\\\"url_hash\\\": \\\"a6b0b8c32a9307742519ef5b1cac69be\\\", \\\"name\\\": \\\"Direction 2  (305/S305680A.pdf, PDF format 91kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/305/S305680A.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Crekav Trading GP Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Crekav Trading GP Limited\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-02-13 00:00:00+00:00\\\", \\\"state\\\": \\\"Grant Perm. w   Conditions\\\"}, {\\\"date\\\": \\\"2019-10-16 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}, {\\\"date\\\": \\\"2019-10-16 00:00:00+00:00\\\", \\\"state\\\": \\\"The application is subject to an EIA procedure. Application documentation associated with\\\"}]\"",
        "created_at": "2020-02-06 17:07:27",
        "updated_at": "2020-06-27 15:23:38",
        "file_num/website": "www.stpaulsshd2.ie",
        "area ha": "6.4",
        "no of units": "657",
        "agent": "Brady Shipman Martin",
        "owner": "Crekav Trading GP Ltd. ",
        "apartments": "657",
        "houses": "",
        "student": "",
        "studio": "",
        "apt.1_bed": "224",
        "apt.2_bed": "378",
        "apt.3_bed": "55",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Creche 612\r\nResidenial Amenity Spaces 881 sqm",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7311",
        "ref": "PL29N.305680"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.189486980438232,
          53.37324186852435
        ]
      },
      "id": 42
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64575,
        "url": "http://www.pleanala.ie/casenum/305623.htm",
        "la": "Dublin City Council",
        "dev_desc": "282 no. apartments and associated site works.",
        "abp_ref": "PL29N.305623",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2019-10-11 0:00:00",
        "scraped_datetime": "2020-06-27 15:24:35",
        "documents": "\"[{\\\"url_hash\\\": \\\"fd7ca395c4862a094e4106369c65ad84\\\", \\\"name\\\": \\\"Inspectors report (305/R305623.pdf, PDF format 334kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/305/R305623.pdf\\\"}, {\\\"url_hash\\\": \\\"e5badfe30de937b2d034f90d6b2ff048\\\", \\\"name\\\": \\\"Order (305/D305623.pdf, PDF format 149kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/305/D305623.pdf\\\"}, {\\\"url_hash\\\": \\\"bafca8a787ea8aa91ab47d0ba083b46e\\\", \\\"name\\\": \\\"Direction (305/S305623.pdf, PDF format 175kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/305/S305623.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Cairn Homes Properties Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Cairn Homes Properties Limited\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-02-06 00:00:00+00:00\\\", \\\"state\\\": \\\"Grant Perm. w   Conditions\\\"}, {\\\"date\\\": \\\"2019-10-11 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}, {\\\"date\\\": \\\"2019-10-11 00:00:00+00:00\\\", \\\"state\\\": \\\"The application is subject to an EIA procedure. Application documentation associated with\\\"}]\"",
        "created_at": "2020-02-06 17:08:42",
        "updated_at": "2020-06-27 15:24:35",
        "file_num/website": "www.parksideblvdshdplanning.com",
        "area ha": "3.17",
        "no of units": "282",
        "agent": "McGill Planning Limited",
        "owner": "Cairn Homes Properties Limited ",
        "apartments": "282",
        "houses": "",
        "student": "",
        "studio": "",
        "apt.1_bed": "94",
        "apt.2_bed": "175",
        "apt.3_bed": "13",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Concierge, media suite, gymnasium 530 Bin stores, bike stores, plant rooms 1159.5",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7310",
        "ref": "PL29N.305623"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.16581916809082,
          53.40841904486014
        ]
      },
      "id": 43
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64237,
        "url": "http://www.pleanala.ie/casenum/305619.htm",
        "la": "Fingal County Council",
        "dev_desc": "153 no. residential units (113 no. houses and 40 no. apartments), 3 no. retail units, cafe, restaurant, medical unit and associated site works.",
        "abp_ref": "PL06F.305619",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2019-10-11 0:00:00",
        "scraped_datetime": "2020-06-27 15:25:28",
        "documents": "\"[{\\\"url_hash\\\": \\\"b9d002cd444f9fe1f5009d55ed143d4f\\\", \\\"name\\\": \\\"Inspectors report (305/R305619.pdf, PDF format 340kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/305/R305619.pdf\\\"}, {\\\"url_hash\\\": \\\"892c019cf88ded0930309f0efca73015\\\", \\\"name\\\": \\\"Order (305/D305619.pdf, PDF format 156kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/305/D305619.pdf\\\"}, {\\\"url_hash\\\": \\\"2b90c729620002dd9e3156007899d0b4\\\", \\\"name\\\": \\\"Direction (305/S305619.pdf, PDF format 175kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/305/S305619.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"St. Marnock's II Designated Activity Company \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"St. Marnock's II Designated Activity Company\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-01-30 00:00:00+00:00\\\", \\\"state\\\": \\\"Grant Perm. w   Conditions\\\"}, {\\\"date\\\": \\\"2019-10-11 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}]\"",
        "created_at": "2020-02-06 13:56:20",
        "updated_at": "2020-06-27 15:25:28",
        "file_num/website": "www.portmarnocksouthphase1c.com",
        "area ha": "4.59",
        "no of units": "153",
        "agent": "",
        "owner": "St. Marnock’s II Designated Activity\r\nCompany",
        "apartments": "40",
        "houses": "113",
        "student": "",
        "studio": "",
        "apt.1_bed": "",
        "apt.2_bed": "26",
        "apt.3_bed": "14",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "78",
        "house.4_bed": "35",
        "house.4+_bed": "",
        "other notes": "retail / café /\r\nrestaurant units (c. 440 sq. m gross floor area overall)\r\nmedica 92sqm",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7311",
        "ref": "PL06F.305619"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.148159503936767,
          53.416169724925055
        ]
      },
      "id": 44
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64570,
        "url": "http://www.pleanala.ie/casenum/305563.htm",
        "la": "South Dublin County Council",
        "dev_desc": "488 no. apartments, creche and associated site works.",
        "abp_ref": "PL06S.305563",
        "app_type": "Strategic Housing Development - Application",
        "decision": "Grant Perm. w   Conditions",
        "signed": "03/02/2020",
        "lodged": "2019-10-07 0:00:00",
        "scraped_datetime": "2020-06-27 15:24:34",
        "documents": "\"[{\\\"url_hash\\\": \\\"0fc7199fde0b99bafede779920633e77\\\", \\\"name\\\": \\\"Inspectors report (305/R305563.pdf, PDF format 245kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/305/R305563.pdf\\\"}, {\\\"url_hash\\\": \\\"1483d81950ff2119b094245ecdbc6e0b\\\", \\\"name\\\": \\\"Order (305/D305563.pdf, PDF format 143kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/305/D305563.pdf\\\"}, {\\\"url_hash\\\": \\\"d480f5e7da3242dc1fd37dc4dc3ea520\\\", \\\"name\\\": \\\"Direction (305/S305563.pdf, PDF format 154kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/305/S305563.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Greenacre Residential DAC \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Greenacre Residential DAC\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-02-03 00:00:00+00:00\\\", \\\"state\\\": \\\"Grant Perm. w   Conditions\\\"}, {\\\"date\\\": \\\"2019-10-07 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}]\"",
        "created_at": "2020-02-06 17:08:20",
        "updated_at": "2020-06-27 15:24:34",
        "file_num/website": "www.fortunestownshd2.com",
        "area ha": "4.2",
        "no of units": "488",
        "agent": "BMA Planning",
        "owner": "Greenacre Residential DAC",
        "apartments": "488",
        "houses": "",
        "student": "",
        "studio": "",
        "apt.1_bed": "118",
        "apt.2_bed": "327",
        "apt.3_bed": "43",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Childcare facilities 431sq.m (c.100 to\r\n110 childcare spaces)\r\nRetail/ commercial 1180\r\nCafé/ bar/ restaurant 188\r\nCommunity Space 186",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7312",
        "ref": "PL06S.305563"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.435971260070801,
          53.285101140221585
        ]
      },
      "id": 45
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64251,
        "url": "http://www.pleanala.ie/casenum/305556.htm",
        "la": "South Dublin County Council",
        "dev_desc": "290 no. apartments, creche and associated site works.",
        "abp_ref": "PL06S.305556",
        "app_type": "Strategic Housing Development - Application",
        "decision": "Grant Perm. w   Conditions",
        "signed": "20/01/2020",
        "lodged": "2019-10-04 0:00:00",
        "scraped_datetime": "2020-06-27 15:26:15",
        "documents": "\"[{\\\"url_hash\\\": \\\"03e77e3e2d64efe43438efdb8f2259b6\\\", \\\"name\\\": \\\"Inspectors report (305/R305556.pdf, PDF format 394kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/305/R305556.pdf\\\"}, {\\\"url_hash\\\": \\\"ac657630f05ef2205a828c8a632ffdde\\\", \\\"name\\\": \\\"Order (305/D305556.pdf, PDF format 160kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/305/D305556.pdf\\\"}, {\\\"url_hash\\\": \\\"f79f4a8e4ef9cb4780cbe14e452b1632\\\", \\\"name\\\": \\\"Direction (305/S305556.pdf, PDF format 169kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/305/S305556.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"OBSF Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"OBSF Limited\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-01-20 00:00:00+00:00\\\", \\\"state\\\": \\\"Grant Perm. w   Conditions\\\"}, {\\\"date\\\": \\\"2019-10-04 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}]\"",
        "created_at": "2020-02-06 13:57:03",
        "updated_at": "2020-06-27 15:26:15",
        "file_num/website": "www.citywestdriveshd.com",
        "area ha": "2.9",
        "no of units": "290",
        "agent": "Tom Phillips + Associates",
        "owner": "OBSF(I) Limite",
        "apartments": "290",
        "houses": "",
        "student": "",
        "studio": "",
        "apt.1_bed": "106",
        "apt.2_bed": "144",
        "apt.3_bed": "40",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Childcare facility (71 no. of childcare spaces) 265\r\n4 no. Retail Units 284.6\r\n2 no. Café / Restaurant Units 205.8",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7313",
        "ref": "PL06S.305556"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.42275333404541,
          53.28356173836786
        ]
      },
      "id": 46
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64236,
        "url": "http://www.pleanala.ie/casenum/305538.htm",
        "la": "Dublin City Council",
        "dev_desc": "129 no. apartments and associated site works.",
        "abp_ref": "PL29N.305538",
        "app_type": "Strategic Housing Development - Application",
        "decision": "Grant Perm. w   Conditions",
        "signed": "27/01/2020",
        "lodged": "2019-10-02 0:00:00",
        "scraped_datetime": "2020-06-27 15:25:26",
        "documents": "\"[{\\\"url_hash\\\": \\\"3bd1ce23439cac89643bdbc5f63f21af\\\", \\\"name\\\": \\\"Inspectors report (305/R305538.pdf, PDF format 350kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/reports/305/R305538.pdf\\\"}, {\\\"url_hash\\\": \\\"1797e556c16ce05689527687ac286aa4\\\", \\\"name\\\": \\\"Order (305/D305538.pdf, PDF format 146kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/orders/305/D305538.pdf\\\"}, {\\\"url_hash\\\": \\\"999844715259ed470da9997254c27c67\\\", \\\"name\\\": \\\"Direction (305/S305538.pdf, PDF format 213kB)\\\", \\\"url\\\": \\\"http://www.pleanala.ie/documents/directions/305/S305538.pdf\\\"}]\"",
        "parties": "\"[{\\\"_type\\\": \\\"Applicant\\\", \\\"name\\\": \\\"Dwyer Nolan Developments Limited \\\"}, {\\\"_type\\\": \\\"(Applicant)\\\", \\\"name\\\": \\\"Dwyer Nolan Developments Limited\\\"}]\"",
        "history": "\"[{\\\"date\\\": \\\"2020-01-27 00:00:00+00:00\\\", \\\"state\\\": \\\"Grant Perm. w   Conditions\\\"}, {\\\"date\\\": \\\"2019-10-02 00:00:00+00:00\\\", \\\"state\\\": \\\"Lodged\\\"}]\"",
        "created_at": "2020-02-06 13:56:18",
        "updated_at": "2020-06-27 15:25:26",
        "file_num/website": "www.hamptonwood.ie",
        "area ha": "0.75",
        "no of units": "129",
        "agent": "SBA Architects",
        "owner": "Dwyer Nolan Developments Limited",
        "apartments": "129",
        "houses": "",
        "student": "",
        "studio": "",
        "apt.1_bed": "55",
        "apt.2_bed": "65",
        "apt.3_bed": "9",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Coffee Shop 300",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7314",
        "ref": "PL29N.305538"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.283761262893677,
          53.40548339381624
        ]
      },
      "id": 47
    },
    {
      "type": "Feature",
      "properties": {
        "id": 64514,
        "url": "http://www.pleanala.ie/casenum/305859.htm",
        "la": "Dun Laoghaire-Rathdown County Council",
        "dev_desc": "Demolition of 'Benoni' and extant single storage buildings, construction of 234 no. apartments, creche and associated site works.",
        "abp_ref": "PL06D.305859",
        "app_type": "Strategic Housing Development - Application",
        "decision": "",
        "signed": "",
        "lodged": "2019-07-11 0:00:00",
        "scraped_datetime": "2020-02-06 17:04:45",
        "documents": "\"[]\"",
        "parties": "\"[{\\\"name\\\": \\\"Atlas GP Limited \\\", \\\"_type\\\": \\\"Applicant\\\"}, {\\\"name\\\": \\\"Atlas GP Limited\\\", \\\"_type\\\": \\\"(Applicant)\\\"}]\"",
        "history": "\"[{\\\"state\\\": \\\"Lodged\\\", \\\"date\\\": \\\"2019-07-11 00:00:00\\\"}]\"",
        "created_at": "2020-02-06 17:04:45",
        "updated_at": "",
        "file_num/website": "www.brennanstownroadshd2.ie",
        "area ha": "2.3",
        "no of units": "234",
        "agent": "Brock McClure Planning",
        "owner": "Atlas GP Limited",
        "apartments": "234",
        "houses": "",
        "student": "",
        "studio": "",
        "apt.1_bed": "71",
        "apt.2_bed": "155",
        "apt.3_bed": "8",
        "apt.4_bed": "",
        "apt.5_bed": "",
        "apt.6_bed": "",
        "apt.7_bed": "",
        "apt.8_bed": "",
        "house.1_bed": "",
        "house.2_bed": "",
        "house.3_bed": "",
        "house.4_bed": "",
        "house.4+_bed": "",
        "other notes": "Creche and Gym Space 688.1sqm\r\nLower Foyer Amenity Space 267.5sqm",
        "coordinates": "https://gist.github.com/rustyb/c6a2d88e4f046fb05a865ff75bcf7315",
        "ref": "PL06D.305859"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.150959730148315,
          53.2579738931655
        ]
      },
      "id": 48
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.155955427,
          53.420222356
        ]
      },
      "properties": {
        "uid": "28ebb61d4a1fce21d9fad842ce184a4e",
        "25PLUS": "yes",
        "la": "fingal",
        "file_num": "F20A/0222",
        "url": "http://planning.fingalcoco.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=F20A/0222&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Residential development, to include the demolition of 2 no. residential houses (452sq.m) and ancillary garage (54sq.m) and the construction of 28 no. residential houses (2523sq.m) with a mix of 1-bed and 2-bed houses and 3-bed loft houses. 35 no. parking spaces and associated ancillary services and a pumping station with a site area of 0.76ha.",
        "address": "Amalgamated sites of Eastwood Lodge, Old Portmarnock, D13 PX65 and Beechlawn, Old Portmarock, D13 V343, Portmarnock, Co Dublin",
        "Applicant": "HLK Development Ltd",
        "received": "2020-05-21",
        "status": "Registered application",
        "decision_date": null,
        "decision_due": null,
        "decision_code": null,
        "decision": "none",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.42022236,
        "longitude": -6.155955427,
        "last_updated": "2020-06-06",
        "area ha": 0.76,
        "no of units": 30,
        "agent": "Horan Rainsford Architects",
        "owner": "HLK Development Ltd",
        "apartments": 28,
        "houses": 0,
        "student": null,
        "studio": null,
        "apt.1_bed": 8,
        "apt.2_bed": 6,
        "apt.3_bed": 14,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Inconsistency between number of units in the development description online and the number cited in the planning application",
        "ref": "F20A/0222"
      },
      "uid": "28ebb61d4a1fce21d9fad842ce184a4e",
      "id": 49
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.150410564,
          53.483993989
        ]
      },
      "properties": {
        "uid": "be66ba3c89d3307d3cf81aa681950bf3",
        "25PLUS": "yes",
        "la": "fingal",
        "file_num": "F20A/0204",
        "url": "http://planning.fingalcoco.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=F20A/0204&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Development will consist of 55 no residential units, 3 no. retail units, public open spaces, upgrades to the public road, reconstruction of the existing car park serving Smyths Bridge House (a Protected Structure), upgrade of the existing entrance onto Main Street, internal access roads, water services including a pumping station, surface water attenuation tank and detention basin, public lighting, 1 no. ESB substation and utilities. The residential element of the proposed development of 55 no. units comprises the following: 1 no. House Type B1: 3 Bedroom Two Storey Mid-Terrace House (110 sqm) 1 no. House Type C: 3 Bedroom Two Storey Mid-Terrace House (102 sqm) 1 no. House Type E: 3 Bedroom Two Storey Semi-Detached House (116.5 sqm) 2 no. House Type F: 3 Bedroom Two Storey Semi-Detached House ( 116.4 sqm) 2 no. House Type L: 4 Bedroom Three Storey Under parked Terraced House (182 sqm) 1 no. House Type L1: 4 Bedroom Three Storey Underparked Semi-Detached House ( 182 sqm) 1 no. House Type L2: 4 Bedroom Three Storey Underparked Semi-Detached House (182 sqm) 2 no. House Type M: 4 Bedroom Two Storey Terraced House (144.4 sqm) 1 no. House Type M1: 4 Bedroom Two Storey Semi-Detached House (144.4 sqm) 2 no. House Type N: 4 Bedroom Two Storey Semi-Detached (125.4 sqm) 4 no. 2 Bedroom Duplexes (98.4 sqm) (Block 1) 1 no. 2 Bedroom Apartment (110.9 sqm) (Block 2) 1 no. 1 Bedroom Apartment (57 sqm) (Block 3) 1 no. 2 Bedroom Apartment (83 sqm) (Block 3) 6 no. 1 Bedroom Apartment (50.7 sqm) (Block 4) 4 no. 1 Bedroom Apartment (54.5 sqm) (Block 4) 1 no. 1 Bedroom apartment (63.2 sqm) (Block 4), 2 no. 1 Bedroom apartment (64 sqm) (Block 4), 6 no. 2 Bedroom apartment (82.2 sqm) (Block 4), 2 no 2 Bedroom apartments (86 sqm) (Block 4), 6 no 2 Bedroom apartment (87.3 sqm) (Block 4), 6 no 2 Bedroom apartment (89 sqm) (Block 4) and 1 no. 3 Bedroom apartment (110 sqm) (Block 4). Proposed Block 1 is three storeys in height, Block 2 is two storeys, Block 3 is two storeys and Block 4 is four storeys. It is proposed to provide 1,600 sqm of public open space including a central playground and a pathway linking to the approved bridge over the railway line. The commercial element of the scheme comprises 2 no. retail units of 108 sqm each and 1 no retail unit of 45 sqm. It is proposed to reconfigure the existing permitted car park serving Smyths Bridge House to accommodate pedestrian , cyclist and limited vehicular access, 44 no. replacement car parking spaces. Works include the upgrade of 140 metres of Main Street including the Balcarrick Road Junction. It is proposed to provide 98 bike parking spaces to serve the proposed development and 112 no. car parking spaces in total to serve the proposed development and Smyths Pub. Proposed potable, surface and foul water services and utilities will be provided predominantly under the proposed roadways, with pumping station, attenuation tank and detention basin provided in the south of the subject site. The application is accompanied by a Natura Impact Statement (NIS).",
        "address": "Lands to the South of Main Street, Corballis East, Donabate, Co Dublin",
        "Applicant": "Aledo Donabate Limited",
        "received": "2020-05-07",
        "status": "Registered application",
        "decision_date": null,
        "decision_due": null,
        "decision_code": null,
        "decision": "none",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.48399399,
        "longitude": -6.150410564,
        "last_updated": "2020-05-23",
        "area ha": 2,
        "no of units": 55,
        "agent": "Declan Brassil & Co. Ltd",
        "owner": "Aledo Donabate Limited",
        "apartments": 41,
        "houses": 14,
        "student": null,
        "studio": null,
        "apt.1_bed": 14,
        "apt.2_bed": 26,
        "apt.3_bed": 1,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": 5,
        "house.4_bed": 9,
        "house.4+_bed": null,
        "other notes": "Retail units to be provided with residential",
        "ref": "F20A/0204"
      },
      "uid": "be66ba3c89d3307d3cf81aa681950bf3",
      "id": 50
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.235860819,
          53.349527618
        ]
      },
      "properties": {
        "uid": "022806abc1254b453af3ad8f2ee94469",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "DSDZ4111/19",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=DSDZ4111/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Planning permission for amendments to previously permitted development, Reg. Ref.DSDZ2896/18 and as amended by DSDZ4279/18 at a site of 1.26 hectares located at City Block 2, Spencer Dock, Dublin 1. The site is bound by Sheriff Street Upper to the north, Mayor Street Upper to the south, New Wapping Street to the east and a development site to the west (also part of Block 2). The subject site also includes the existing operational North Lotts Pumping Station and its associated infrastructure. The application relates to a proposed development within a Strategic Development Zone Planning Scheme area, North Lotts and Grand Canal Dock SDZ. The proposed development comprises of amendments to previously permitted development Reg. Ref. DSDZ2896/18 and as amended by Reg. Ref. DSDZ4279/18 comprising of: • Reconfiguration of the permitted residential development, reducing the number of apartment units from 349 no. to 326 no. comprising of (163 no. 1 beds and 163 no. 2 bed units). • Removal of the southern elevation of block 1 over the Irish Water Pumping Station; • Block 1 will comprise of 201 no. residential units (96 no. 1 beds and 105 no. 2beds); • Block 2 will comprise of 125 no. residential units (67 no 1 beds and 58 no. 2 beds) and an Aparthotel of 100 no. bedrooms. (there is no change to the number of bedrooms proposed within the aparthotel) • Amendments to the façade and elevational treatment to provide for revised balconies and modulation • The proposed amendments will result in revisions to all elevations including revised location and provision of private balconies/terraces; • Provision of link bridge at 6th storey (5th storey) connecting block 1 and block 2; • Revised location and increase in internal residential amenity space associated with the development and the provision of external communal roof terraces; • Revised under croft layout and increase in area by 366 sq.m. overall (an increase of 416sqm on block 1and a decrease of 50sqm on block 2) to include 78 no. car parking spaces and 726 no. cycle parking spaces; and an increase in plant area; • Revised landscaping throughout the scheme as a result of the proposed amendments and revised boundary treatments along the street frontages; • Provisions of 102 no. surface level visitor bicycle parking spaces; • The development also includes, SUDs drainage, the provision of a green roof on both blocks, revised plant at roof level, consequential minor amendments and all associated site development works necessary to facilitate the development.",
        "address": "City Block 2, Spencer Dock, Dublin 1.The site is bound by Sheriff Street Upper to the north, Mayor Street Upper to the south, New Wapping Street to the east and a development site to the west (also part of Block 2)",
        "Applicant": null,
        "received": "2019-09-30",
        "status": null,
        "decision_date": "2019-11-22",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.34952762,
        "longitude": -6.235860819,
        "last_updated": "2019-12-07",
        "area ha": 1.26,
        "no of units": 326,
        "agent": "John Spain Associates ",
        "owner": "Spencer Place Development Company Limited",
        "apartments": 326,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 163,
        "apt.2_bed": 163,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Aparthotel 100 rooms",
        "ref": "DSDZ4111/19"
      },
      "uid": "022806abc1254b453af3ad8f2ee94469",
      "id": 51
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.440024347,
          53.38806589
        ]
      },
      "properties": {
        "uid": "419b398bfbc0e0f9c1d1921d901aca62",
        "25PLUS": "yes",
        "la": "fingal",
        "file_num": "FW20A/0059",
        "url": "http://planning.fingalcoco.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=FW20A/0059&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "circa 0.55 ha, being part of Zone 7 Railway of the Hansfield Strategic Development Zone Planning Scheme 2006. The proposed development is in the townland of Barberstown, Hansfield, Dublin 15. The proposed development is located tot he north of the Royal Canal and the Dublin to Dunboyne rail line, northeast of Hansfield railway station, east of Station Road, south of the Ongar Road, Hansfield Village Green and Park Walk Road and to the west & north of permitted residential development granted under Reg. Ref. FW18A/0110 and currently under construction. The proposed development consists of 83 no. dwellings in 2 no. 5 & 6 sstorey blocks (Blocks L&K) over baseemnt level carparking. Block K is a 5 storey building consisting of 35 no. dwellings comprised of 15 no. 1 bed & 20 no. 2 bed apartments. Block L is a 6 storey building consisting of 48 no. 2 bed apartments. The proposed development also includes for basement level carparking measuring circa 3,305m2 consisting of 97 no. car parking spaces (including for 4 no. disabled parking spaces) bin store and plant room. Access to the proposed basement will be from the permittted basement level car park to the east granted under Reg.Ref. FW18A/0110. Access to the proposed development will be from Station Road to the west and Park Walk Road to the north via the internal road network granted under Reg.Ref. FW18A/0110. The proposed development includes for 2 no. ESB substations located to the east of the proposed apartment blocks. The proposed development also includes for all associated site development works, car parking (surface and basement), landscaping, open spaces, public lighting, foul and surface water drainage/attenuation, infrastructure connections etc. The proposed development is located on lands within the boundaries of Hansfield Strategic Development Zone as defined by Statutory Instrument No. 273 of 2001.",
        "address": "Zone 7 \"Railway\", Hansfield Strategic Development Zone Planning Scheme 2006, Barberstown, Dublin 15",
        "Applicant": "Garlandbrook Ltd.",
        "received": "2020-04-20",
        "status": "Registered application",
        "decision_date": null,
        "decision_due": null,
        "decision_code": null,
        "decision": "none",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.38806589,
        "longitude": -6.440024347,
        "last_updated": "2020-05-09",
        "area ha": 0.55,
        "no of units": 83,
        "agent": "Delphi Design",
        "owner": "Garlandbrook Ltd.",
        "apartments": 83,
        "houses": 0,
        "student": null,
        "studio": null,
        "apt.1_bed": 15,
        "apt.2_bed": 68,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": null,
        "ref": "FW20A/0059"
      },
      "uid": "419b398bfbc0e0f9c1d1921d901aca62",
      "id": 52
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.362083591,
          53.373944377
        ]
      },
      "properties": {
        "uid": "548cc6659e9c049a17ff7055d1a2bfcb",
        "25PLUS": "yes",
        "la": "fingal",
        "file_num": "FW20A/0058",
        "url": "http://planning.fingalcoco.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=FW20A/0058&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "The proposed development will consist of: the demolition of an existing residential unit and associated structures on the application site, and the development of a three and part four storey, residential development, consisting of 25 apartments. The apartments will consist of 4 one bed units, 19 two bed units and 2 three bed units. The wider development includes parking for 27 cars and 1 accessible parking bay and bin storage unit; secure cycle storage building; boundary treatment and landscaping; and all underground drainage and service infrastructure. It is proposed to widen the access point onto the Castleknock Road and regrade the driveway. The development includes all associated site development works.",
        "address": "Glenmalure, Castleknock Road, Castleknock, Dublin 15",
        "Applicant": "Castleshore Investments Limited",
        "received": "2020-04-17",
        "status": null,
        "decision_date": null,
        "decision_due": null,
        "decision_code": null,
        "decision": "none",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.37394438,
        "longitude": -6.362083591,
        "last_updated": "2020-05-02",
        "area ha": 0.35,
        "no of units": 25,
        "agent": "Tony Bamford Planning",
        "owner": "Castleshore Investments Limited",
        "apartments": 25,
        "houses": 0,
        "student": null,
        "studio": null,
        "apt.1_bed": 4,
        "apt.2_bed": 19,
        "apt.3_bed": 2,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": null,
        "ref": "FW20A/0058"
      },
      "uid": "548cc6659e9c049a17ff7055d1a2bfcb",
      "id": 53
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.099926483,
          53.532050905
        ]
      },
      "properties": {
        "uid": "b08c0cf73c4b119551c16c4174eccb36",
        "25PLUS": "yes",
        "la": "fingal",
        "file_num": "F20A/0170",
        "url": "http://planning.fingalcoco.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=F20A/0170&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "A residential scheme of 43 no. residential units comprising 15 no. detached/semi-detached two-storey houses, along the eastern half of the subject lands and 28 no. apartments/duplexes in 2 no. three-storey height building blocks located to the southern-west of the application's site, 35 no. surface car parking spaces to the front of the 2 no. proposed apartment/duplex buildings,34 no. bicycle parking spaces (28 no. residents and 6 no. visitors) in proximity of the 2 no. building blocks, I no. new vehicular entrance, internal vehicular route and associated road works including the construction of a section of the new East-West Urban Street along the southern site boundary and its connection to permitted site development Reg Ref. F16A/0148 and road layout permitted under Reg. Ref. F15A/0294; pedestrian/cycling linkages to Palmer Road, the new East-West Urban Street and Park Road via permitted site development Reg. Ref. F16A/0148 located south of the application's site; provision of public open space (1,416sqm) located to the south-eastern corner of the site; Bin Store, collections areas, street lighting and SuDs drainage comprising car parking bays fitted with permeable paving, detention pound, rainwater butts, filter drains and a new underground surface water attenuation system; and all associated and ancillary site development and infrastructural works, hard and soft landscaping and boundary treatment works to facilitate the development.",
        "address": "Palmer Road area of Rush, 110m west of Palmer Avenue, on a site of c.12h., Rush, Co Dublin",
        "Applicant": "PWCPS",
        "received": "2020-04-16",
        "status": "Registered application",
        "decision_date": null,
        "decision_due": null,
        "decision_code": null,
        "decision": "none",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.53205091,
        "longitude": -6.099926483,
        "last_updated": null,
        "area ha": 1.27,
        "no of units": 43,
        "agent": "Corr & Associates Spatial Planning Ltd",
        "owner": "PWCPS",
        "apartments": 28,
        "houses": 15,
        "student": null,
        "studio": null,
        "apt.1_bed": null,
        "apt.2_bed": 14,
        "apt.3_bed": 14,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": 15,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": null,
        "ref": "F20A/0170"
      },
      "uid": "b08c0cf73c4b119551c16c4174eccb36",
      "id": 54
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.205571593,
          53.313375933
        ]
      },
      "properties": {
        "uid": "2ab8b1e99c97e1ae2009299a39eae700",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "3743/19",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=3743/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "The development will consist of: - Part 3, part 4, part 5, part 7 and part 9 storey residential building providing for 73 no. apartments (1 studio; 10 1-bed; 56 2-bed and 6 3-bed units) with terraces, balconies and winter gardens to south, east and west elevations; - The proposed residential development is located immediately south of the existing 'The Links' building which is situated to the west of the overall campus; - Revisions to basement layout resulting in the provision of an additional 52 no. car parking spaces and 73 no. bicycle parking spaces; bin storage and access cores to service the residential development; - Provision of playground and associated landscaping to west of 'The Links' building; - All associated works, site development, landscaping, utilities infrastructure, temporary construction works, plant and PV panels.",
        "address": "Elmpark Green, Merrion Road, Dublin 4",
        "Applicant": "Davy Platform ICAV acting on behalf of its sub fund Elm Real Estate Investments",
        "received": "2020-04-08",
        "status": null,
        "decision_date": "2020-05-29",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.31337593,
        "longitude": -6.205571593,
        "last_updated": "2020-06-13",
        "area ha": 0.568,
        "no of units": 73,
        "agent": "John Spain Associates",
        "owner": "Davy Platform ICAV acting on behalf of its sub fund Elm Real Estate Investments",
        "apartments": 72,
        "houses": 0,
        "student": null,
        "studio": 1,
        "apt.1_bed": 10,
        "apt.2_bed": 56,
        "apt.3_bed": 6,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Playground to be provided. ",
        "ref": "3743/19"
      },
      "uid": "2ab8b1e99c97e1ae2009299a39eae700",
      "id": 55
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.417229733,
          53.383272715
        ]
      },
      "properties": {
        "uid": "2a1813f895849b7fc0a97bff18d5ef03",
        "25PLUS": "yes",
        "la": "fingal",
        "file_num": "FW20A/0046",
        "url": "http://planning.fingalcoco.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=FW20A/0046&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "A Mixed-Use Development including: 1.) Community Room at Ground Floor Level; 2.) A total of 12 No. Residential Apartments at First Floor Level, Second Floor Level and Second Floor (Set-Back) Level comprising of 2 No. 2 Bedroom Units and 10 No. 1 Bedroom Units; 3.) Residential Circulation Areas; 4.) Residential External Terrace Areas; 5.) The relocation of site vehicular and pedestrian access onto Clonsilla Road; and 6.) All ancillary site works and services.",
        "address": "Clonsilla Road, Clonsilla Village, Dublin 15",
        "Applicant": "Coastdawn Limited",
        "received": "2020-03-27",
        "status": null,
        "decision_date": null,
        "decision_due": null,
        "decision_code": null,
        "decision": "none",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.38327272,
        "longitude": -6.417229733,
        "last_updated": "2020-04-11",
        "area ha": 0.0904,
        "no of units": 12,
        "agent": "Douglas Wallace Consultants",
        "owner": "Coastdawn Limited",
        "apartments": 12,
        "houses": 0,
        "student": null,
        "studio": null,
        "apt.1_bed": 10,
        "apt.2_bed": 2,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": null,
        "ref": "FW20A/0046"
      },
      "uid": "2a1813f895849b7fc0a97bff18d5ef03",
      "id": 56
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.15458224,
          53.286183076
        ]
      },
      "properties": {
        "uid": "74e23dd65e577ef5a936d4a2809a4a85",
        "25PLUS": "yes",
        "la": "dun laoghaire-rathdown",
        "file_num": "D19A/0798",
        "url": "http://planning.dlrcoco.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=D19A/0798&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Permission for a residential and commercial development. The subject site",
        "address": "Lands comprising former Monkstown Mansions, former Tyre Centre and rear of Carrickbrennan Credit Union, at Monkstown Farm and Monksotwn Grove, Blackrock, Co. Dublin",
        "Applicant": "Southern Oak",
        "received": "2020-03-20",
        "status": "Decision made",
        "decision_date": "2020-06-09",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.28618308,
        "longitude": -6.15458224,
        "last_updated": "2020-06-13",
        "area ha": 0.2185,
        "no of units": 30,
        "agent": "Donal Duffy",
        "owner": "Southern Oak",
        "apartments": 30,
        "houses": 0,
        "student": null,
        "studio": null,
        "apt.1_bed": 12,
        "apt.2_bed": 18,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": null,
        "ref": "D19A/0798"
      },
      "uid": "74e23dd65e577ef5a936d4a2809a4a85",
      "id": 57
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.136041631,
          53.584751456
        ]
      },
      "properties": {
        "uid": "0240a1cff39c5eff14e69a53a13d0b02",
        "25PLUS": "yes",
        "la": "fingal",
        "file_num": "F18A/0561",
        "url": "http://planning.fingalcoco.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=F18A/0561&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "The development consists of the following: 3 No. separate Apartment blocks C1, C3 & C4 comprising a total of 30 no. 2 Bedroom Garden Level Apartments Below, 32 no. 3 Bedroom Duplex Apartments. This development was previously approved under Planning Reg. Ref. No's F05A/1818, F07A/0898 & F08A/1374. The proposed development at the site provides 62 No. new residential dwellings units: (i) Block C1 (3,885m²) - 18 no. 2 Bedroom Garden Level Apartments Below 20 no. 3 Bedroom Duplex Apartments, (ii) Block C3 (802m²) - 4 no. 2 Bedroom Garden Level Apartments Below 4 no. 3 Bedroom Duplex Apartments, (iii) Block C4 (1,612m²) - 8 no. 2 Bedroom Garden Level Apartments Below 8 no. 3 Bedroom Duplex Apartments, (iv) Total of 41 car parking spaces provided at surface level to service the proposed apartments in addition to the existing underground car park already provided on the site. (v) New landscaped area with a total area of open space 2,292m², pedestrian and cycle routes, foul and surface water drainage site development works, and all other associated site development works. Add info received 10th January 2019.",
        "address": "Barnageeragh Cove, Kellys Bay, Skerries, Co. Dublin",
        "Applicant": "Winsac Limited",
        "received": "2018-10-09",
        "status": "Decision Made by Fingal County Council",
        "decision_date": "2019-04-09",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.58475146,
        "longitude": -6.136041631,
        "last_updated": "2019-04-27",
        "area ha": 0.78,
        "no of units": 62,
        "agent": "Fitzgerald Kavanagh & Partners ",
        "owner": "Winsac Limited ",
        "apartments": 62,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 30,
        "apt.2_bed": 32,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "no other development",
        "ref": "F18A/0561"
      },
      "uid": "0240a1cff39c5eff14e69a53a13d0b02",
      "id": 58
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.327934338,
          53.322942542
        ]
      },
      "properties": {
        "uid": "29bd108e0a1299290c689084021c6027",
        "25PLUS": "yes - shd ??",
        "la": "dublin city",
        "file_num": "4364/19",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=4364/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Site bounded and accessed by both Walkinstown Road and Balfe Road, comprising of Balfe Road Industrial Estate (2-4 Balfe Road), Walkinstown Road Surface Car Park and lands and industrial building (5 Walkinstown Road) to the rear of houses on Walkinstown Road and Thomas Moore Road, Walkinstown, Dublin 12 The development will consist of:- 1.) The demolition of all existing buildings on site; 2.) The construction of a mixed use commercial and residential development in 6 no. blocks accommodating 2 no. commercial units, a communal meeting space and 70 no. residential units comprising 29 no. 1 bed units (apartments), 30 no. 2 bed units (apartments), 5 no. 3 bed units (townhouses) and 6 no.4 bed units (townhouses); 3.) the proposed blocks consist of the following: -Block 1: part 3-storey / part 5-storey (3-storey plus two setback levels) mixed-use block fronting onto Walkinstown Road accommodating 2 no. ground floor retail/non-retail services unit addressing Walkinstown Road, ground floor communal meeting area, and 26 no. apartments comprising of 13 no. 1 bed units and 13 no. 2 bed units with associated balconies/terraces; - Block 2: part 3-storey/part 4-storey (3-storey plus setback level) residential block fronting onto Balfe Road accommodating 25 no. apartments comprising 12 no. 1 bed units and 13 no. 2 bed units with associated balconies/terraces;- Block 3: 2-storey plus attic level residential block fronting onto the central communal amenity area accommodating 5 no. 3 bed townhouses; - Block 4: 2-storey residential block accommodating 4 no. apartments comprising 2 no. 1 bed units and 2 no. 2 bed units with associated balconies /terraces; - Block 5: 2-storey residential block accommodating 4 no. apartments comprising 2 no 1 bed units and 2 no. 2 bed units with associated balconies/terraces; - Block 6: 2-storey plus attic level residential block at the southern end of the site accommodating 6 no.4 bed townhouses; 4.) Vehicular access from Walkinstown Road and realignment/widening of existing public laneway off Walkinstown Road including removal of existing boundary wall along the laneway; 5.) internal access road and 38 no. car parking spaces; 6.) associated signage, bicycle parking, refuse stores, landscaping, boundary treatments, and all site development works and services.",
        "address": "Thomas Moore Road, Walkinstown, Dublin 12",
        "Applicant": "Canmar Properties Limited",
        "received": "2020-03-10",
        "status": null,
        "decision_date": "2020-04-17",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.32294254,
        "longitude": -6.327934338,
        "last_updated": "2020-05-02",
        "area ha": 0.683,
        "no of units": 70,
        "agent": "Stephen Little &Associates",
        "owner": "Canmar Properties Limited",
        "apartments": 59,
        "houses": 11,
        "student": null,
        "studio": null,
        "apt.1_bed": 29,
        "apt.2_bed": 30,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": 5,
        "house.4_bed": 6,
        "house.4+_bed": null,
        "other notes": null,
        "ref": "4364/19"
      },
      "uid": "29bd108e0a1299290c689084021c6027",
      "id": 59
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.274641513,
          53.337410819
        ]
      },
      "properties": {
        "uid": "39b5f8882f7f7451d2ff39f111da095d",
        "25PLUS": "maybe",
        "la": "dublin city",
        "file_num": "4423/19",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=4423/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "PROTECTED STRUCTURE: We, TC Fumbally Properties Ltd, intend to apply for full planning permission for a mixed use development at 27-29 New Row South, Dublin 8. The application site is located at the junction of New Row South to the northwest, Blackpitts to the west and Fumbally Lane to the south and southeast. The site contains a Protected Structure (referred to as a former laundry building under RPS Ref.:5821). The development, which ranges from 4 to 8 no. storeys over basement and includes the re-use and extension of the protected structure, provides 4,843 sq.m of hotel use from first to third floor level (144 no. bedrooms), 2,390 sq.m of Build-to-Rent Shared Living accommodation from fourth to seventh floor level (inclusive of amenity space) (69 no. units), 213 sq.m of co-working/artistic-creative studios, 142 sq.m of restaurant and 147 sq.m public community/event space uses at ground floor level. The detailed description of the proposed development is as follows: • Restoration, refurbishment and extension of the existing building, a Protected Structure under RPS Ref.: 5821, to facilitate the proposed redevelopment, including removal and reinstatement of sections of the rear wall, removal of internal dividing walls, removal of existing non-original floors, staircases and roof, reinstatement of original window openings at ground floor level and modifications to the fenestration at first floor level fronting onto New Row South. • It is proposed to provide 4 no. floors within the existing Protected Structure, including setback at second and third floor level. • The internal and external modifications to the Protected Structure will accommodate of co-working / artist studios, shared amenity space, a gym and community/event space at ground floor level and 72 no. hotel rooms from first to third floor level. • The refurbishment protected structure will be integrated with the proposed new building to the west via an entrance lobby at ground floor level, and from first to third floor level via linking corridors. • The proposal includes a new 7 storey building, including a setback 8th storey in the central section of the building, above basement, at the junction of New Row South and Blackpitts, with an overall height of 27.3m. • The proposed building will include reception/concierge, shared amenity space and restaurant at ground floor level, 72 no. hotel rooms from first to third floor level and 69 no. single occupancy shared accommodation units and amenity space from fourth to seventh floor level. • The development includes communal residential amenity space to serve the shared accommodation units including; a screening room at basement level, residential lounges and gym facilities at ground floor level, communal areas at first floor level, informal breakout spaces from fourth to sixth floor level, laundry and lounge area at fifth floor level, and event space at seventh floor level. Two communal kitchen/dining areas are provided at fourth and seventh floor levels. • External open space is located within the courtyard at ground floor level (347 sq.m), fourth floor level (23 sq.m) and roof terrace at seventh floor level (435 sq.m). • The development includes all associated and ancillary works including plant and storeroom facilities at basement level, staircase cycle parking, bin storage, an ESB substation and switchroom, landscaping, boundary treatment, lighting, and all associated site works including underground foul and storm water drainage network and attenuation areas.",
        "address": "27-29, New Row South, Dublin 8",
        "Applicant": "TC Fumbally Properties Ltd.",
        "received": "2020-03-04",
        "status": null,
        "decision_date": "2020-03-30",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.33741082,
        "longitude": -6.274641513,
        "last_updated": "2020-04-18",
        "area ha": 0.23,
        "no of units": 69,
        "agent": "John Spain and Associates",
        "owner": "TC Fumbally Properties Ltd.",
        "apartments": 69,
        "houses": 0,
        "student": null,
        "studio": null,
        "apt.1_bed": 69,
        "apt.2_bed": null,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": null,
        "ref": "4423/19"
      },
      "uid": "39b5f8882f7f7451d2ff39f111da095d",
      "id": 60
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.120998798,
          53.246873042
        ]
      },
      "properties": {
        "uid": "23f674beba4fddb41ce397f6ec99797b",
        "25PLUS": "yes",
        "la": "dun laoghaire-rathdown",
        "file_num": "D20A/0155",
        "url": "http://planning.dlrcoco.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=D20A/0155&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Permission for the construction of a residential development on lands. The",
        "address": "Cromlech Cottage, Killiney Hill Road, Killiney, Co. Dublin",
        "Applicant": "Conskig Ltd",
        "received": "2020-02-28",
        "status": "Registered application",
        "decision_date": null,
        "decision_due": null,
        "decision_code": null,
        "decision": "none",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.24687304,
        "longitude": -6.120998798,
        "last_updated": "2020-06-06",
        "area ha": 0.46,
        "no of units": 20,
        "agent": "Downey Planning and Architecture",
        "owner": "Conskig Ltd",
        "apartments": 20,
        "houses": 0,
        "student": null,
        "studio": null,
        "apt.1_bed": 8,
        "apt.2_bed": 12,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": null,
        "ref": "D20A/0155"
      },
      "uid": "23f674beba4fddb41ce397f6ec99797b",
      "id": 61
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.210821645,
          53.31866699
        ]
      },
      "properties": {
        "uid": "977a75057fa22550f9b52f54831ba225",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "4461/19",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=4461/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "The development will consist of demolition of existing underutilised 2 no. storey building (390 sqm) and tennis court and the construction of a residential development of 28 no. apartments with an overall height of part 4, part 5 no. storeys (over basement) comprising: 12 no. 1 bedroom apartments, 13 no. 2 bedroom apartment and 3 no. 3 bedroom apartments (with private balconies/terraces at each floor level) and a ground floor gym (c. 159 sqm). Vehicular and pedestrian access will be provided from Merrion Road into a basement which will provide 28 no. car parking spaces (1 no. disabled access), 44 no. cycle space and all ancillary areas, with 2 no. disabled parking spaces and 12 no. visitor bicycle parking spaces at surface level; all associated site development works, hard and soft landscaping and all other ancillary works to include provision of an area of communal landscaped open space, with pedestrian access provided to the north east. The total gross floor area proposed is c. 2,213sqm.",
        "address": "The Pavilion, 204-205 Merrion Road, Dublin 4, D04 EC86",
        "Applicant": "Brian Kennedy",
        "received": "2020-02-24",
        "status": null,
        "decision_date": "2020-03-20",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.31866699,
        "longitude": -6.210821645,
        "last_updated": "2020-04-04",
        "area ha": 0.25,
        "no of units": 28,
        "agent": "John Spain and Associates",
        "owner": "Brian Kennedy",
        "apartments": 28,
        "houses": 0,
        "student": null,
        "studio": null,
        "apt.1_bed": 12,
        "apt.2_bed": 13,
        "apt.3_bed": 3,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": null,
        "ref": "4461/19"
      },
      "uid": "977a75057fa22550f9b52f54831ba225",
      "id": 62
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.244616787,
          53.380051953
        ]
      },
      "properties": {
        "uid": "d7a9384f147399a5cfb4742aec430d0a",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "3405/19",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=3405/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Permission for an amendment to a permitted development (DCC Reg. Ref. 3269/10; ABP Ref. PL29N.238685, as extended by DCC Reg. Ref. 3269/10x01) on a site at Swords Road, Whitehall, Dublin 9. The site is bounded to the west by Swords Road, to the south by Highfield Hospital, to the north by vacant lands and GAA pitches and to the east by Beechlawn Nursing Home with residential development beyond. The permitted scheme comprises 358 no. apartments, a crèche (465 sq m) and 3 no. retail/commercial units (344 sq m) in 7 no. four to seven storey blocks over partial basement, all on a site area of 2.73 hectares. The subject application relates to Block F, which is a permitted 6 no. storey block comprising 60 no. apartments measuring 4,745.4 sq m, located in the north-eastern corner of the subject site. The proposed development comprises the rationalisation of the existing floor plans and amendments to the footprint increasing the number of apartment units within Block F to 76 no. units (7,226 sq m). Block F will now comprise 27 no. 1 bedroom apartments, 43 no. 2 bedroom apartments and and 6 no. 3 bedroom apartments and a communal room for residents measuring 111 sq m. The development also proposes revised elevational treatments; amendments to underground services; bin store; and all associated work above and below ground.",
        "address": "Site at Swords Road, Whitehall, Dublin 9",
        "Applicant": "Eastwise Construction Limited",
        "received": "2020-02-21",
        "status": null,
        "decision_date": "2020-03-19",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.38005195,
        "longitude": -6.244616787,
        "last_updated": "2020-04-04",
        "area ha": 2.7,
        "no of units": 76,
        "agent": "Thornton O'Connor Town Planning",
        "owner": "Eastwise Property Ltd",
        "apartments": 76,
        "houses": 0,
        "student": null,
        "studio": null,
        "apt.1_bed": 27,
        "apt.2_bed": 43,
        "apt.3_bed": 6,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": null,
        "ref": "3405/19"
      },
      "uid": "d7a9384f147399a5cfb4742aec430d0a",
      "id": 63
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.230349519,
          53.444001679
        ]
      },
      "properties": {
        "uid": "0304dbb72e3177f7c3ef03873af050b6",
        "25PLUS": "yes",
        "la": "fingal",
        "file_num": "F18A/0306",
        "url": "http://planning.fingalcoco.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=F18A/0306&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Permission for the construction of 36 residential units consisting of 30 two storey houses (23 three bedroom type, 7 four bedroom type) and 6 number two bedroom apartments in a three storey block, with ancillary open spaces, boundary treatment and site works at Fosterstown North. The lands adjoin the Boroimhe Housing Estate to the west and the Texaco service station on the old N1 road to the east. Vehicular and pedestrian access to the new housing will be from the Boroimhe Distributor Road linking the Swords Road with Forest Road and by pedestrian access from the adjoining Boroimhe housing. Add Info received 5th November 2018.",
        "address": "Lands at Fosterstown North, Boroimhe Link Road, Swords, Co Dublin",
        "Applicant": "Clarke Family Partnership",
        "received": "2018-06-01",
        "status": "Decision Made by Fingal County Council",
        "decision_date": "2018-11-30",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.44400168,
        "longitude": -6.230349519,
        "last_updated": "2018-12-15",
        "area ha": 0.99,
        "no of units": 36,
        "agent": "Manrahan Planners",
        "owner": "Clarke Family Partnership ",
        "apartments": 6,
        "houses": 30,
        "student": null,
        "studio": null,
        "apt.1_bed": null,
        "apt.2_bed": 6,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": 23,
        "house.4_bed": 7,
        "house.4+_bed": null,
        "other notes": "Residential only",
        "ref": "F18A/0306"
      },
      "uid": "0304dbb72e3177f7c3ef03873af050b6",
      "id": 64
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.174783058,
          53.42449694
        ]
      },
      "properties": {
        "uid": "0a47107564231bdced28a95200ef0288",
        "25PLUS": "yes",
        "la": "fingal",
        "file_num": "F20A/0010",
        "url": "http://planning.fingalcoco.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=F20A/0010&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Development of 0.7429hectares consisting of new construction and amendment of part of the permitted scheme (Reg. Ref. F16A/0511; An Bord Pleanála Reference PL06.248584) now identified as Kinsealy Woods (currently under construction). (The application site comprised of c. 0.3829 of lands forming part of the permitted development (Reg. Ref. F16A/0511; ABP Ref. PL06F.248584) and c 0.36 hectares of additional land.) (The original site of c. 3.766 hectares included some 0.266 hectares of lands in the ownership of Fingal County Council, outwith the site at Kinsealy Lane and at the Malahide Road/Chapel Road junction, respectively.) The site is principally bounded by: chapel Road to the north; by 3 no. residential dwellings to the east (The Bungalow, Chapel Road, Malahide, Co. Dublin, K36 KW89; Churchview, Chapel Road, Kinsealy, Malahide, Co. Dublin, K36 VP76; and Woodford, Chapel Road, Malahide, Co. Dublin, K36 PY04, respectively); by the lands associated with the Teagasc, Kinsealy Centre to the south; and by Church View, Malahide Road, Dublin 17, D17 AX54, agricultural lands and No. 5 Kinsealy Cottages, Malahide, Co. Dublin, K36 DE04 to the west. The development will consist of; the relocation of the permitted one/two storey childcare facility (191.2sq.m.); the construction of 18 no. one and two-storey dwellings (identified as Units 6 to 11 and 16 to 28 inclusive) of which some 9 no. units are previously permitted units relocated/amended (to provide 2 no. two-bedroom, 6 no. three-bedroom, and 1 no. four-bedroom dwellings) and the balance of 9 no. units being new build (2 no. one-bedroom, 1 no. two-bedroom, and 6 no. three-bedroom dwellings) (overall this will result in a net increase of 9 no. dwellings from the 82 no. permitted in Kinsealy Woods to 91 no.); and the provision of all associated parking, site excavation and development works (above and below ground), hard and soft landscaping works (including lighting, changes in levels, boundary treatments, provision of revised/new paving and cycle path, and of new roadway, the reconfiguration of a permitted road, and extension of the permitted park). The unit identification of the permitted units is renumbered on the revised Site Layout Plan (Hogan Associates' Dwg. No. 926.PL.003 Rev. 14). The 9 no. new build units comprise: 2 No. Type E (two-storey three-bedroom terrace house (102.3 sq.m. )) Nos. 19 and 21); 1 No. Type E2 (two-storey three-bedroom terrace/detached house (130.2sq.m.)) (No. 24); 1 No. Type F (two-storey three-bedroom terrace (102.3sq.m.)) ( No. 20); 1 No. Type H (one-storey two-bedroom bungalow (66.1sq.m.)) ( No. 10); 2 No. Type J (one-storey one-bedroom bungalow (54.5sq.m.)) (Nos. 9 and 11); and 2 No. Type K (two-storey three-bedroom detached house (114.4sq.m.)) ( Nos. 22 and 23), respectively. The previously permitted 191.2 sq.m. childcare facility is relocated, as are House Nos. 6-7 (Type H, one-storey two-bedroom bungalow (66.1sq.m.)), House No. 16 (Type A1, two-storey four-bedroom detached house), and House Nos. 17-18 (Type D, three-bedroom semi-detached (102.3sq.m.)). House Nos. 25-26 have been relocated and amended from a Type D2 (three-bedroom semi-detached (102.3sq.m.)) to a Type D (three-bedroom semi-detached (102.3sq.m.)); House No. 27 has been amended from a Type D (two-storey three-bedroom semi-detached (102.3sq.m.)) to a Type E2 (two-storey three-bedroom terrace/detached house (130.2sq.m.)); and House No. 28 has been amended from a Type D1 (two-storey three-bedroom terraced house (130.2sq.m.)) to a Type D (two-storey three bedroom semi-detached (102.3sq.m.)). Add Info received 18th March 2020.",
        "address": "Chapel Road, Kinsealy (Kinsaley), Malahide, Co. Dublin",
        "Applicant": "O'Flynn Group",
        "received": "2020-01-14",
        "status": "Decision Made by Fingal County Council",
        "decision_date": "2020-04-21",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.42449694,
        "longitude": -6.174783058,
        "last_updated": "2020-05-09",
        "area ha": 0.7,
        "no of units": 18,
        "agent": "Tom Phillips & Associates",
        "owner": "O'Flynn Construction (Kinseally)",
        "apartments": 18,
        "houses": 0,
        "student": null,
        "studio": null,
        "apt.1_bed": 2,
        "apt.2_bed": 3,
        "apt.3_bed": 12,
        "apt.4_bed": 1,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "*",
        "ref": "F20A/0010"
      },
      "uid": "0a47107564231bdced28a95200ef0288",
      "id": 65
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.203859861,
          53.379055736
        ]
      },
      "properties": {
        "uid": "0d9d80012f31d509dae089f884162277",
        "25PLUS": "Yes",
        "la": "dublin city",
        "file_num": "3826/19",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=3826/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Planning permission for amendments to a previously permitted residential development (Reg. Ref. 3930/18; ABP-303146-18). The proposed revisions shall consist of: (a) an increase of 15 no. apartments (comprising 7 no. 1 bedroom units; 7 no. 2 bedroom units; 1 no. 3 bedroom unit) to provide 86 no. apartments (71 previously permitted) within 2 no. blocks and increase in the heights of previously permitted Blocks 02 and 03 from 4 storeys to 5 storeys; (b) the proposed development shall now comprise the following: Block 02 - 5 storey block (4 storeys plus setback penthouse level) (4 storeys previously permitted) comprising of 38 no. residential units (18 no. 1 bedroom units and 20 no. 2 bedroom units) with balconies/terraces on east and west elevations. Block 03 - 5 storey block (4 storeys plus setback penthouse level) (4 storeys previously permitted) comprising 37 residential units (18 no. 1 bedroom units, 18 no. 2 bedroom units and 1 no. 3 bedroom unit) with balconies/terraces on northwest and southeast elevations; (c) associated internal and elevational changes to Blocks 02 and 03; (d) increase in basement level area with increase in car parking spaces from 75 no. spaces to 97 no. spaces and increase in basement level bicycle parking spaces from 70 no. spaces to 111 no. spaces; (e) reposition the vehicular and pedestrian access gate to St. Brigid's Road; (f) increase in open space area in lieu of 4 no. houses omitted by condition no. 2(b) attached ABP Ref. 303146-18; (g) Provision of Fire Tender Access to the south of Block 01 and 02; and (h) All associated engineering and site development works necessary to facilitate the development.",
        "address": "Former Holy Faith Convent Building, St. Brigid's Road, Killester, Dublin 5",
        "Applicant": null,
        "received": "2020-01-15",
        "status": null,
        "decision_date": "2020-02-11",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.37905574,
        "longitude": -6.203859861,
        "last_updated": "2020-02-29",
        "area ha": 0.9,
        "no of units": 15,
        "agent": "Downey Planning & Architecture",
        "owner": "Clondev Properties Ltd",
        "apartments": 15,
        "houses": 0,
        "student": null,
        "studio": null,
        "apt.1_bed": 7,
        "apt.2_bed": 7,
        "apt.3_bed": 1,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": null,
        "ref": "3826/19"
      },
      "uid": "0d9d80012f31d509dae089f884162277",
      "id": 66
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.334249741,
          53.326932244
        ]
      },
      "properties": {
        "uid": "11de0dc69a39b16809428fa59e4a6510",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "2203/18",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=2203/18&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "The proposed development seeks amendments to previously permitted residential development, Reg. Ref. 4244/15, as subsequently amended under Reg. Refs. 2438/17, 2875/17and 3940/17. The proposed amendments comprise of (i) New Design, layout and orientation of permitted block D to provide for 35 no. units ( 14 no. 1 bed, 14 no. 2 bed and 7 no. 3 bed ) (ii) Repositioning reorientation and provision of an additional floor on the west side of Block E increasing the height from 6 no. storey as permitted to 6-7 storeys as proposed, all to provide for 46 no. units ( 13 no. 1 bed, 20 no. 2 bed and 13 no. 3 bed ) (III) Amendments to all elevations of Blocks D and E incorporating new and revised balconies / terraces generally on all floors; (iv) Revised hard and soft landscaping master plan; and (v) all associated site development works and ancillary infrastructure and site services to facilitate the proposed development . The proposed amendments will provide for a reduction of 7 no. units in Block D( from 42 no. as permitted to 35 no. as proposed ) and 4 no. additional units in Block E ( from 42 no. as permitted to 46 no. as proposed ) bringing the total unit provision within the development from 358 no. as permitted to 355 no. as proposed ( comprising of 84 no. 1 bed, 214 no. 2 bed, 57 no. 3 bed units )",
        "address": "Carriglea Industrial Estate, Muirfield Drive, Naas Road, Dubllin 12",
        "Applicant": null,
        "received": "2018-12-21",
        "status": null,
        "decision_date": "2019-01-25",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.32693224,
        "longitude": -6.334249741,
        "last_updated": "2019-02-09",
        "area ha": 2.62,
        "no of units": 81,
        "agent": "Marlet Property Group Limited",
        "owner": "Crekav Trading GP Limited",
        "apartments": 81,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 27,
        "apt.2_bed": 34,
        "apt.3_bed": 20,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "no other dev",
        "ref": "2203/18"
      },
      "uid": "11de0dc69a39b16809428fa59e4a6510",
      "id": 67
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.153390295,
          53.403466413
        ]
      },
      "properties": {
        "uid": "26679db3795fede9197e4bbfbd0d7546",
        "25PLUS": "yes\r\nABP 303262 ",
        "la": "dublin city",
        "file_num": "3894/19",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=3894/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Planning permission is sought for development at lands at Clongriffin, Dublin 13, on plots known as 3, 13 and 15, located to the south of Park Street, east of Friars' Street and north of main Street (plot 3), to the north of Market Street, south of Dargan Street, east of Lake Street and west of Clongriffin Road (plot 13), to the north of Main Street, south of Market Street, west of Station Square and east of Market Lane (plot 15); all of which are located to the north of Main Street, Clongriffin, Dublin 13. The development will consist of the construction of a mixed-use development (within 3 no blocks, i.e. Blocks 3, 13 and 15) comprising of 420 no. apartment units (127 no. one beds, 273 no. two beds and 20 no. three beds) of which 233 no. units are residential and 187 no. units are 'build to rent' with ancillary residential amenity facilities; 14 no. retail units, 1 no. 8 screen cinema, 4 no. cafes/restaurants and 10 no. floors of commercial office suites, all of which will be provided as follows: - Block 3 containing a total of 141 no. residential apartments comprising 31 no. 1 beds, 104 no. 2 beds and 6 no. 3 beds, all apartments with private balconies/terraces to north, south, east and west elevations, in 3 no. buildings ranging from 5 to 6 storeys in height, with ancillary residential amenity facilities, 2 no. retail units at ground floor level with 5 no. floors of commercial office suites at first to fifth floor level, 1 no. ESB substation at ground floor level, all surrounding 1 no. landscaped podium garden with play equipment, off street car parking totalling 80 no. spaces accessed via new vehicular access on Park Street, 43 no. on-street car parking spaces (10 no. spaces on Park Street, 13 no. spaces on Friars' Street, 10 no. spaces on Main Street/Lake Street and 10 no. spaces on proposed Park Lane), 200 no. bicycle parking spaces at ground floor level and associated elevational signage to all retail/commercial units; - Block 13 containing a total of 187 no. residential build to rent apartments comprising 58 no. 1 beds, 115 no. 2 beds and 14 no. 3 beds, all apartments with private balconies/terraces to north, south, east and west elevations, in 3 no. buildings ranging from 5-7 storeys in height, with ancillary residential amenity facilities as follows: games room, gym, conference room, amenity room, laundry, bulk store and guest suites; 6 no. retail units and 1 no. cafe/restaurant all at ground floor level, 5 no. floors of commercial office suites at first to fifth floor level, 1 no. landscaped roof deck at fifth floor level to serve offices, 1 no. ESB substation at ground floor level, surrounding 1 no. landscaped podium garden with play equipment, off street car parking totalling 97 no. spaces accessed via new vehicular access on Lake Street, 26 no. on-street car parking spacess (8 no. spaces on Dargan Street, 11 no. spaces on Clongriffin Road and 7 no. spaces on Lake Street); 234 no. bicycle parking spaces (20 no. on street and 214 no. at ground floor level) and associated elevational signage to all retail/commercial units; - Block 15 containing a total of 92 no. residential apartments comprising 38 no. 1 beds and 54 no. 2 beds, all apartments with private balconies/terraces to north, south, east and west elevations, in 2 no. buildings ranging from 3 to 6 storeys in height, with ancillary residential amenity facilities; 1 no. 8 screen cinema, 5 no. retail units and 3 no. cafes/restaurants at ground floor level, 1 no. retail unit split over ground and first floor level, 1 no. ESB substation at ground floor level, surrounding 1 no. landscaped podium garden, off street car parking totalling 50 no. spaces accessed via new vehicular access on Market Lane, 32 no. on-street car parking spaces (23 no. spaces on Market Lane and 9 no. spaces on Main Street); 201 no. bicycle parking spaces (20 no. street and 181 no. at ground floor level) and associated elevational signage to all retail/commercial units. The proposed development provides for a total of 328 no. car parking spaces and 635 no. bicycle spaces all across surface and undercroft levels. Planning permission is also sought for landscaping, roads, footpaths, boundary treatments and all associated engineering and site works necessary to facilitate the development. An Environmental Impact Assessment Report has been prepared in respect of the proposed development.",
        "address": "Lands at Clongriffin, Dublin 13 on plots known as 3, 13 and 15, located to the south of Park Street, east of Friars' Street and north of Main Street (plot 3) to the north of Market Street, south of Dargam Sreet, east of Lake Street and west of Clongriffin",
        "Applicant": null,
        "received": "2019-11-29",
        "status": null,
        "decision_date": "2020-01-31",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.40346641,
        "longitude": -6.153390295,
        "last_updated": "2020-02-15",
        "area ha": 2.96,
        "no of units": 420,
        "agent": "Downey Planning",
        "owner": "Gerard Gannon Properties",
        "apartments": 420,
        "houses": 0,
        "student": null,
        "studio": null,
        "apt.1_bed": 127,
        "apt.2_bed": 273,
        "apt.3_bed": 20,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Not clear if there was an ABP SHD application\r\nPart of a much larger 1000+ unit developement",
        "ref": "3894/19"
      },
      "uid": "26679db3795fede9197e4bbfbd0d7546",
      "id": 68
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.095082787,
          53.530990881
        ]
      },
      "properties": {
        "uid": "272fbc55d1456139ac532c6838a5c863",
        "25PLUS": "need to add ABP list\r\nhttp://www.pleanala.ie/casenum/305534.htm",
        "la": "fingal",
        "file_num": "SHD/003/19",
        "url": "http://planning.fingalcoco.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=SHD/003/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "To view the full Strategic Housing Development Application, please visit www.skerriesroadrushshd.ie The development will consist of a residential development of 165 No. units, comprising 117 No. houses and 48 No. apartments. The houses comprise of 28 No. two bed units, 65 No. 3 bed units, and 24 No. 4 bed units. The houses include 7 No. housing typologies comprising of 2 storey typologies (typologies 1, 2, 3, 4, 5 and 6) and a 3 storey typology (typology 7). The apartments comprise of 19 No. 1 bed units and 29 No. 2 bed units located in 2 no. three storey blocks to the North-West of the application site, bounded by Palmer Road and Palmer Avenue. The development also includes 294 No. surface car parking spaces, 118 No. bicycle parking spaces, public open space including a children's playground, new vehicular entrances to Skerries Road and Palmer Avenue including new signalised junction at Skerries Road, internal vehicular routes including a new East-West link street, the widening and upgrade of Palmer Avenue to include footpaths and cycleways, ESB substations, all site services, refuse/bin stores, public lighting, boundary treatment, pedestrian/cycle linkages to St. Maur's Park to the South and Palmer Court to the North, repair and making good of retained elements of the existing boundary wall to Skerries Road, re-use on-site of material from the boundary wall to Skerries Road required to be removed to facilitate the site entrance, removal of existing bus stop on Skerries Road adjacent to site, and all other associated and ancillary development/works. The total gross floorspace of the development is circa 16,983 sq.m The application contains a statement setting out how the proposal will be consistent with the objectives of the Fingal Development Plan 2017/2023. The site area is 4.845 hectares. All submissions to be made to An Bord Pleanála, Ref: ABP-305534-19.",
        "address": "Lands at Skerries Road, Palmer Road, Palmer Avenue &, St. Maur's Park, Rush, Co Dublin",
        "Applicant": "The Skerries Road Partnership",
        "received": "2019-09-27",
        "status": null,
        "decision_date": null,
        "decision_due": null,
        "decision_code": null,
        "decision": "none",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.53099088,
        "longitude": -6.095082787,
        "last_updated": null,
        "area ha": 4.8,
        "no of units": 165,
        "agent": "Virtus",
        "owner": "The Skerries Road Partnership",
        "apartments": 48,
        "houses": 117,
        "student": null,
        "studio": null,
        "apt.1_bed": 19,
        "apt.2_bed": 29,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": 28,
        "house.3_bed": 65,
        "house.4_bed": 24,
        "house.4+_bed": null,
        "other notes": "Doesn't appear to be any other developments",
        "ref": "SHD/003/19"
      },
      "uid": "272fbc55d1456139ac532c6838a5c863",
      "id": 69
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.29029515,
          53.335157547
        ]
      },
      "properties": {
        "uid": "2c08ac8405cfb001ff510d9dea3fa7be",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "3853/17",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=3853/17&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "The application site is bound by Dolphin's Barn Street to the east, No. 51 Dolphin's Barn Street to the north east, No. 7 Poole Terrace to the south and boundaries of rear gardens of the residential properties located on Reuben Street and Emerald Square to the west and north of the application site. The proposed development will consist of the demolition of the existing former factory building to the rear of the site and buildings which front onto Dolphin's Barn Street (Nos. 43-50) which have a total gross floor area (GFA) of 3,243.5 sq.m, and the construction of a part four to part seven storey residential and retail building to Dolphin's Barn Street, stepping down to three storeys to the rear, over basement and ground floor retail and car park. The total gross floor area including basement car parking of the new mixed use building is 13,150 sq.m. The proposed development comprises 1 no. retail unit at ground floor level with a total GFA of 1,405 sq.m and 70 no. apartments from first to sixth floor level comprising 41 no. 1 beds and 29 no. 2 beds (proposed as Build to Let accommodation). The proposal includes two residential entrances at ground floor level and communal facilities (with a GFA of 410 sq.m) at first floor to sixth floor level. Balconies are provided for the residential apartments on the eastern, western, southern and northern elevations. Vehicular access is provided from Dolphin's Barn Street and the development includes a total of 67 no. car parking spaces at basement level and 18 no. car parking spaces, a bike store providing 80 no. bicycle parking spaces and a bin store at ground floor level. The proposal also includes landscaping works including a communal open space area at first floor level measuring 693 sq.m and all associated site development works.",
        "address": "43-50, Dolphin's Barn Street, Dublin 8",
        "Applicant": null,
        "received": "2018-05-31",
        "status": null,
        "decision_date": "2018-06-27",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.33515755,
        "longitude": -6.29029515,
        "last_updated": "2018-07-14",
        "area ha": 3.3,
        "no of units": 70,
        "agent": "John Spain Associates",
        "owner": "Majick Hour Limited",
        "apartments": 70,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 41,
        "apt.2_bed": 29,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Residential only",
        "ref": "3853/17"
      },
      "uid": "2c08ac8405cfb001ff510d9dea3fa7be",
      "id": 70
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.179842836,
          53.408985331
        ]
      },
      "properties": {
        "uid": "2f685fb95108c675f6b9d8dc80a21ce8",
        "25PLUS": "yes",
        "la": "fingal",
        "file_num": "F18A/0167",
        "url": "http://planning.fingalcoco.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=F18A/0167&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Modifications to previously granted planning application Reg. Ref. F15A/0093 (An Bord Pleanala Ref. No. PL06F.245710) includes the omission of 6 no. 4 bed detached houses (Type B), to be replaced with 6 no. 3 bed terraced houses (Type A). In addition, permission is sought for the construction of 12 No. 3 bed terraced houses (Type A). Permission for change of use from residential to licenced betting shop including a new rear and side extension totalling 44 sq.m. with external lighting, signage, shopfront alterations, satellite dishes to rear along with all associated plant to rear. Change of use from licensed bar at first floor level over existing ground floor public house, to 1 No. 5 bed apartment, with new entrance door and access stairs from the rear of the public house, together with associated balcony to rear and internal modifications. All with associated site layout modifications, car parking and site works. Add Info received 5th July 2018. Revised Public Notices received 5th July 2018.",
        "address": "Campions Public House, its carpark and lands to its rear, Malahide Road, Balgriffin, Co. Dublin.",
        "Applicant": "Crosswaithe Developments",
        "received": "2018-03-29",
        "status": "Decision Made by Fingal County Council",
        "decision_date": "2018-07-31",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.40898533,
        "longitude": -6.179842836,
        "last_updated": "2018-08-18",
        "area ha": 1.83,
        "no of units": 55,
        "agent": "CDP Architecture ",
        "owner": "Crosswaithe Developments",
        "apartments": 1,
        "houses": 54,
        "student": null,
        "studio": null,
        "apt.1_bed": null,
        "apt.2_bed": null,
        "apt.3_bed": null,
        "apt.4_bed": 0,
        "apt.4+_bed": 1,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": 48,
        "house.4_bed": 7,
        "house.4+_bed": null,
        "other notes": "Retail 440 sqm",
        "ref": "F18A/0167"
      },
      "uid": "2f685fb95108c675f6b9d8dc80a21ce8",
      "id": 71
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.163615934,
          53.399850774
        ]
      },
      "properties": {
        "uid": "35ce89a6c12641af4b25e50b089133ba",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "3403/18",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=3403/18&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Planning permission on lands at the former Columban Missionary site, The Hole in the Wall Road and the R139 Road, Donaghmede, Dublin 13, for revisions to a previously permitted mixed-use residential development (previously granted under Reg. Ref. 2854/17; ABP Ref. PL29N.249368) to now provide for a 'Build to Rent' scheme. The proposed revisions shall consist of: (a) an increase of 22 no. apartments to now provide for a total of 225 no. residential units (comprising 113 no. 1 bedroom units; 102 no. 2 bedroom units; and 10 no. 3 bedroom units) within the 4 no. previously permitted blocks as follows: Block A - 5 Storey (Part 4 storey) block comprising of 78 no. residential units (43 no. 1 bedroom units; 33 no. 2 bedroom units; 2 no. 3 bedroom units) with balconies/terraces on the north, east, south and west elevations. Block B - 5 storey apartment block comprising 51 no. residential units (27 no. 1 bedroom units; 22 no. 2 bedroom units; 2 no. 3 bedroom units) with balconies/terraces on the north, east, south and west elevations. Block B will also comprise the previously permitted 1 no. concierge office; 1 no. community room (94sq.m. GFA); 1 no. gym (201 sq.m. GFA) and 1 no. childcare facility (248 sq.m. GFA) with ancillary outdoor play area (129 sq.m.), all of which will be at ground floor level; Block C - 5 storey apartment block comprising 25 no. residential units (7 no. 1 bedroom units; 16 no. 2 bedroom units; 2 no. 3 bedroom units) with balconies/terraces on the north and south elevations. Block D - 5 storey apartment block comprising 71 no. residential units (36 no. 1 bedroom units; 31 no. 2 bedroom units; 4 no. 3 bedroom units) with balconies/terraces on the north, east, south and west elevations; (b) associated elevational changes to Blocks A,B,C and D (c) provision of additional amenity facilities including children's play and recreational area at basement level; (d) reduction in basement level car parking spaces from 249 no. spaces to 151 no. spaces; (e) Increase in basement level bicycle parking spaces from 212 no. spaces to 348 no. spaces; (f) provision of new plant areas and refuse storage at basement level; and, (g) all associated engineering and site development works necessary to facilitate the development.",
        "address": "Lands at the former Columban Missionary site, Hole in the Wall Road and the R139 Road, Donaghmede, Dublin 13",
        "Applicant": null,
        "received": "2018-09-12",
        "status": null,
        "decision_date": "2018-10-09",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.39985077,
        "longitude": -6.163615934,
        "last_updated": "2018-10-27",
        "area ha": 1.3,
        "no of units": 225,
        "agent": "Downey Planning",
        "owner": "Midgard Construction Limited",
        "apartments": 225,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 112,
        "apt.2_bed": 103,
        "apt.3_bed": 10,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "creche 248 sqm\r\ngym 201 sqm\r\nPlay area 239 sqm",
        "ref": "3403/18"
      },
      "uid": "35ce89a6c12641af4b25e50b089133ba",
      "id": 72
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.441191015,
          53.284430313
        ]
      },
      "properties": {
        "uid": "3c207ce89a8ff75050aa8f665b6f5b33",
        "25PLUS": "yes",
        "la": "south dublin",
        "file_num": "SD18A/0368",
        "url": "http://www.sdublincoco.ie/Planning/Details?p=99&regref=SD18A%2F0368",
        "dev_desc": "Retention of the change of use of 32 apartments from short term tourist accommodation to residential use; associated internal works at ground level to convert fourteen 2 bedroom apartments to fourteen 1 bedroom apartments, including provision of study rooms and increased storage space together with works to provide increased storage space to two apartments; associated internal works at first and second floor (mezzanine) levels to provide enlarged bedrooms, new study rooms and increased storage space to sixteen apartments; associated works in increase the size of fourteen balconies on the southern facade of the building; retention of vehicular access to the development from Church Road via the laneway to the south of the site; associated ground level site and landscaping works including the provision of new or enlarged gardens to the ground floor apartments, reduction in the number of parking spaces from 38 to 29 spaces, removal of associated hard surfacing and the provision of communal open space measuring 711sq.m including a children's play area, cycle parking for up to 32 bicycle and hard and soft landscaping.",
        "address": "The Round Garden Apartments, Church Road, Saggart, Co. Dublin",
        "Applicant": "Search 4 Alpha CVBA",
        "received": "2018-10-10",
        "status": null,
        "decision_date": "2018-12-03",
        "decision_due": "2018-12-04",
        "decision_code": "GRANT PERMISSION & GRANT RETENTION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.28443031,
        "longitude": -6.441191015,
        "last_updated": "2020-02-15",
        "area ha": 0.37,
        "no of units": 32,
        "agent": "John Spain Associates",
        "owner": "Search 4 Alpha CVBA",
        "apartments": null,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 14,
        "apt.2_bed": 18,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "no other development",
        "ref": "SD18A/0368"
      },
      "uid": "3c207ce89a8ff75050aa8f665b6f5b33",
      "id": 73
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.3078132,
          53.34658178
        ]
      },
      "properties": {
        "uid": "3e0296e31f4d48594fb1dce873a89776",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "4660/18",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=4660/18&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "The site is generally bound to the east and south by the existing Clancy Quay mixed-use development, to the west by the South Circular Road, and to the north by Riverbank House apartment building. The proposed development will consist of the demolition of The Black And Amber Inn (1-2 storey building, c.602m2 GFA) and basement vault (c.201m2 GFA) and construction of a 6 storey over ground mixed-use building (c.1,247m2GFA) to accommodate at 1st to 5th floor levels, 20 no. studio apartments each with a private balcony; at ground floor level, a commercial unit (c. 88m2 GFA) fronting onto South Circular Road, and , all associated and ancillary site development works,landscaping and boundary treatments, including a bin store (c.21m2), bike store (c.17m2 and providing 20 no. covered bicycle parking spaces), 3 no. under croft car parking spaces accessed directly from Hospital Lane, 10 no. external bicycle parking spaces; a canopy above the residential entrance on the southern elevation; at roof level, 49 no. solar PV Panels and lift overrun; reconfiguration of Hospital Lane east of the access to Riverbank House to provide vehicular access to the proposed car parking spaces, replace the existing footpath (c.0.96m wide) on the southern edge of the carriageway with a wider footpath (c.1.3m wide), and to replace the existing footpath (c.0.8m wide) on the northern edge of the existing carriageway with grass verge (c. 0.5m wide), resulting in a wider carriageway (c.4.8m wide); re-surfacing works to Hospital Lane; a temporary turning head and landscaped area, to be subject of future permanent works under a separate planning permission; new taxi set down/loading area on South Circular Road and associated reconstruction of existing steps and part of wall at south western corner of the site; all on a site c.991.7m2.",
        "address": "The Black And Amber Inn, 778, South Circular Road and Hospital Lane, Islandbridge, Dublin 8",
        "Applicant": null,
        "received": "2019-03-12",
        "status": null,
        "decision_date": "2019-04-08",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.34658178,
        "longitude": -6.3078132,
        "last_updated": "2020-06-20",
        "area ha": 0.6,
        "no of units": 20,
        "agent": "Stephen Little & Associates",
        "owner": "KW PRS ICAV",
        "apartments": 20,
        "houses": null,
        "student": null,
        "studio": 20,
        "apt.1_bed": null,
        "apt.2_bed": null,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Commercial 87.5sqm",
        "ref": "4660/18"
      },
      "uid": "3e0296e31f4d48594fb1dce873a89776",
      "id": 74
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.247818136,
          53.319740813
        ]
      },
      "properties": {
        "uid": "75dee5f4f447840cf3f46c3d6b2c70df",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "2189/20",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=2189/20&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "PROTECTED STRUCTURE: Permission for development on lands at Sandford Lodge (a Protected Structure), Sandford Close, Sandford Road, Dublin 6. The development will consist of the demolition (total c. 392 sqm GFA) of Block 5 (1 storey) and Block 6 (1 storey) (total 4 no. residential units) and the construction of a new residential scheme of 36 no. residential units in the form of 2 no. contemporary three storey terraces, comprising: 12 no. 1 bed A 1 storey (GIA c. 54.65 sqm) units, 12 no. 1 bed B 1 storey (GIA c. 57.76 sqm) units; and 12 no. 2 bed A 2 storey (GIA c. 110.29 sq.m) units. Each new residential unit has associated private open space in the form of a garden courtyard or terraces. Landscaping works to existing and proposed external amenity spaces (total c. 3,851 sq m) include an upgraded fire tender route with a wild flower meadow edge, a sunken garden area around the Protected Structure, a central formal garden and an outdoor seating area. The development shall be accessed via the existing vehicular access point from Sandford Close and will provide for the reconfiguration of the existing basement car park and surface level parking areas to comprise a total of 120 car parking spaces at basement level; 36 spaces at grade; 133 residential cycle parking spaces and 18 visitor cycle parking spaces. The proposed modifications reduce the total number of vehicle parking spaces on the overall site from 169 to 156 and increase the cycle parking spaces from 85 to 151. An ESB Meter room (c. 6 sqm) and bin store (c. 21.6 sqm) are proposed at surface level. The associated site and infrastructure works include provision for water services, foul and surface water drainage and connections; attenuation proposals; permeable paving; all landscaping works; boundary treatment; electrical services and associated ancillary works. All of the above within the overall Sandford Lodge residential development. The proposal and associated ancillary elements are located within he curtilage of a Protected Structure.",
        "address": "Lands at Sandford Lodge (a Protected Structure), Sandford Close, Sandford Road, Dublin 6",
        "Applicant": "KW PRS ICAV acting for and on behalf of its sub-fund KW PRS Fund 2",
        "received": "2020-02-03",
        "status": null,
        "decision_date": "2020-03-27",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.31974081,
        "longitude": -6.247818136,
        "last_updated": "2020-04-11",
        "area ha": 1.5,
        "no of units": 36,
        "agent": "Brock McClure Planning Consultants",
        "owner": "KW PRS ICAV acting for and on behalf of its sub-fund KW PRS Fund 2",
        "apartments": 36,
        "houses": 0,
        "student": null,
        "studio": null,
        "apt.1_bed": 24,
        "apt.2_bed": 12,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": null,
        "ref": "2189/20"
      },
      "uid": "75dee5f4f447840cf3f46c3d6b2c70df",
      "id": 75
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.233709765,
          53.349436814
        ]
      },
      "properties": {
        "uid": "c89d70e82661368e0b79b37b7c659571",
        "25PLUS": "yes - shd",
        "la": "dublin city",
        "file_num": "DSDZ2186/20",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=DSDZ2186/20&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "KW PRS ICAV acting for and on behalf of its sub-fund KW PRS Fund 11 intends to apply for permission at a site (c.1.55Ha) at City Block 3 and Northbank House, Sheriff Street Upper, New Wapping Street and Mayor Street Upper, North Lotts, Dublin 1 and otherwise generally bounded by Nos. 7-10 Mayor Street Upper to the south, Nos. 1-14 New Wapping Street to the west, and existing Northbank House, Alexandra Terrace and Castleforbes Road to the east. The development will consist of: - A residentially led development accommodated in 5no. residential blocks ranging from 2 to 7 storeys, sitting partially over single level basement, and at ground floor of existing Northbank House (c.37,358.1 sq.m gross floor area excluding basement c. 5,410.5 sq.m gross floor area), to accommodate: 472no. residential units in total, comprising 463no. 'Build-to-Rent' apartments (65no. 1-bed studios, 217no. 1-beds, 179no. 2-beds, 2no. 3-beds) and 9no. 2-bed houses; residential amenities (c.805 sq.m gross floor area) in proposed Block 3B1 and basement; 1no. café/restaurant (c.111.4sq.m gross floor area) in proposed Block 3B1; and, reconfiguration and change of use of existing retail/commercial floor area in Northbank House to provide a childcare facility (c. 343sq.m gross floor area) and associated external play area. Proposed accommodation by block is as follows: - Block 3A1 (c. 8,060.7 sq.m gross floor area) fronting Sheriff Street Upper and New Wapping Street, comprises a 7-storey apartment building accommodating 106no. 'Build-to-Rent' residential apartments (15no. studios, 53no. 1-beds, 37 no. 2-beds and 1no. 3-bed); Block 3A2 (c.9,825.8 sq.m gross floor area) fronting Sheriff Street Upper, comprises a 7-storey apartment building accommodating 124no. 'Build-to-Rent' residential apartments (6no. studios, 69no. 1-beds, 48no. 2-beds and 1no. 3-bed); Block 3B1 (c.9,054.4 sq.m gross floor area) fronting Sheriff Street Upper and north of the previously approved new civic park, comprises a 7-storey apartment building accommodating 102no. 'Build-to-Rent' residential apartments (25no. studios, 24no. 1-beds and 53no. 2-beds). This building includes resident amenities (c. 697 sq.m gross floor area) at ground and first floor levels, and a café (c.111.4sq.m gross floor area) at ground floor level; Blocks 3D2/3E2 (c.9,556.2 sq.m gross floor area) fronting Mayor Street Upper and west of the proposed new civic park, comprises a 3 to 6 storey apartment building accommodating 131 no. 'Build-to-Rent' residential apartments (19no. studios, 71no. 1-beds and 41 no. 2-beds); Block 3D1 (c.861 sq.m gross floor area) located to the rear (east) of the existing houses fronting New Wapping Street and west of proposed Block 3D2/3E2, comprises 9no. 2 storey 2-bed houses. Residential balconies are provided on elevations of the apartment blocks (3A1, 3A2, 3B1 and 3D2/3E2). Private rear gardens are provided at ground floor level to the Block 3D1 houses. All associated and ancillary site development works, hard and soft landscape, boundary treatment works, including: - New external residential courtyards and roof terrace amenity areas; new civic park located centrally within the city block (c.2,259 sq.m), previously approved under DCC Reg. Ref. DSDZ4112/19; new internal east-west street and north-south (pedestrian/cycle) streets, previously approved under DCC Reg. Ref. DSDZ2464/19; 102no. car parking spaces, including 101no. spaces at basement level and 1no. space at surface level; 511no. bicycle parking spaces, including 463no. at basement level and 48no. at surface level; new vehicular access to the basement car park from New Wapping Street, previously approved under DCC Reg. Ref. DSDZ2464/19; basement storage, service and plant areas; provision of a bin store (c.37.9 sq.m gross floor area) between Blocks 3D1 and 3D2/3E2, previously approved under DCC Reg. Ref. DSDZ2464/19; provision of 4no. ESB sub-stations; public realm works along Sheriff Street Upper, New Wapping Street and Mayor Street Upper, including revised landscape treatment to new north-south street between Block 3B1 and Northbank House, previously approved under DCC Reg. Ref. DSDZ2642/16. This application relates to a proposed development within the North Lotts & Grand Canal Dock Strategic Development Zone Planning Scheme Area.",
        "address": "City Block 3 and Northbank House, Sheriff Street, New Wapping Street and Mayor Street Upper, North Lotts, Dublin 1",
        "Applicant": null,
        "received": "2020-01-31",
        "status": null,
        "decision_date": "2020-03-26",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.34943681,
        "longitude": -6.233709765,
        "last_updated": "2020-04-11",
        "area ha": 1.5,
        "no of units": 472,
        "agent": "Stephen Little &Associates",
        "owner": "KW PRS ICAV acting for and on behlf of sub-fund KW PRS Fund 11",
        "apartments": 398,
        "houses": 9,
        "student": null,
        "studio": 65,
        "apt.1_bed": 217,
        "apt.2_bed": 179,
        "apt.3_bed": 2,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": 9,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Creche ",
        "ref": "DSDZ2186/20"
      },
      "uid": "c89d70e82661368e0b79b37b7c659571",
      "id": 76
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.233796053,
          53.332193375
        ]
      },
      "properties": {
        "uid": "42ee4dc13fbf9d64f48dabed3b414075",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "3502/19",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=3502/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Permission for development at a site (c.1.73ha) at the Ballsbridge Hotel, Pembroke Road, Ballsbridge, Dublin 4 bounded generally by Lansdowne Road to the north, Lansdowne Place development (currently under construction) to the east, Pembroke Road to the west and One Ballsbridge to the south, at Ballsbridge, Dublin 4. The development will consist of a scheme of residential, hotel, retail, non-retail services, licenced restaurants, bars, cafes and ancillary uses above and below ground (81,024.7sq.m gross floor area), comprising: The demolition of structures on site (excluding the primarily retained external posts, plinths and railings around the site perimeter to the public road)(approximately 35,500sq.m); The construction of 7 no. buildings (Blocks 1, 2, 8, 9, 10, 11 primarily residential and inter-linked; Block 12 primarily hotel) over a 2 level basement, comprising: 313 no. residential units (42,794.8 sq.m including arcaded walkways); a 152 no. bedroom hotel (8,185sq.m, including leisure/spa facility, conference facilities, and restaurant and bar facilities above and below ground floor level); an anchor retail unit (2,444.2 sq.m gross); licenced restaurants, cafes and bars (1,540.3sq.m, 7 no. in total); 7 no. retail (including an off-licence)/commercial/non-retail service units (1,399.9sq.m, to accommodate Use Class 1 and 2 uses such as retail, professional/financial services); and ancillary plant, circulation and landscaped areas. The basement levels will accommodate 636 no. car spaces, 32 no. motorcycle spaces and 458 no. bicycle spaces together with circulation, storage and services areas (24,351sq.m). 76 no. bicycle spaces are also provided at surface level within the proposed public realm. Vehicular access to the development (including to basement) is provided from Pembroke Road. A pedestrian entrance, together with a vehicular entrance to cater for residents' drop-off facility and emergency access is provided from Lansdowne Road. The basement connects at L-1 and L-2 with the already constructed basement under the adjoining Lansdowne Place development which is separately accessed at present from both Shelbourne Road and Lansdowne Road. The residential units are accommodated in Blocks 1, 2, 8, 9, 10, 11 (313 no. residential units comprising: 33 no. 1-bed apartments; 249 no. 2-bed apartments; 4no. 2-bed apartments with study; 6 no. 2-bed duplex apartments; 12 no. 3-bed apartments; 2 no. 3-bed apartments with study; 5 no. 3-bed duplex apartments; 2 no. 4-bed apartments): (Blocks 1, 2 and 11 are over a Lower Ground Floor level to accommodate duplex units.) Block 1 has a shoulder level of 8 storeys stepping up to 9 storeys and contains a licenced restaurant/café use at ground floor level with residential use over (21 no. apartments); Block 2 has a shoulder level of 8 storeys stepping up to 9 storeys and is in residential use (24 no. apartments); Blocks 8-11 are centred around the feature courtyard gardens over the ground floor anchor retail unit; Blocks 8, 9 and 10 have a shoulder height of 8 storeys stepping up to 9 storeys (stepping from 7 to 8 storeys within the courtyard) with a feature 13 storey landmark element at the corner of Block 8; Blocks 8, 9 and 10 contain retail/non-retail service/licenced restaurant/café/bar uses at ground floor level with residential uses over (Block 8 -70 no. apartments; Block 9 - 42 no. apartments; Block 10 - 46 no. apartments); Block 11 has a shoulder height of 9 storeys stepping up to 10 storeys (stepping from 8 storeys to 9 storeys within the courtyard) and contains retail/non-retail service/licenced restaurant/café/bar and residential uses at ground floor level with residential uses over (110 no. apartments); Block 12 has an overall height of 10 storeys and contains the 152 no. bedroom hotel with associated facilities including a licenced restaurant/bar at 9th floor level and retail/non-retail service, licenced restaurant/café/bar uses at ground floor level, together with conference and leisure facilities at Basement Level -1. The development will also consist of: vehicular connections at Basement Levels -1 and -2 to adjoining basement of previously permitted mixed-use scheme (under construction) at 'Lansdowne Place' - Dublin City Council Reg. Ref. 4015/09 (An Bord Pleanala Ref. PL29S.237454), as revised by subsequent permissions, Dublin City Council Reg. Refs. 4344/15, 2244/16, 2578/16, 2849/16, 3386/16, 3468/16, 3532/16, 4369/16, 2853/17, 4601/17 and 3620/18; the provision of private, semi-private, and public open spaces, and external circulation areas in the form of winter-gardens, balconies, garden areas including a raised courtyard green, roof terraces, a public plaza, and covered and open pedestrian streets and paths; all hard and soft landscaping including boundary treatments (including alterations to parts of the external posts, plinths and railings), changes in level; substations; plant; and all other associated site excavation and site development works above and below ground. Works to the external pavement will consist of new paving, lay-bus, set-down and taxi facilities.",
        "address": "The Ballsbridge Hotel, Pembroke Road, Ballsbridge, Dublin 4",
        "Applicant": null,
        "received": "2019-07-16",
        "status": null,
        "decision_date": "2019-09-09",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.33219337,
        "longitude": -6.233796053,
        "last_updated": "2019-09-28",
        "area ha": 1.73,
        "no of units": 313,
        "agent": "Stephen Little & Associates",
        "owner": "Copper Bridge C2015 ICAV",
        "apartments": 313,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 59,
        "apt.2_bed": 259,
        "apt.3_bed": 19,
        "apt.4_bed": 2,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Retail / Commercial 3844 sqm\r\nRest/Cafe/Bar 1540 sqm\r\nHotel 5604 sqm",
        "ref": "3502/19"
      },
      "uid": "42ee4dc13fbf9d64f48dabed3b414075",
      "id": 77
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.2405005,
          53.32753409
        ]
      },
      "properties": {
        "uid": "4343d2377e9a632adbb769df9da0d7c9",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "2424/19",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=2424/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Planning permission at this site of c. 0.34 hectares. The proposed development will consist of: 1) Demolition of non-original extensions to St. Mary's Home and ancillary structures on site; 2) Alterations to and change of use of the existing St. Mary's Home (nursing home) building to residential use, including internal and external alterations, elevational alterations, provision of terraces at second floor level and balconies at first floor level, to provide 9 no. residential units; 3) Construction of new 2, 3 and 4 storey structures to the north and east of the existing St. Mary's Home, including balconies and private open space, to provide 15 no. residential units; 4) The proposed development will provide a total of 24 no. residential apartment units comprising of 3 no. 1 bed apartments, 16 No 2 bed apartmentsand 5 no. 3 bed apartments; 5) Provision of a basement level to accommodate car parking (25 no. spaces, including car stacker system), bin storage areas, plant, and service cores; 6) 2 no. accessible parking spaces are provided at ground floor level, along with cycle parking (46 no. spaces); 7) The development includes all associated site development works, solar panels at roof level, bin store, hard and soft landscaping, boundary treatments, widening of vehicular access from Pembroke Park, pedestrian access from Clyde Lane and Pembroke Park, foul and surface water drainage, and all other ancillary works, including temporary site hoarding and marketing signage.",
        "address": "St. Mary's Home, Pembroke Park and 28A, Clyde Lane, Dublin 4",
        "Applicant": null,
        "received": "2019-06-07",
        "status": null,
        "decision_date": "2019-07-04",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.32753409,
        "longitude": -6.2405005,
        "last_updated": "2019-07-20",
        "area ha": 0.34,
        "no of units": 24,
        "agent": "John Spain Associates ",
        "owner": "The Pembroke Road Partnership",
        "apartments": 24,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 3,
        "apt.2_bed": 16,
        "apt.3_bed": 5,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "No other developments",
        "ref": "2424/19"
      },
      "uid": "4343d2377e9a632adbb769df9da0d7c9",
      "id": 78
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.202959859,
          53.442223413
        ]
      },
      "properties": {
        "uid": "45542332578910eb4b6a7845ab79993b",
        "25PLUS": "yes",
        "la": "fingal",
        "file_num": "F18A/0352",
        "url": "http://planning.fingalcoco.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=F18A/0352&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "The development will consist of 34 no. residential dwellings comprising of 20 no. 3-bed, 3 storey, terraced and semi-detached houses; 7 no. 2-bed ground floor apartments with 7 no. 3-bed duplex units above (all in a 3-storey terrace), together with ancillary parking (70 no. spaces); open space; new vehicular entrance onto Drynam Green; internal access road; pedestrian linkages to Feltrim Road and Kettles Lane; together with ancillary site infrastructure, landscaping and boundary treatments and all associated site and development works. The proposed development facilitates the continuation of the public footpath along Feltrim Road, Kettles Lane and Drynam Road, and a cycle lane along Kettles Lane.",
        "address": "Drinan, (generally bound by Feltrim Road to the east, Kettles Lane to the south and Drynam Green to the west, Swords, Co. Dublin.",
        "Applicant": "Ardstone Homes Ltd.",
        "received": "2018-06-22",
        "status": "Decision Made by Fingal County Council",
        "decision_date": "2018-08-16",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.44222341,
        "longitude": -6.202959859,
        "last_updated": "2018-09-01",
        "area ha": 0.934,
        "no of units": 34,
        "agent": "Declan Brassil",
        "owner": "Ardstone Homes Ltd. ",
        "apartments": 14,
        "houses": 20,
        "student": null,
        "studio": null,
        "apt.1_bed": null,
        "apt.2_bed": 7,
        "apt.3_bed": 7,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": 20,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "No other development",
        "ref": "F18A/0352"
      },
      "uid": "45542332578910eb4b6a7845ab79993b",
      "id": 79
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.178889345,
          53.409831828
        ]
      },
      "properties": {
        "uid": "4c14ff7e7075e8c31b94de0a2e883b96",
        "25PLUS": "yes",
        "la": "fingal",
        "file_num": "F18A/0735",
        "url": "http://planning.fingalcoco.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=F18A/0735&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Demolition of the two existing office blocks (Balgriffin House and Glandore House), 'The Cottage' (residential dwelling) and related outbuildings; and the construction of a residential apartment scheme with a gross floor area of c.5,749sq.m. in 2 no.blocks with an overall height of 4 storeys( with roof mounted solar collector panels and rooftop plant, which is setback and screened); comprising 59 no. residential apartments (consisting of 22 no. one-bedroom units, 30 no. two-bedroom units and 7 no. three-bedroom units); creation of a new vehicular access from Carr's Lane to the north (and removal of existing vehicular access from Malahide Road at the northeast corner of the site); creation of new pedestrian access points from Malahide Road to the east; communal open space (c.700 sq.m.) at ground floor level including provision of a dedicated children's play space; external bin storage; 68 no. car parking spaces (including 2 no. disabled spaces) and 144 no. cycle car parking spaces. The overall development will also include a new ESB substation; hard and soft landscaping; changes in level; boundary treatments; drainage works; communal refuse storage areas; internal roads; pedestrian footpaths and lighting; and all associated site development and excavation works above and below ground. Add Info received 29th March 2019.",
        "address": "Sth/West corner, junction Malahide Rd/Carr's Lane, Balgriffin, Dublin 17",
        "Applicant": "Carrs Lane Ltd.",
        "received": "2018-12-19",
        "status": "Decision Made by Fingal County Council",
        "decision_date": "2019-04-24",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.40983183,
        "longitude": -6.178889345,
        "last_updated": "2019-05-11",
        "area ha": 0.72,
        "no of units": null,
        "agent": "Tom Phillips & Associates",
        "owner": "Carrs Lane Ltd",
        "apartments": 50,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 22,
        "apt.2_bed": 30,
        "apt.3_bed": 7,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "no other dev",
        "ref": "F18A/0735"
      },
      "uid": "4c14ff7e7075e8c31b94de0a2e883b96",
      "id": 80
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.23664737,
          53.321081
        ]
      },
      "properties": {
        "uid": "4f0a272d5843a204056811e003d0d7ed",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "2412/19",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=2412/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "PROTECTED STRUCTURE: Permission for development on a site of approximately 0.26 hectares at the site of the former Donnybrook Laundry at the Crescent, Donnybrook, Dublin 4, D04 R856 and No. 17 The Crescent, Donnybrook Road, Dublin 4, D04 A6Y7. (A Protected Structure is located within the site: a chimney stack (RPS Ref. 8713) under the Dublin City Development Plan 2016-2022). The site is principally bounded by: the residential development 'Donnybrook Manor' and other terrace dwellings to the north; 'The Crescent' laneway (formerly known as Church Lane) a graveyard and Donnybrook Garda Station to the east; and by the lands associated with St. Mary's Convent to the south and west. The development will consist of the demolition of structures on site (1.166 sq.m gross floor area) other than: the chimney stack (Protected Structure RPS 8713; a two-storey building located at the south-eastern corner of the site identified as Building 03 on the Architects' drawings) (390 sq. m gross floor area); and No. 17 The Crescent, Donnybrook Road, Dublin 4, D04 A6Y7 (an existing two-storey terraced dwelling) (115 sq.m gross floor area). The development will also consist of the construction of a residential scheme arranged in 3 No. new three-four storey blocks with habitable attic accommodation (identified at Buildings 01, 02 and 04 on the Architects' drawings (3,966 sq.m gross floor area) over basement (1,910 sq. m) and within the refurbished and adapted existing Building 03 (659 sq.m gross floor area) (with interventions to Building 03 including: provision of openings within the eastern, southern and western elevations to provide new windows and access points; and provision of a new roof) providing 44 no. apartments (comprising 11 no. one-bedroom apartments, 27 no. two-bedroom apartments, 5 no. two-bedroom duplex apartments and 1 no. three-bedroom duplex apartment). The proposed development will also consist of the provision of: ancillary floor areas over all floor levels (ancillary space includes areas such as circulation cores (lifts and stairs) and plant areas throughout the building, etc.); a central atrium (including circulation areas at all floor levels) with a glazed roof; a roof garden on Building 02 (153 sq.m); private (including terraces and balconies), communal and public open space areas; residents' storage facilities; waste storage facilities; vehicular and pedestrian access / egress and associated circulation routes (including a ramp to basement level; 46 no. car parking spaces (including 3 no. accessible spaces) at basement level; 80 no. bicycle spaces; 2 no. motorbike spaces; electric vehicle changing points; an ESB substation and switchroom; boundary treatments (including sections of new boundary wall); the widening and improvement of the existing vehicular entrance to the property from The Crescent; revised car parking arrangement and landscape design to the front of No. 17 The Crescent; provision of artwork; lighting; all hard and soft landscaping; the provision of Sustainable Urban Drainage systems (SUDs); and all other associated site excavation, infrastructural and site development works above and below ground, including changes in level and associated retaining features, boundary treatment and associated site servicing (foul and surface water drainage and water supply).",
        "address": "The former Donnybrook Laundry at The Crescent, Donnybrook, Dublin 4, D04 R856 and No. 17 The Crescent, Donnybrook Road, Dublin 4 D04 A6Y7",
        "Applicant": null,
        "received": "2019-07-26",
        "status": null,
        "decision_date": "2019-08-22",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.321081,
        "longitude": -6.23664737,
        "last_updated": "2019-09-07",
        "area ha": 0.26,
        "no of units": 49,
        "agent": "Tom Phillips & Associates",
        "owner": "Pembroke Partnership Limited",
        "apartments": 45,
        "houses": 4,
        "student": null,
        "studio": null,
        "apt.1_bed": 11,
        "apt.2_bed": 32,
        "apt.3_bed": 1,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": 4,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "No other developments",
        "ref": "2412/19"
      },
      "uid": "4f0a272d5843a204056811e003d0d7ed",
      "id": 81
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.064165038,
          53.386392503
        ]
      },
      "properties": {
        "uid": "53adc7cee7eabff1e1e7825289e97509",
        "25PLUS": "yes - shd\r\nhttp://www.pleanala.ie/casenum/301722.htm\r\nAnnulled\r\nDecision quashed by Order of the High Court",
        "la": "fingal",
        "file_num": "SHD/001/18",
        "url": "http://planning.fingalcoco.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=SHD/001/18&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "The demolition of existing structure on site including the disused sports building (c.604sq.m.) on the Balscadden Road site and former Baily Court Hotel Buildings on Main Street (c.2051sq.m.) and a reduction in ground levels. Construction of 164 no. residential units in 3 no. separate apartment blocks and 1 mews building, comprising 158 no. apartments and 6 duplexes which includes 40 no. 1 bed units, 97 no. 2 bed units and 27 no. 3 bed units. Provision 397 no. bicycle parking spaces and a total of 120 no. car parking spaces, which comprises 112 no. spaces in an underground basement in Block C and 8 no. on-street parking spaces. Provision of commercial/retail space (c. 757sq.m.), which includes a community room (c. 161sq.m.), 2 no. retail units (c.429sq.m and c. 96sq.m.) and a cafe (c.71sq.m.). The main vehicular entrance to the scheme will be from Main Street to serve the underground car park in Block C. The scheme provides for a new linear plaza which will create a new pedestrian link between Main Street and Balscadden Road to include the creation of an additional 2 no. public plazas and also maintains and upgrades the pedestrian link from Abbey Street to Balscadden Road below the Martello Tower. The public footpath on the opposite side of Balscadden Road will be widened for the length of the site as part of the development. All other ancillary site development works, site services, a sub-station, public lighting, plant, bin stores, bike stores, boundary treatments and landscaping. Commercial and retail signage (c. 75sq.m.) The application contains a statement setting out how the proposal will be consistent with the objectives of the Fingal County Development Plan 2017-2023. The application may be inspected, or purchased at a fee not exceeding the reasonable cost of making a copy, during the public opening hours at the following website set up by the applicant: www.howthshd.ie ALL OBJECTIONS / SUBMISSIONS TO BE SUBMITTED TO AN BORD PLEANALA.",
        "address": "Former Baily Court Hotel, Main Street, Lands located south of the Martello Tower, Balscadden Road, Howth, co. Dublin",
        "Applicant": "Crekav Trading GP Limited",
        "received": "2018-05-29",
        "status": "Decision Made by Fingal County Council",
        "decision_date": "2018-09-17",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.3863925,
        "longitude": -6.064165038,
        "last_updated": "2018-10-06",
        "area ha": 1.55,
        "no of units": 164,
        "agent": "Crekav Trading GP Limited",
        "owner": "Crekav Trading GP Limited",
        "apartments": 164,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 40,
        "apt.2_bed": 97,
        "apt.3_bed": 27,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": null,
        "ref": "SHD/001/18"
      },
      "uid": "53adc7cee7eabff1e1e7825289e97509",
      "id": 82
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.444604351,
          53.279840714
        ]
      },
      "properties": {
        "uid": "54d94daffb230ac837cd214f724ff2e3",
        "25PLUS": "yes",
        "la": "south dublin",
        "file_num": "SD18A/0202",
        "url": "http://www.sdublincoco.ie/Planning/Details?p=99&regref=SD18A%2F0202",
        "dev_desc": "Mixed use development will consist of 29 residential units(comprising 2 1-bed units; 16 2-bed units and 11 3-bed units (including terraces and balconies) an office unit (100sq.m), 2 retail units (87sq.m and 154sq.m), ancillary bin stores (16sq.m) and bike storage area (29sq.m) across 4 blocks (Blocks A to D); the breakdown for the individual Blocks is as follows: Block A (3 storeys (1,497sq.m), 7 apartments and 7 duplex apartments; Block B (3 storeys (851sq.m) 4 apartments and 4 duplex apartments; Block C (3 storeys (777sq.m), 6 apartments and 2 retail units and Block D (2 storey (243sq.m), the refurbishment, alteration and extension of the existing 2 storey former public house (including the demolition of a 3sq.m rear lean-to) and its change of use to 1 office unit and 1 apartment with new bin stores and bike store to the rear. The provision of private open space, communal and public open space; surface car parking (30 spaces); all hard and soft landscaping including boundary treatments; SUDS measures including attenuation tanks; PV panels; changes to levels and all other associated site excavation and site development works above and below ground. Vehicular access will be form Pairc Mhuire to the south. The existing perpendicular public parking on the north side of Pairc Mhuire will be replaced with 4 perpendicular car parking spaces on Pairc Mhuire and 2 parallel car parking spaces on the eastern side of Boherboy Road. The site is bounded by Main Street to the north, public open space to the east, Pairc Mhuire to the south and Boherboy Road to the west. it previously accommodated a petrol filling station and a public house (part of which remains on site).",
        "address": "0.42ha site at the junction of Main Street & Boherboy Road, Saggart, Co. Dublin.",
        "Applicant": "Thomas McMullan",
        "received": "2018-06-01",
        "status": null,
        "decision_date": "2018-11-22",
        "decision_due": "2018-11-22",
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.27984071,
        "longitude": -6.444604351,
        "last_updated": "2020-02-29",
        "area ha": 0.42,
        "no of units": 29,
        "agent": "Tom Phillips & Associates",
        "owner": "Thomas McMullan",
        "apartments": 29,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 2,
        "apt.2_bed": 16,
        "apt.3_bed": 11,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Office 100sqm\r\nRetail 243sqm\r\n",
        "ref": "SD18A/0202"
      },
      "uid": "54d94daffb230ac837cd214f724ff2e3",
      "id": 83
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.420873082,
          53.284197534
        ]
      },
      "properties": {
        "uid": "5f9cbd9769bec05b937c3e4c24a252fd",
        "25PLUS": "yes",
        "la": "south dublin",
        "file_num": "SD18A/0015",
        "url": "http://www.sdublincoco.ie/Planning/Details?p=99&regref=SD18A%2F0015",
        "dev_desc": "A residential development on a site area of 2.59ha at Citywest, Dublin 24 east of the N82 Citywest Road, north-west of Magna Park, north of undeveloped lands, south-west of Scoil Aoife and south of Fortunestown Lane. The proposed development consists of 52 No. 2 storey, 3 & 4 bedroom semi-detached and terraced houses and includes all associated site development and infrastructural works, car & bicycle parking, ESB sub-station, open spaces and landscaping. Access to the development will by via two vehicular entrances, i.e. the creation of a new entrance from Citywest Road and an extension to an existing entrance from Fortunestown Lane.",
        "address": "Magna Park, Citywest Road, Dublin 24",
        "Applicant": "Citywest Homes Developments Ltd.",
        "received": "2018-01-18",
        "status": null,
        "decision_date": "2018-07-10",
        "decision_due": "2018-07-11",
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.28419753,
        "longitude": -6.420873082,
        "last_updated": "2019-10-19",
        "area ha": 2.59,
        "no of units": 52,
        "agent": "Fenton & Associates",
        "owner": "Citywest Homes Developments Ltd",
        "apartments": null,
        "houses": 52,
        "student": null,
        "studio": null,
        "apt.1_bed": null,
        "apt.2_bed": null,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": 43,
        "house.4_bed": 9,
        "house.4+_bed": null,
        "other notes": "Residential Only",
        "ref": "SD18A/0015"
      },
      "uid": "5f9cbd9769bec05b937c3e4c24a252fd",
      "id": 84
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.268645157,
          53.371315152
        ]
      },
      "properties": {
        "uid": "5fe9dacac297e37a28deb8cf91413759",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "4554/17",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=4554/17&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "The development will consist of the provision of a new residential development consisting of (a) erection of 12 no. apartment units comprising 1 no. one-bedroom and 11 no. two-bedroom units with private terrace / balcony areas in 2 no. four-storey apartment buildings fronting Botanic Road, (b) erection of 19 no. houses comprising 16 no. four-bedroom and three no. three-bedroom units with private rear gardens (17 no. houses will also contain a terrace area to the front elevations), (c) 47 no. car parking spaces, bicycle parking and refuse area at basement level (with access to and from Botanic Road), (d) central courtyard area, (e) paving and landscaping works to include tree planting and provision of green areas, (f) restoration and upgrade works to the site boundaries, (g) re-orientation of existing footpath along Botanic Road, (h) installation of street lighting, (i) surface water and foul drainage, (j) demolition of 'The Addison Lodge' a two storey public house and 'Glasnevin Lodge', a two-storey house with attic floor level and all existing out-buildings and (k) all other site works necessary to facilitate the development.",
        "address": "The Addison Lodge' and 'Glasnevin Lodge', Botanic Road, Dublin 9",
        "Applicant": null,
        "received": "2018-06-29",
        "status": null,
        "decision_date": "2018-07-26",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.37131515,
        "longitude": -6.268645157,
        "last_updated": "2018-08-11",
        "area ha": 0.45,
        "no of units": 31,
        "agent": "Glasnevin SPV Limited",
        "owner": "Hughes Planning & Development",
        "apartments": 12,
        "houses": 19,
        "student": null,
        "studio": null,
        "apt.1_bed": 1,
        "apt.2_bed": 11,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": 3,
        "house.4_bed": 16,
        "house.4+_bed": null,
        "other notes": "No other development",
        "ref": "4554/17"
      },
      "uid": "5fe9dacac297e37a28deb8cf91413759",
      "id": 85
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.23586082,
          53.34952762
        ]
      },
      "properties": {
        "uid": "601829fe9bfabb73b795a95d82e77256",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "DSDZ4279/18",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=DSDZ4279/18&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Planning Permission for amendments to previously permitted development, Reg. Ref. DSDZ2896/18 at a site of 1.26 hectares located at City Block 2, Spencer Dock, Dublin 1. The site is bound by Sheriff Street Upper to the north, Mayor Street Upper to the south, New Wapping Street to the east and a development site to the west (also part of Block 2). The development site also includes the existing operational North Lotts Pumping Station and its associated infrastructure - the proposed development involved building adjacent to, and over, the Pumping Station. The application relates to a proposed development within a Strategic Development Zone Planning Scheme area. The proposed development comprises of amendments to previously permitted development DSDZ2896/18 comprising of: - Internal re-configuration of the previously permitted Block 1 and Block 2 to provide for 349 no. residential units (174 no. 1 beds and 175 no. 2 beds) increasing the permitted total from 322 no. 349 no. units; - Block 1 will comprise of 222 no. units (105 no. 1 beds and 117 no. 2 beds); - Block 2 will comprise of 127 no. units (69 no. 1 beds 58 no. 2 beds); - The revised block layout will result in amendments to all elevations including revised location and provision of private balconies/ terraces and revised resident amenity facilities; - Revised under croft layout and increase in area to include an increase in car parking spaces from 77 no. car parking spaces to 80 no. car parking and increase in bicycle parking from 462 no. spaces to 524 no. spaces and an increase in plant area; - Revised aparthotel layout to provide for 100 no. units (240 no. bed spaces); - Provision of mezzanine level between ground and first floor level to include an extension to the cafe space permitted at ground floor level and ancillary office area to serve the aparthotel development; - Provision of mezzanine level to 8 no. ground floor aparthotel units; - Revised landscaping and boundary treatment; - Revision to plant at roof level; - The proposed amendments will not result in an increase in the permitted maximum building height; - The development also includes, SUDS drainage, the provision of a green roof on both blocks and all associated site development work necessary to facilitate the development.",
        "address": "City Block 2, Spencer Dock, Dublin 1",
        "Applicant": null,
        "received": "2018-10-26",
        "status": null,
        "decision_date": "2018-12-18",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.34952762,
        "longitude": -6.23586082,
        "last_updated": "2019-01-05",
        "area ha": 1.26,
        "no of units": 349,
        "agent": "John Spain Associates",
        "owner": "Spencer Place Devlopment Company",
        "apartments": 349,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 174,
        "apt.2_bed": 175,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Class 4 commerical 6000 sqm",
        "ref": "DSDZ4279/18"
      },
      "uid": "601829fe9bfabb73b795a95d82e77256",
      "id": 86
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.224986763,
          53.343908577
        ]
      },
      "properties": {
        "uid": "659af4fe4cb34f0f68db698f95560c80",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "2043/20",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=2043/20&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Planning Permission for a residential development of a c.0.073 hectare site. The development will consist of the demolition of all existing buildings (2 storey and single storey - c. 667 sq.m) and the construction of a 26 no. unit residential development, extending to 7 no. storeys comprising: 13 no. 1 bed apartments and 13 no. 2-bed apartments, all with private balcony or terrace. Provision of c.184 sq.m of landscaped communal amenity space to the rear at ground floor level; single storey plant and storage building and enclosed bin store and 58 no. bicycle secure parking spaces; pedestrian access from York Road; all ancillary site works, an ESB substation (at ground floor level fronting onto York Road); provision of green roof, plant and all associated site development work. The total gross floor area is c.2,129 sqm.",
        "address": "11, 11A &, 12, York Road, Ringsend, Dublin 4",
        "Applicant": "Melvin Properties",
        "received": "2020-01-14",
        "status": null,
        "decision_date": "2020-03-09",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.34390858,
        "longitude": -6.224986763,
        "last_updated": "2020-03-28",
        "area ha": 0.07,
        "no of units": 26,
        "agent": "John Spain & Associates",
        "owner": "Tony Gaule",
        "apartments": 26,
        "houses": 0,
        "student": null,
        "studio": null,
        "apt.1_bed": 13,
        "apt.2_bed": 13,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": null,
        "ref": "2043/20"
      },
      "uid": "659af4fe4cb34f0f68db698f95560c80",
      "id": 87
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.14820238,
          53.3833702
        ]
      },
      "properties": {
        "uid": "669685e61d43ea816329bf2e9d3425a0",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "2475/19",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=2475/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Planning Permission at 'Strand View' (formerly 778-784), Howth Road, Raheny, Dublin 5 for revisions to a previously permitted residential development (previously granted under Reg. Ref. 4648/17: ABP Ref. ABP-301265-18). The proposed revisions will comprise of the addition of a new fourth floor penthouse level to previously permitted apartment blocks A and B to now comprise 2 no. 5 storey (3 storey plus 2 setback penthouse floors) apartment blocks with an overall increase of 6 no. apartments (2 No. 1 bedroom units and 4 no. 2 bedroom units) with the overall apartment blocks now consisting of a total of 58 no. apartments (10 no. 1 bedroom units, 38 no. 2 bedroom units, 10 no. 3 bedroom units) with balconies to east, south and west elevations and all associated internal and external modifications to the previously permitted blocks to facilitate this development; and all associated engineering and site development works necessary to facilitate the development.",
        "address": "Strand View, (formerly 778-784) Howth Road, Raheny, Dublin 5",
        "Applicant": null,
        "received": "2019-07-29",
        "status": null,
        "decision_date": "2019-08-23",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.3833702,
        "longitude": -6.14820238,
        "last_updated": "2019-09-07",
        "area ha": 0.89,
        "no of units": 6,
        "agent": "Downey Planning",
        "owner": "Horoprops Limited",
        "apartments": 6,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 2,
        "apt.2_bed": 4,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Not relevant",
        "ref": "2475/19"
      },
      "uid": "669685e61d43ea816329bf2e9d3425a0",
      "id": 88
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.25981939,
          53.40230352
        ]
      },
      "properties": {
        "uid": "68f989aa1a0b3ddd5577fd9fe84bdd07",
        "25PLUS": "yes",
        "la": "fingal",
        "file_num": "F19A/0419",
        "url": "http://planning.fingalcoco.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=F19A/0419&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "The proposed development is Phase 2 of a 2 Phase masterplan for a mixed development on an overall site of c.1.5 hectares, including adjoining lands to the east located at the south western junction of Northwood Avenue and Northwood Road, Northwood, Santry, Dublin 9. The proposed Phase 2 development will comprise the construction of a proposed shared access road from Northwood Road to the east and a new residential block comprising 6 storeys over podium (7 storeys over ground) (c.6,742 sq.m. gross floor area) to include: 12 no. studio units, 19 one-bedroom units, 41 two-bedroom units, 6 three-bedroom units; internal plant room; generator room; entrance lobby and internal circulation space; internal waste collection area; residential amenity space (communal facilities); private amenity space in the form of balconies and terraces (c. 730 sq.m); communal amenity space with children's play area, formal planting and lawn at podium level (c. 674 sq.m); a total of 72 no. car parking spaces (including 4 no. accessible car parking spaces); 160 no. cycle parking spaces; 3 no. motorbike parking spaces; creation of a pedestrian crossing point to provide safe and efficient pedestrian access between the proposed development and crèche (permitted under Reg. Ref. F18A/0438); and closure of an existing site access at Northwood Crescent (to the west). The development will also consist of the provision of external circulation areas; pedestrian footpaths; lighting; all hard and soft landscaping; planting; boundary treatments; changes in level; and all other associated site excavation works, site development works and site services above and below ground. All on this site of c.0.68 hectares comprising lands bound by Northwood Crescent to the south and west, 'The Crescent' Office Building to the north, and Northwood Road to the east, at Northwood, Santry, Dublin 9. Add Info received 31st January 2020. Add Info deemed Significant 5th February 2020. Revised Public Notices received 10th February 2020.",
        "address": "Northwood, Santry, Dublin 9.",
        "Applicant": "Kategale Limited",
        "received": "2019-09-06",
        "status": "Decision Made by Fingal County Council",
        "decision_date": "2020-03-05",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.40230352,
        "longitude": -6.25981939,
        "last_updated": "2020-03-21",
        "area ha": 0.68,
        "no of units": 78,
        "agent": "Tom Phillips & Associates",
        "owner": "Kategale Limited",
        "apartments": 78,
        "houses": null,
        "student": null,
        "studio": 12,
        "apt.1_bed": 19,
        "apt.2_bed": 41,
        "apt.3_bed": 6,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "No other development",
        "ref": "F19A/0419"
      },
      "uid": "68f989aa1a0b3ddd5577fd9fe84bdd07",
      "id": 89
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.24326571,
          53.34552891
        ]
      },
      "properties": {
        "uid": "6bae59f6807469ce4f1a117e90e5f55f",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "DSDZ2668/19",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=DSDZ2668/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "PROTECTED STRUCTURE: The application relates to a proposed development within the North Lotts and Grand Canal Dock Strategic Development Zone Planning Scheme area. The proposed development will consist of:- * Demolition of 8-10 Hanover Street East; * Construction of a 'build-to-rent' residential development in buildings ranging from 1 storey to 6 storeys plus set back level (over basement); * Provision of 217 apartments comprising 180 no. 1-bed-room units and 37 no. 2-bedroom units, along with associated resident amenity spaces including multi-purpose room and gym at basement level, reception/concierge and multi-function space at ground level, lounge at mezzanine level and roof terrace at first floor; * The residential accommodation includes 5 no. live/work units at ground floor level on Whitaker Lane; * Balconies at all levels on west (Lime Street), south (Hanover Street East) and east (Whitaker Lane) elevation and on internal courtyard elevations; * Retail/retail services/cafe unit at corner of Hanover Street East and Whitaker Lane; * Car parking (45 spaces), bicycle parking, residential storage, bin storage and plant rooms at basement level; * Vehicular access to basement from Lime Street; * Landscaped internal courtyard and new west-east pedestrian route linking Lime Street to Whitaker Square; * Sub-station, surface level bicycle parking signage and all ancillary site works and services. The application will be constructed on a phased basis, with all elements of the proposal to be completed in Phase 1 with the exception of the southern part of the Whitaker Lane block.",
        "address": "20-24, Sir John Rogerson's Quay (A Protected Structure), 25-27 Sir John Rogerson's Quay, 1-5, 11/11a, 12-14 Lime Street, Lime Court & at 8-10 Hanover Street East, Dublin 2",
        "Applicant": null,
        "received": "2019-07-24",
        "status": null,
        "decision_date": "2019-08-20",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.34552891,
        "longitude": -6.24326571,
        "last_updated": "2019-09-07",
        "area ha": 0.8,
        "no of units": 217,
        "agent": "Simon Clear & Associates",
        "owner": "Balark Trading GP Limited",
        "apartments": 217,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 180,
        "apt.2_bed": 37,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Retail/Restaurant 225 sqm\r\nCommercial 295 sqm",
        "ref": "DSDZ2668/19"
      },
      "uid": "6bae59f6807469ce4f1a117e90e5f55f",
      "id": 91
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.25611757,
          53.346374926
        ]
      },
      "properties": {
        "uid": "87c426890d57bb6c925cc37c8688d555",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "4170/19",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=4170/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Permission for development at a site of 0.57 ha at Apollo House, Tara St. (D02 N920); 9-11 Townsend St. (incl. The Long Stone Pub) D02 FE00); College House, Nos. 2-3 Townsend Street, (D02 F990) and the Screen Cinema, 16-19 Hawkins Street (D02 DP65), Dublin 2. The site is bounded by Townsend St. to the south, Tara St. to the east, Hawkins St. to the west, Hawkins House to the north and west and Poolbeg Street to the north. The development consists of amendments to previous permissions and proposed additional build to rent residential accommodation on previously permitted College House and the former Screen Cinema (DCC Reg. Ref: 3637/17, ABP Ref: PL29S.300709) and the former Apollo House DCC Reg. Ref.: 3036/16, ABP Ref: PL29S.247907) and as amended by DCC Reg. Ref.: 2415/19, as follows: 1. The proposed development consists of amendments to the permitted basement layouts including relocation of permitted core locations and alterations to plant areas and the addition of a residential waste store and residential cycle parking (76 cycle spaces). The proposals also include the reduction in car parking from 48 spaces to 40 spaces and an increase in cycle parking for the commercial offices from 404 spaces to 510 spaces (with an additional 20 at ground level). Decrease in permitted office amenity space at basement -1 from 505sq.m to 305sq.m2. Extension and increase in the extent and partial increase in heights of permitted Apollo House and College House developments where they adjoin onto the corner of Townsend St. and Tara St. There is no increase in overall maximum height of the permitted office buildings as a result of these proposed amendments. 3. The proposed development also includes new build to rent residential accommodation over part of the permitted Apollo House onto Poolbeg St. and Tara St. containing 54 residential apartment units (45 no. 1 bedroom and 9 no. 2 bedroom). The proposed residential element is ten storeys including a setback amenity floor with further set back screened plant. The proposed residential element includes communal internal residential amenity space of 207.9sq.m and external terraces on the east and west elevations. The proposed combined building height is 21 storeys (78.95m above street level). 4. Alterations to the proposed material and colour finishes of both permitted buildings, including minor alterations to the geometric arrangement of the facade. Proposed enclosure of the permitted plant screen on College House with a louvered cover. 5. Alterations to the permitted ground floor layouts of College House and Apollo House to include a new residential reception on Tara Street, the reconfiguration of the permitted office entrance foyers and the permitted cafe/retail/restaurant units and alterations to plant/services including a new ESB substation on Hawkins Street. These alterations include for a minor relocation of permitted ground and first floor external walls. 6. Overall minor decrease in permitted cafe/retail/restaurant floor space of 59 sq.m, increase in venue floor space of 87sq.m and increase in commercial floor space of 3,939 sq.m resulting from these proposed alterations. 7. The proposed scheme includes green roofs, PV panels, building lighting and associated signage.",
        "address": "Apollo House, Tara St., 9-11 Townsend St. (incl. The Long Stone Pub) (D02 FE00; College House, Nos. 2-3 Townsend St. (D02 F990) & the Screen Cinema, 16-19 Hawkins St. (D02 DP65), Dublin 2.",
        "Applicant": null,
        "received": "2019-10-09",
        "status": null,
        "decision_date": "2019-12-03",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.34637493,
        "longitude": -6.25611757,
        "last_updated": "2019-12-21",
        "area ha": 0.57,
        "no of units": 45,
        "agent": "Brady Shipman Martin",
        "owner": "Atlas GP Limited",
        "apartments": 45,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 45,
        "apt.2_bed": 9,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Commercial 44,421 sqm",
        "ref": "4170/19"
      },
      "uid": "87c426890d57bb6c925cc37c8688d555",
      "id": 92
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.421409359,
          53.284558349
        ]
      },
      "properties": {
        "uid": "88b2abab768c57a6bbff5ff7182b57e2",
        "25PLUS": "yes",
        "la": "south dublin",
        "file_num": "SD18A/0014",
        "url": "http://www.sdublincoco.ie/Planning/Details?p=99&regref=SD18A%2F0014",
        "dev_desc": "Residential development on a site area of 2.27ha at Citywest bounded to the north by Fortunestown Lane, to the west by the N82 Citywest Road, with Scoil Aoife to the east. The proposed development consists of 78 dwellings comprised of 58 No.2 storey houses, i.e. 2 No. 3 bed detached houses & 56 No. 3 bed terraced houses, along with 20 No. 1 and 2 bed apartments in a 4 storey building. The proposed development includes all associated site development and infrastructural works, car & bicycle parking, ESB sub-station, open spaces and landscaping. Access to the development will be via two vehicular entrances, i.e. the creation of a new entrance from Citywest Road and an extension to an existing entrance from Fortunestown Lane.",
        "address": "Fortunestown Lane, Citywest, Dublin 24",
        "Applicant": "Citywest Homes Developments Ltd.",
        "received": "2018-01-18",
        "status": null,
        "decision_date": "2018-07-10",
        "decision_due": "2018-07-11",
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.28455835,
        "longitude": -6.421409359,
        "last_updated": "2019-10-19",
        "area ha": 2.27,
        "no of units": 78,
        "agent": "Fenton & Associates",
        "owner": "Citywest Homes Developments Ltd",
        "apartments": 20,
        "houses": 58,
        "student": null,
        "studio": null,
        "apt.1_bed": 4,
        "apt.2_bed": 16,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": 58,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Residential Only",
        "ref": "SD18A/0014"
      },
      "uid": "88b2abab768c57a6bbff5ff7182b57e2",
      "id": 93
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.26556126,
          53.31106456
        ]
      },
      "properties": {
        "uid": "92c57d3a55642b0c7b1658133ac2d6d9",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "2010/19",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=2010/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Planning permission for a residential development at this site of c. 0.69 hectares, incorporating former Highfield plant nursery located off Highfield Grove, Oaklands Crescent Road and Saint Luke's Hospital service road together with the existing &quot;Primrose Lodge&quot; property at 28A Highfield Grove, all accessed off Highfield Road, Rathgar, Dublin 6. The site is bounded by the rear gardens of St. Kevin's Park to the south, Highfield Grove and Four Oaks to the north, Sunbury Park to the east and Saint Luke's Hospital to the west. The development will consist of: the demolition and removal of the existing derelict glass greenhouses and related structures (c. 4450sqm) on site with the existing 1.5 storey, 3 bed dwelling at 28A Highfield Grove to be retained and included as part of the proposal; the partial demolition of existing site boundaries to provide for a new pedestrian access and entrance gate on the north-west boundary of the site within the curtilage of the property at 28A Highfield Grove (and the creation of new boundary to this property) with vehicular access maintained off Oaklands Crescent and Saint Luke's Hospital service road to the west; the construction of 14 no. new dwellings comprising: 2 no. Type A (3 storey, 4 bed) end of terrace dwellings, 2 no. Type B (3 storey, 4 bed) end of terrace dwellings, 4 no. Type B (3 storey, 4 bed) terraced dwellings, 2no. Type C (3 storey, 4 bed) detached dwellings, 2 no. Type E (3 storey, 4 bed) semi-detached dwellings, 1 no. Type F (3 storey, 4 bed) detached dwelling and 1 no. Type G (2 storey, 3 bed) detached dwelling, all with in curtilage car parking; provision of public open space (totalling c.509sqm); and, all other site development works and site services above and below the ground required to facilitate the proposed development including visitor car parking, bike parking, bin storage, incidental open space, boundary treatments, landscaping and surface water attenuation facilities required to facilitate the proposed development.",
        "address": "Highfield Grove, Oaklands Crescent Road and Saint Luke's Hospital service road together with the existing \"Primrose Lodge\" property at 28A Highfield Grove, all accessed off Highfield Road, Rathgar, Dublin 6",
        "Applicant": null,
        "received": "2019-07-01",
        "status": null,
        "decision_date": "2019-07-26",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.31106456,
        "longitude": -6.26556126,
        "last_updated": "2019-08-10",
        "area ha": 0.68,
        "no of units": 14,
        "agent": "Marlet Property Group Limited",
        "owner": "Crekav Trading GP Limited",
        "apartments": 0,
        "houses": 14,
        "student": null,
        "studio": null,
        "apt.1_bed": null,
        "apt.2_bed": null,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": 1,
        "house.4_bed": 13,
        "house.4+_bed": null,
        "other notes": "No other development",
        "ref": "2010/19"
      },
      "uid": "92c57d3a55642b0c7b1658133ac2d6d9",
      "id": 94
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.064359362,
          53.386623094
        ]
      },
      "properties": {
        "uid": "986480e91533a470a3a585ef3d4673e4",
        "25PLUS": "need to add to ABP SHD list\r\nhttp://www.pleanala.ie/casenum/305828.htm",
        "la": "fingal",
        "file_num": "SHD/004/19",
        "url": "http://planning.fingalcoco.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=SHD/004/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "To view this application for Strategic Housing Development please visit www.rennieplaceshd.ie The development will consist of: The demolition of existing structures on site including the disused sports building (c.604sq.m.) on the Balscadden Road site and former Baily Court Hotel Buildings on Main Street (c.2051sq.m.). Construction of 177 no. residential units in 3 no. separate apartment blocks and 1 mews building ranging in height from 2-5 storeys, comprising 171 no. apartments and 6 duplexes which includes 44 no. 1 bed units, 103 no. 2 bed units and 30 no. 3 bed units. Balconies/winter gardens/terraces to be provided on all elevations at all levels for the 3 no. apartment blocks. Roof gardens will be provided on Block C. Provision 406 no. bicycle parking spaces and a total of 146 no. car parking spaces, which comprises 112 no. spaces in an underground basement in Block C, 26 spaces in a podium car park in Block B and 8 no. on-street parking spaces. Provision of commercial/retail space (c. 757sq.m.), which includes a community room (c. 161sq.m.), 2 no. retail units (c.429sq.m and c. 96sq.m.) and a cafe (c.71sq.m.). The main vehicular entrance to the scheme will be from Main Street to serve the underground car park in Block C. A secondary vehicular entrance from Balscadden Road will access the podium parking in Block B. The scheme provides for a new linear plaza which will create a new pedestrian link between Main Street and Balscadden Road to include the creation of an additional 2 no. public plazas and also maintains and upgrades the pedestrian link from Abbey Street to Balscadden Road below the Martello Tower. The public footpath on the opposite side of Balscadden Road will be widened for the length of the site as part of the development. All other ancillary site development works to facilitate construction and the provision of the basement car park, site services, piped infrastructure, a sub-station, public lighting, plant, bin stores, bike stores, boundary treatments and hard and soft landscaping. It is proposed to reduce the ground levels on the site from c. 35.0m OD to c. 20.0m OD. The basement car park of Block C is proposed at c. 17.0m OD. Excavation will range from 0m to up to c. 18m in depth to facilitate the construction of the development and basement car park. This equates to c. 78,000m3 of material to be removed from site in total. Commercial and retail signage (c. 75sq.m.) The application contains a statement setting out how the proposal will be consistent with the objectives of the Fingal County Development Plan 2017-2023. A Nature Impact Statement (NIS) has been prepared in respect of the proposed development and accompanies this application. The application, together with the Natura Impact Statement, may be inspected or purchased at a fee not exceeding the reasonable cost of making a copy during public opening hours at the offices of An Bord Pleanála and Fingal County Council. All Observations/Submissions to be made to An Bord Pleanála, 64 Marlborough Street, Dublin 1 and be accompanied by the prescribed fee of €20.00.",
        "address": "Former Baily Court Hotel, Main Street, Lands located south of the Martello Tower, Balscadden Road, Howth, co. Dublin",
        "Applicant": "Crekav Trading GP Limited",
        "received": "2019-11-04",
        "status": "Decision Made by Fingal County Council",
        "decision_date": "2020-03-02",
        "decision_due": null,
        "decision_code": "Grant Permission - DECISION BY ABP",
        "decision": "none",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.38662309,
        "longitude": -6.064359362,
        "last_updated": "2020-03-21",
        "area ha": 1.55,
        "no of units": 177,
        "agent": "Tom Phillips & Associates",
        "owner": "Crekav Trading GP Ltd",
        "apartments": 177,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 44,
        "apt.2_bed": 103,
        "apt.3_bed": 30,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "The floor area of commercial premises would be 757m2 of which the\r\ncommunity room would be 161m2\r\n, the café 71m2\r\n, one shop would be 429m2 and the\r\nother 96m2\r\n.",
        "ref": "SHD/004/19"
      },
      "uid": "986480e91533a470a3a585ef3d4673e4",
      "id": 96
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.349347609,
          53.345845819
        ]
      },
      "properties": {
        "uid": "987a3439b466e2ab2dd4da964788b972",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "3221/18",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=3221/18&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Revision to a previously permitted mixed-use residential development ( previously granted under Reg. Ref. 2869/17; ABP Ref. PL29S248958)to now provide for a ' build to rent' scheme. The proposed revisions shall consist of: (a) An increase of 21 no. residential units to now provide for a total of 174 no. residential units (84 no. 1 bedroom units; 88 no. 2 bedroom units; and 2 no. 3 bedroom units) within the 3 no. previously permitted blocks as follows; Block A - 5 storeys in height (part3 storeys) comprising of 40 no. residential units (25 no. 1 bedroom units; 15 no. 2 bedroom units with balconies/terrace on all elevations; Block B - 5 storeys in height comprising 80 no. residential units (39 no. 1 bedroom units; 41 no. 2 bedroom units) with balconies/terraces/gardens to all elevations; and Block C - 5 storey in height comprising 54 no. units ( 20 no. 1 bedroom units;32 no. 2 bedroom units; and 2 no. 3 bedroom units) with balconies/terraces/winter-gardens to all elevations.(b) Associated elevational changes to Block A, Band C, (c) Reduction in the size of previously permitted childcare facility; (d) Provision of additional amenity facilities including community room, gym and recreational area in Block A; (e) Reduction in basement level car parking spaces from 202 no spaces to 123 no. spaces; (f) Reduction in basement level motor cycle parking spaces from 13 no. spaces to 9 no. spaces; (f) Increase in basement level bicycle parking spaces from 188 no. spaces to 280 no. spaces; (g) Reduction in the basement floor area; (h) Provision of new plant areas at basement level; (i) All associated engineering and site development works necessary to facilitate the development.",
        "address": "Lands at the former Faulkners Industries Factory,Chapelizod Hill Road, Chapelizod, Dublin 20; ' Beann', 38 Chapelizod Hill Road, Chapelizod, Dublin 20 and' Clarevill' 38D Chapelizod Hill Road Dublin 20",
        "Applicant": null,
        "received": "2018-09-07",
        "status": null,
        "decision_date": "2018-10-04",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.34584582,
        "longitude": -6.349347609,
        "last_updated": "2018-10-21",
        "area ha": 1.05,
        "no of units": 174,
        "agent": "Downey Planning",
        "owner": "Midgard Construction Limited",
        "apartments": 174,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 84,
        "apt.2_bed": 88,
        "apt.3_bed": 2,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Childcare 194 sqm\r\nGymn 277 sqm",
        "ref": "3221/18"
      },
      "uid": "987a3439b466e2ab2dd4da964788b972",
      "id": 97
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.279099031,
          53.34564502
        ]
      },
      "properties": {
        "uid": "9951132c73e8dbc00ddac842813e792b",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "3328/18",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=3328/18&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "The proposed development will involve the demolition of all existing structures onsite (c. 1,028 sqm) to provide for a new 6-8 storey residential over ground floor commercial development (c.3,166.7 sqm GFA),in one block accommodating 28 no. apartments: 5 no. 1 bed units; 22 no. 2 bed units; and 1 no. 3 bed unit; with private balconies at each floor level. The parapet height of the proposed development at its highest point is 26.3m and the uppermost floors of the building will be set back fronting onto Usher Street and Usher's quay. at ground floor level,1 no. commercial unit (c.1 72.7sqm, to accommodate use class 1 and 2 type uses such as retail, professional / financial services) will be provided along with ancillary laundry room and gym facility; secure bicycle store with 66 no. spaces; store; plant rooms; and ESB substation . The development also includes all hard and soft landscaping including, a communal roof terrace at 6th floor level and private terrace at penthouse level; boundary treatments; PV panels; SuDS measures including blue roof surface water attenuation; and all other associated site excavation and site development works above and below ground. Access to the residential units will be provided via a private entrance lobby off Usher Street, with access to the commercial unit provided off Usher's Quay.",
        "address": "Site of c.552 sqm (c.0.05ha)at Nos. 1, 1A and 2 Usher Street and Nos. 29/30, Usher's Quay, Dublin 8",
        "Applicant": null,
        "received": "2018-11-13",
        "status": null,
        "decision_date": "2018-12-10",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.34564502,
        "longitude": -6.279099031,
        "last_updated": "2018-12-29",
        "area ha": 0.05,
        "no of units": 28,
        "agent": "Tom Phillips & Associates",
        "owner": "IDV Boyne Future Ltd",
        "apartments": 28,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 5,
        "apt.2_bed": 22,
        "apt.3_bed": 1,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Class 4 commerical 172 sqm",
        "ref": "3328/18"
      },
      "uid": "9951132c73e8dbc00ddac842813e792b",
      "id": 98
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.263194359,
          53.331462451
        ]
      },
      "properties": {
        "uid": "a625320a1f22be1a9753321a4a1447bd",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "2107/20",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=2107/20&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "The development will consist of amendments to Block 4 which forms part of a previously permitted development DCC Reg. Ref. 3742/10 (ABP Ref. PL29S.238212), as subsequently amended by planning permission DCC Reg. Ref. 4443/16 and DCC Reg. Ref. 3416/18. The proposed amendments to Block 4 will provide for an additional storey to Core 2 of the previously approved development to provide for an 8-storey building at Core 2 and an increase in height from the approved 23.375m to the proposed 28.15m. The proposed development will provide for an additional 4 no. residential units, increasing the total in Block 4 from the approved 86 no. units to the proposed 90 no. units. The additional units will comprise the following: -1 no. two-bedroom unit with a floor area of 103m2 to include a winter garden measuring 9.3m2 and external balcony measuring 8m2; -1 no. two-bedroom unit with a floor area of 103m2 to include a winter garden measuring 9.3m2; -1 no. two-bedroom unit with a floor area of 87m2 and external terrace measuring 18m2; -and 1 no. one-bedroom unit with a floor area of 58m2 and external terrace measuring 8m2.",
        "address": "Tom Kelly Road/ Charlemont Street, Dublin 2, D02 P489",
        "Applicant": "Charlemont Regeneration Ltd.",
        "received": "2020-01-23",
        "status": null,
        "decision_date": "2020-03-18",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.33146245,
        "longitude": -6.263194359,
        "last_updated": "2020-04-04",
        "area ha": 0.19,
        "no of units": 4,
        "agent": "McCutcheon Halley Plannin",
        "owner": "Charlemont Regeneration",
        "apartments": 4,
        "houses": 0,
        "student": null,
        "studio": null,
        "apt.1_bed": 1,
        "apt.2_bed": 3,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": null,
        "ref": "2107/20"
      },
      "uid": "a625320a1f22be1a9753321a4a1447bd",
      "id": 99
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.199170498,
          53.369476997
        ]
      },
      "properties": {
        "uid": "b3bef42fefd26cd4ffc0433ea3c52e9b",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "2038/18",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=2038/18&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "PROTECTED STRUCTURE: Permission for a residential development of 72 no. units across 4 no. blocks with a single level basement, consisting of the change of use of the existing Verville Retreat building from nursing home use to residential use and the change of use of the existing former outbuilding to residential use. The overall development will comprise of the following: Block A: construction of a 4 storey building (3 storeys with a setback fourth storey) comprising 14 no. apartments (12 no. 2 bedroom units and 2 no. 3 bedroom units) with balconies/terraces to the north and south elevations; Block B: The change of use of the existing 4 storey Verville Retreat building from nursing home use to residential use comprising 9 no. apartments (3 no. 1 bedroom units and 6 no. 2 bedroom units). Demolition of later additions and extensions to the existing Verville Retreat building as well as associated modifications to elevations and internal modifications/reconfiguration of the refurbishments to the existing building in order to accommodate the provision of the new apartment units and the construction of a new external stair core at the buildings eastern elevation; Block C: Construction of a 4 storey building (3 storeys with a setback fourth storey) comprising 48 no. apartments (1 no. studio apartment, 20 no. 1 bedroom units, 21 no. 2 bedroom apartments and 6 no. 3 bedroom apartments) with balconies/terraces to all elevations and roof garden; Block D: The conversion of the existing single storey outbuilding into 1 no. single storey, 2 bedroom mews dwelling with associated internal and external modifications to accommodate the proposed change of use; A basement level comprising a total of 69 no car parking spaces, 80 no. bicycle parking spaces, ancillary plant room and refuse storage areas; Revisions and improvements to the existing vehicular entrance to Vernon Avenue; Demolition of the existing single storey block to the north of Verville Retreat; landscaping (including communal and private open space); Boundary treatment; and, all associated engineering and site development works necessary to facilitate the development.",
        "address": "Verville Retreat, Vernon Avenue, Clontarf, Dublin 3",
        "Applicant": null,
        "received": "2018-06-26",
        "status": null,
        "decision_date": "2018-07-23",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.369477,
        "longitude": -6.199170498,
        "last_updated": "2018-08-11",
        "area ha": 0.5,
        "no of units": 72,
        "agent": "Downey Planning",
        "owner": "MKN Property Group",
        "apartments": 71,
        "houses": 1,
        "student": null,
        "studio": 1,
        "apt.1_bed": 23,
        "apt.2_bed": 39,
        "apt.3_bed": 8,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": 1,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "No other development",
        "ref": "2038/18"
      },
      "uid": "b3bef42fefd26cd4ffc0433ea3c52e9b",
      "id": 100
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.305533067,
          53.278334083
        ]
      },
      "properties": {
        "uid": "c3ef98a1895a5df586e2fa0c0aa0a176",
        "25PLUS": "yes",
        "la": "south dublin",
        "file_num": "SD18A/0215",
        "url": "http://www.sdublincoco.ie/Planning/Details?p=98&regref=SD18A%2F0215",
        "dev_desc": "Modifications to Apartment Block B of the residential development permitted under Reg. Ref: SD15A/0017 & ABP Ref. PL 06S.244732, which is currently under construction, at Scholarstown Wood, located south of Scholarstown Road, west of Stocking Lane, north of Ballyboden waterworks and east of Woodfield, Dublin 16. The purpose of this application is to ensure compliance with the specific planning policy requirements of the Sustainable Urban Housing: Design Standards for New Apartment Guidelines for Planning Authorities as they relate to the permitted development on the site, pursuant to Section 34 (3A and 3B) of the Planning and Development Act 2000, as amended. The proposed modifications relate to the permitted Apartment Block A, including Apartment No’s 248-281, at the western section of the permitted development and consist of the following: the omission of 2 stair/lift cores and 2 entrance lobbies and the provision of 1 stair/lift core and entrance in the central section of the apartment block and associated internal changes involving the reconfiguration of the permitted layout for Unit No’s 248-281 (no change is proposed to the permitted number of units); alterations to the permitted unit mix of Unit No’s 248-281, from 7 1-bed and 27 2-bed, to 7 1-bed, 25 2-bed and 2 3-bed; alterations to the permitted basement level, including a reduction in the GFA from 1,409.2sq.m to 998sq.m resulting in the reduction of parking provision from 35 spaces to 28 spaces and reduction of cycle parking spaces from 40 spaces to 8 cycle parking spaces at basement level (including 4 cycle spaces allocated for Block C); relocation of 30 cycle parking spaces to ground floor level and provision of 5 surface parking spaces at the front/eastern elevation. The total car parking provision of Apartment Block A is 34 spaces and 2 visitor parking spaces. The total cycle parking provision decreases by 2 spaces from 40 spaces to 38 spaces (including 4 cycle spaces allocated for Block C); elevational changes include modifications to the proposed entrance of the apartment scheme, provision of balconies at first and second floor level on the southern elevation and adjustments to the fenestration at ground to third floor level of the northern and eastern elevations. The proposed modifications result in a total net reduction of the permitted GFA from 4,757.8sq.m to 4,314sq.m.",
        "address": "Scholarstown Wood, Rathfarnham, Dublin 16",
        "Applicant": "Broadcrest Ltd.",
        "received": "2018-06-08",
        "status": null,
        "decision_date": "2018-08-02",
        "decision_due": "2018-08-02",
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.27833408,
        "longitude": -6.305533067,
        "last_updated": "2019-10-12",
        "area ha": 9.77,
        "no of units": 34,
        "agent": "John Spain Associates",
        "owner": "Broadcrest Ltd",
        "apartments": 34,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 7,
        "apt.2_bed": 25,
        "apt.3_bed": 2,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Change in number of units on existing permission",
        "ref": "SD18A/0215"
      },
      "uid": "c3ef98a1895a5df586e2fa0c0aa0a176",
      "id": 101
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.288022463,
          53.387431443
        ]
      },
      "properties": {
        "uid": "caa796fb00df7b4a7bb854e0a0ec1d81",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "3055/18",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=3055/18&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Permission for development at this 1.124 ha. site adjoining Gaelscoil Ui Earcain, at Glasanaon Rd. and School Rd., Finglas East, Dublin D 11VP44. The development will consist of revisions to development permitted under ref. no. 4161/16. (The permitted development on a larger site of 2.12 ha. includes: a) re-location and improvement of existing G.A.A. football pitch; b) accommodation of extension to Gaelscoil Ui Earcain: c) construction of 4-storey residential care home served by 72 surface car-parking spaces and landscaped open space; d) construction of 18 apartments in three and four storey block served by 18 surface car-parking spaces; e) new vehicular and pedestrian access to residential care home and apartment developments from School Rd.). The revisions now proposed comprise: Provision of basement car-park under the residential care home, to service the residential care home, with 72 no. car parking spaces, 20 no. bicycle parking spaces, laundry, storage and plant; Replacement of permitted block of 18 apartments with 22 apartments, in three and four-storey block (Block B), comprising 5. no. 1-bedroom units, 13 no. 2-bedroom units and 4 no. 3-bedroom units; with balconies on west and east-facing elevations and roof garden at third floor level on north part of building; Additional three and four-storey block of 22 apartments (Block A), comprising 5 no. 1-bedroom units and 17 no. 2-bedroom units with balconies on west and east-facing elevations and roof garden at third floor level on north part of building. Total number of proposed apartments 44 no. served by 46 no. surface car-parking spaces and 44 no. bicycle parking spaces. Revised open space to serve the residential care home. Minor revisions to residential care home to accommodate revised site service road layout (floor area reduced by 17 sq.m). The development will otherwise be carried out in accordance with Dublin City Council planning permission ref. no. 4161/16.",
        "address": "Site adjoining Gaelscoil Ui Earcain, at Glasanaon Rd. and School Rd., Finglas East, Dublin D11VP44",
        "Applicant": null,
        "received": "2018-09-11",
        "status": null,
        "decision_date": "2018-10-08",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.38743144,
        "longitude": -6.288022463,
        "last_updated": "2018-10-27",
        "area ha": 1.124,
        "no of units": 44,
        "agent": "Auveen Byrne & Associates",
        "owner": "De La Salle Brothers",
        "apartments": 44,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 10,
        "apt.2_bed": 30,
        "apt.3_bed": 4,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "no other development",
        "ref": "3055/18"
      },
      "uid": "caa796fb00df7b4a7bb854e0a0ec1d81",
      "id": 102
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.23370977,
          53.34943681
        ]
      },
      "properties": {
        "uid": "cb4fedf3ad0359b724414f79928c0e32",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "DSDZ2464/19",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=DSDZ2464/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Permission at a site (c. 1.51 Ha) at City Block 3 and Northbank House, Sheriff Street Upper, New Wapping Street and Mayor Street Upper, North Lotts, Dublin 1 and otherwise generally bounded by Nos. 7-10 Mayor Street Upper to the south, Nos. 1-14 New Wapping Street to the west, and existing Northbank House, Alexandra Terrace and Castleforbes Road to the east. The development will consist of: - The construction of 6 no. residential blocks, ranging from 2 to 7 storeys over partial single level basement (gross floor area c. 36,834.2 sq m excluding basement c. 5,369 sq m), to accommodate 449 no. residential units comprising 59 no. 1-bed studios, 166 no. 1-bed apartments, 215 no. 2-bed apartments, 2 no. 3-bed apartments and 7 no. 3-bed houses. The development provides for Tenant Amenity area (c. 766 sq m gfa), a cafe (c. 109 sq m gfa) within the proposed Block 3B, and change of use and reconfiguration of an existing retail unit to provide a crèche (c. 343 sq m gfa) and associated play area at Northbank House. The breakdown of accommodation is as follows: - Block 3A1 (c. 7,951.1 sq m gross floor area) fronting Sheriff Street Upper and New Wapping Street, comprises a 7 storey apartment building accommodating 106 no. residential units (13 no. studios, 56 no. 1-beds, 36 no. 2-beds and 1 no. 3-bed). Block 3A2 (c. 9,668.8 sq m gross floor area) fronting Sheriff Street Upper, comprises a 7 storey apartment building accommodating 117 no. residential units (5 no. studios, 52 no. 1-beds, 59 no. 2-beds and 1 no. 3-bed). Block 3B (c. 8,908.7 sq m gross floor area) fronting Sheriff Street Upper and north of the proposed new civic park, comprises a 6 to 7 storey apartment building accommodating 102 no. residential units (25 no. studios, 24 no. 1-beds and 53 no 2-beds). This building includes tenant amenities (c. 766 sq m) at ground and first floor levels, and a cafe (c.109 sq m) at ground floor level. Blocks 3D2 / 3E2 (c. 9,484.4 sq m gross floor area) fronting Mayor Street Upper and west of the proposed new civic park, comprises a 3 to 6 storey apartment building accommodating 117 no. residential units (16 no. studios, 34 no. 1-beds and 67 no. 2-beds). Block 3D1 (c. 821.2 sq m gross floor area) located to the rear (east) of the existing houses fronting New Wapping Street and west of proposed Block 3D2/3E2, comprises 7 no. 2 storey 3-bed houses. Balconies are provided on all elevations of the apartment blocks (3A1, 3A2, 3B, 3D2 and 3E2). Private rear gardens are provided at ground floor level to the Block 3D1 houses. All associated and ancillary site development works, hard and soft landscape, boundary treatment works, including: - Demolition of remaining existing non-residential structures (c. 420 sq m), previously approved under DCC Reg. ref. DSDZ2242/16. New external residential courtyards and roof terrace amenity areas. New civic park located centrally within the city block (c. 2,259 sq m) as previously permitted under DCC Reg. Ref. DSDZ3357/17. New internal east-west street and north-south (pedestrian / cycle) streets. 100 no. car parking spaces, including 94 no. spaces at basement level and 6 no. spaces at surface level. 552 no. bicycle parking spaces, including 494 no. at basement level and 58 no. at surface level. New vehicular access to the basement car park from New Wapping Street. Basement storage, service and plant areas. Provision of a bin store (c. 39.2 sq m gfa) between Blocks 3D1 and 3D2 / 3E2. Provision of 2 no. ESB sub-stations. Public Realm works along Sheriff Street Upper, New Wapping Street and Mayor Street Upper, including revised treatment to the boundary with Northbank House Fire Tender Route previously approved under DCC Reg. Ref. DSDZ2642/16. This application relates to a proposed development within the North Lotts & Grand Canal Dock Strategic Development Scheme area.",
        "address": "site (c. 1.51 Ha) at City Block 3 and Northbank House, Sheriff Street Upper, New Wapping Street and Mayor Street Upper, North Lotts, Dublin 1",
        "Applicant": null,
        "received": "2019-06-11",
        "status": null,
        "decision_date": "2019-07-08",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.34943681,
        "longitude": -6.23370977,
        "last_updated": "2019-07-27",
        "area ha": 1.51,
        "no of units": 449,
        "agent": "Stephen Little & Associates",
        "owner": "KW PRS ICAV",
        "apartments": 442,
        "houses": 7,
        "student": null,
        "studio": 59,
        "apt.1_bed": 166,
        "apt.2_bed": 214,
        "apt.3_bed": 2,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": 7,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Cafe 109 sqm\r\nCreche 343 sqm",
        "ref": "DSDZ2464/19"
      },
      "uid": "cb4fedf3ad0359b724414f79928c0e32",
      "id": 103
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.23499822,
          53.34444063
        ]
      },
      "properties": {
        "uid": "cd0264e732da64a1fff47fff79fc74d9",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "DSDZ2572/19",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=DSDZ2572/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Planning permission for development at a site of c. 0.435ha at the Opus Building, former Kilsaran Concrete Site, 6 Hanover Quay, Dublin 2. This site fronts onto three streets, Hanover Quay to the south; an unnamed lane which the apartment block fronts onto the east; and Horse Fair Road/Britain Quay to the north. This application relates to a proposed development within the North Lotts & Grand Canal Dock Strategic Development Zone Planning Scheme area. The development will consist of modifications to permissions DCC Reg. Refs. DSDZ3647/18, DSDZ4134/17, DSDZ2577/17 and DSDZ3197/16 to include the following: Removal of a section of artificial grass and installation of paving to match the existing and construction of a new pergola (c. 2.6 metres) at 7th floor roof terrace level in the north east corner; Removal of a section of artificial grass and installation of a fire pit and timber decking to match the existing along with the construction of a new pergola (c. 2.6 metres) at 8th floor roof terrace level in the south east corner; The construction of a communal room for residential use (c. 20.7 sq.m and c. 2.8m tall) at 8th floor roof terrace level in the south east corner; Reconfiguration of the roof area and associated alterations to the open spaces, landscaping and boundary treatment works. The remainder of the development will otherwise be carried out in accordance with permissions DCC Reg. Refs. DSDZ3647/18, DSDZ4134/17, DSDZ2577/17 and DSDZ3197/16.",
        "address": "site of c. 0.435ha at the \"Opus Building\", Former Kilsaran Concrete Site, 6 Hanover Quay, Dublin 2",
        "Applicant": null,
        "received": "2019-03-22",
        "status": null,
        "decision_date": "2019-05-16",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.34444063,
        "longitude": -6.23499822,
        "last_updated": "2019-06-01",
        "area ha": 0.463,
        "no of units": 120,
        "agent": "McGill Planning Limited",
        "owner": "AG 6HQ Hanover Real Estate Limited",
        "apartments": 120,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 24,
        "apt.2_bed": 74,
        "apt.3_bed": 22,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Cafe 675sqm",
        "ref": "DSDZ2572/19"
      },
      "uid": "cd0264e732da64a1fff47fff79fc74d9",
      "id": 104
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.236010321,
          53.349493458
        ]
      },
      "properties": {
        "uid": "d1b28ae3171e98590b1631cb13cbb187",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "DSDZ2896/18",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=DSDZ2896/18&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Spencer Place Development Company Limited intend to apply for planning permission for development at a site of 1.26 hectares located at City Block 2, Spence Dock, Dublin 1. The site is bound by Sheriff Street Upper to the north, Mayor Street Upper to the south, New Wapping Street to the east and a development site to the west (also part of Block 2). The development site also includes the existing operational North Lotts Pumping Station and its associated infrastructure - the proposed development involves building adjacent to, and over, the Pumping Station. The application relates to a proposed development within a Strategic Development Zone Planning Scheme Area. The development consists of the following: - Construction of 325 no. residential units and aparthotel in 2 no. blocks; - Block 1 to the north of the site will be 7 no. storeys in height (max 31.5m) and will comprise of 211 no. units in total (73 no. 1 bed and 138 no. 2 bed) all with associated private terraces/balconies to all elevations; - Block 1 will also include the provision of a communal open space courtyard, reception/concierge, back of house area and internal communal space associated with the residential development at ground floor level, and communal amenity space at 6th floor level; - Block 2 to the south of the site will be part 6 no. (28.050m)/part 7 no. storeys (31.5m) and will comprise of 114 no. units in total (47 no. 1 beds and 67 no. 2 bed units) all with associated private terraces/balconies to all elevations and an aparthotel to the western portion of the block comprising of 102 no. units (216 no. bed spaces); - Block 2 will also include provision of reception area associated with the aparthotel, cafe, internal residential communal space and communal open space courtyard at ground floor level, and a communal residential area at 5th floor level. - Provision of 2 no. under croft levels of car parking and cycle parking to serve each block to facilitate a total of 77 no. car parking spaces and 462 no. bicycle parking spaces in addition to plant, refuse areas, back of house area to serve the aparthotel and storage facilities and 2 no. new vehicular access points onto New Wapping Street; - Provision of new north/south vehicular and pedestrian street including new road way, pedestrian footpath, on street car parking with access from Mayor Street Upper and access/egress from Sheriff Street Upper; - Provision of a new landscaped pedestrian street running in an east/west direction through the site; - Provision of 2 no. substations fronting New Wapping Street to serve each building and 1 no. substation to serve the aparthotel on the new internal north/south street to the west of the site; - Provision of plant at roof level on the aparthotel element of Block 2; - Pedestrian connection from internal courtyard of Block 2 to Mayor Street Upper along the western boundary of the existing residential units; - Screening and appropriate landscaping of existing North Lotts Pumping Station; - Landscaping plan including new pedestrian and disabled access from New Wapping Street to the proposed new landscaped east/west pedestrian street; pedestrian access and maintenance vehicular access from the proposed new north/south street to the landscaped east/west pedestrian street, provision of public artwork, revised boundary treatment to all boundaries; provision of informal children's play areas and seating areas throughout the site, provision of surface level bicycle stands, and defensible landscaped strip at ground floor level on all boundaries; - Improvements to the public realm including tree planting, and the provision of new footpath areas along all site boundaries; - The development also includes, SUDs drainage, the provision of a green roof on both blocks and all associated site development works necessary to facilitate the development.",
        "address": "City Block 2, Spencer Dock, Dublin 1",
        "Applicant": null,
        "received": "2018-08-09",
        "status": null,
        "decision_date": "2018-09-05",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.34949346,
        "longitude": -6.236010321,
        "last_updated": "2018-09-22",
        "area ha": 1.26,
        "no of units": 325,
        "agent": "John Spain Associates",
        "owner": "Spencer Place Development",
        "apartments": 325,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 120,
        "apt.2_bed": 205,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Apart hotel\r\nCafe",
        "ref": "DSDZ2896/18"
      },
      "uid": "d1b28ae3171e98590b1631cb13cbb187",
      "id": 105
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.380041587,
          53.42642209
        ]
      },
      "properties": {
        "uid": "d291a1ec23bb837b46e2d9ef9c1399f8",
        "25PLUS": "yes - shd\r\nhttp://www.pleanala.ie/casenum/303956.htm\r\nRefused",
        "la": "fingal",
        "file_num": "SHDW/01/19",
        "url": "http://planning.fingalcoco.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=SHDW/01/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "www.hollystownshd.ie The proposed development will consist of the removal of two existing sheds and a silo (571sq.m total); change of use of golf course to residential and open space use; and; construction of: - 133 no. 2-storey houses comprising: 9 no. four bedroom units, 74 no. three bedroom units and 50 no. two bedroom units together with 216 no. associated car parking spaces; - 3 no. 4-storey apartment blocks with some plant and provision of solar photovoltaic modules at roof level containing 120 no. apartment units with balconies comprising: 54 no. one bedroom units and 66 no. two bedroom units together with 120 no. associated car parking spaces and provision for 3 no. internal bicycle storage areas within each apartment block, each to cater for 65 no resident bicycle spaces, and 60 no. external visitor bicycle spaces; - Landscaped public open space comprising approximately 1.6ha (excluding area beneath existing overhead powerlines, attenuation areas and incidental open space) and including 2 no. playground facilities (630sqm and 490sqm); - Internal street network with access via a new site entrance off the R121 regional road; - Network of pedestrian and cycle paths with access points along the south, east and west boundaries of the subject site; Associated foul water drainage arrangements including connection to existing Church Road Pumping Station to the south of the subject site and connection to existing Hollystown Pumping Station to the north west; and; - Associated landscaping, surface water drainage arrangements; public lighting, ESB substations, refuse storage sheds associated with the apartments; ducting in parking areas to facilitate electrical car charging; boundary treatments and site development works, all on a site of c. 9.386ha. ABP-303956-19 ALL OBJECTIONS / SUBMISSIONS TO BE SUBMITTED TO AN BORD PLEANALA.",
        "address": "Hollystown Golf Club, Hollystown, Dublin 15",
        "Applicant": "Glenveagh Homes Limited",
        "received": "2019-03-22",
        "status": null,
        "decision_date": null,
        "decision_due": null,
        "decision_code": null,
        "decision": "none",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.42642209,
        "longitude": -6.380041587,
        "last_updated": "2019-04-06",
        "area ha": 1.6,
        "no of units": 253,
        "agent": "RPS Group Ltd",
        "owner": "Glenveagh Homes Limited ",
        "apartments": 120,
        "houses": 133,
        "student": null,
        "studio": null,
        "apt.1_bed": 54,
        "apt.2_bed": 66,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": 50,
        "house.3_bed": 74,
        "house.4_bed": 9,
        "house.4+_bed": null,
        "other notes": "ABP refused\r\nNo other development",
        "ref": "SHDW/01/19"
      },
      "uid": "d291a1ec23bb837b46e2d9ef9c1399f8",
      "id": 106
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.234262912,
          53.332234183
        ]
      },
      "properties": {
        "uid": "d645c7bee1b1d74d577535916b86de1b",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "4522/17",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=4522/17&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "The proposed development comprises amendments to permitted Block 8, 9, 10 and 12 located within the Ballsbridge Hotel site, fronting Lansdowne Road and Pembroke Road (referred to as Site 2 of parent permission), including internal re-configuration, alterations to the building envelope and associated elevational changes to those Blocks, to provide for the following: - Block 9 is now proposed to accommodate a hotel (11,127 sq.m GFA), comprising a reception/ foyer area, administration are, café/ bar, kitchen and storage area at ground floor level and 211 no. hotel rooms at first to seventh floor level, and ancillary revisions at basement level, accommodating ancillary Hotel facilities (This has resulted in the building footprint of Block 9 reducing); - In order to accommodate the hotel at this location, permission is also sought for amendments to aspects of the permitted Block 8 resulting in the omission of 12 no. dwellings (Block 08 will now comprise of 56 no. 2-bed units and 2 no.3-bed units); - In order to accommodate the hotel at this location, permission is also sought for amendments to aspects of the permitted Block 10 resulting in the omission of 12 no. dwellings from permitted Block 10 (Block 10 will now comprise of 109 no. 1-bed units and 24 no. 2-bed units); - Block 12 is now proposed to accommodate at ground floor Unit H (110.7 sq.m) and Unit J (224.2 sq.m) (both café/ restaurant uses) and residential circulation access to upper floors, together with the provision of 42 no. apartments at first to ninth floor level, comprising of 32 no. 2-bed units and 10 no. 3-bed units; with balconies/ terraces at each level on various elevations and terraces at roof level in lieu of previously permitted hotel; - As a consequence of the amendments noted above, permission is sought for consequential revisions sought at ground floor level comprising reduction in floor area of the anchor unit by approx. 232.2 sq.m, reduction in floor area of the ground floor service corridor by approx. 290.6 sq.m, omission of approx. 295.6 sq.m of retail/ commercial floorspace (Units 1 and 2), reduction of approx. 12.7 sq.m of retail/ commercial floorspace (Unit 3); reduction of approx. 28.3 sq.m of retail/ commercial floorspace (Unit 5); omission of approx. 251.3 sq.m of restaurant/ café floorspace (Unit C), omission of approx. 270.9 sq.m of bar/ restaurant floorspace (Unit D), an increase of approx. 20.9 sq.m of bar/ restaurant floorspace (Unit E), provision of approx. 110.7 sq.m new bar/ restaurant floorspace in Unit H, and an increase of approx. 93.1 sq.m of bar/ restaurant floorspace (Unit J); - At basement levels -1 and -2, the reconfiguration of the ancillary accommodation for the uses listed above, plus service yard, plant and attenuation; the reconfiguration of car-parking layout; the overall basement floor area will remain at 41,990 sq.m; and no change to the total number of permitted car parking spaces or motorcycle spaces; The above revisions will result in an increase in the gross floor area of the permitted development above ground by c. 642.8 sq.m; And all ancillary landscape and site development works to include a new taxi/ drop-off area to be accessed from Pembroke Road at permitted entry egress point to basement car park, including necessary revisions to access ramp to basement car park from Pembroke Road; All on a site of c.5.68 ha, occupied by Blocks 09 and 12, and portions of blocks 08 and 10, and adjacent amenity space and access routes; All of the above amends a previously permitted mixed use scheme Dublin City Council Reg.Ref. 4015/09 (An Bord Pleanála Ref. PL29S.237454)- the 'parent permission' - as revised by subsequent permissions, Dublin City Council Reg.Refs. 3008/17 and 3184/17.",
        "address": "Ballsbridge Hotel, being part of a wider site known as the D4 Hotels site/ former Jury's Hotel site, generrally bounded by Lansdowne Road to the north, Shelbourne Road to the east and Pembroke Road to the west, Ballsbridge, Dublin 4",
        "Applicant": null,
        "received": "2018-03-16",
        "status": null,
        "decision_date": "2018-04-10",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.33223418,
        "longitude": -6.234262912,
        "last_updated": "2018-04-28",
        "area ha": 2.78,
        "no of units": 42,
        "agent": "Stephen Little & Associates",
        "owner": "Copper Bridge C 2015 ICAV",
        "apartments": 42,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": null,
        "apt.2_bed": 32,
        "apt.3_bed": 10,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Hotel 11,100sqm\r\nBar 224sqm",
        "ref": "4522/17"
      },
      "uid": "d645c7bee1b1d74d577535916b86de1b",
      "id": 107
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.315325146,
          53.337417498
        ]
      },
      "properties": {
        "uid": "db6529049c70e374b711a457328112ee",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "4260/19",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=4260/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Permission for development at this site (0.72 hectare), known as Site 1b St. Michael's Estate, Inchicore, Dublin 8 bounded by Richmond Barracks to the north, the rear of Connolly Avenue to the east and Thornton Heights to the south. The development will consist of a one to four storey older persons housing with supports scheme, incorporating: (i) 52 no. apartment dwellings with balconies; (a) 16 no. 2 bedroom apartments; (b) 36 no. 1.5 bedroom apartments. (ii) Communal facilities at ground floor level to include a multipurpose room, additional ancillary spaces, staff offices and a publicly accessible tea room (26.5m2). (iii) Landscaping works to include resident courtyards and a landscaped open space (facing the St. Michaels Estate road) incorporating a new vehicle setdown area. (iv) 15 no. car parking spaces . (13 no. new car parking spaces to be accessed from an existing vehicular entrance and the relocation of 2 no. existing car parking spaces adjacent to the new vehicle setdown area). (v) 52 no. bicycle parking spaces. (vi) (ESB substation), external signage, site perimeter boundary treatments, plant rooms, waste storage enclosures and all associated ancillary development works and services. (vii) The development will consist of the following floor areas: - Total gross internal floor area (GIA): 4,655m2 (inclusive of all residential, communal, vertical circulation & ancillary spaces). - Area of external deck/gallery access (excluding balconies): 1,066.6m2. - Area of roof terrace (excluding balconies): 100.1m2. (viii) The building will be one to four storeys in height, with a top parapet level of 40.04m OD (measuring 14.835m above finished ground floor level).",
        "address": "Site known as Site 1b St. Michael's Estate, Inchicore, Dublin 8 (bounded to the north by Richmond Barracks, to the east by the rear of houses to Connolly Avenue & to the south by Thornton Heights apartment complex)",
        "Applicant": null,
        "received": "2019-10-21",
        "status": null,
        "decision_date": "2019-12-13",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.3374175,
        "longitude": -6.315325146,
        "last_updated": "2019-12-28",
        "area ha": 0.72,
        "no of units": 52,
        "agent": "OBFA Architects",
        "owner": "Circle Voluntary Housing Association",
        "apartments": 52,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 36,
        "apt.2_bed": 16,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Tea room 26.5 sqm",
        "ref": "4260/19"
      },
      "uid": "db6529049c70e374b711a457328112ee",
      "id": 108
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.37182824,
          53.33106179
        ]
      },
      "properties": {
        "uid": "dbd88513efde939537d93f5c516ebe65",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "3798/18",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=3798/18&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Marblegate Limited intend to apply for permission for development on this site (1.27 ha) at Blocks 70 and 72, Park West Avenue and Park West Road, Park West, Dublin 12. The proposed development will consist of the conversion, extension and change of use of existing Blocks 70 and 72 from commercial office over ground floor retail/restaurant uses to provide for a residential development with a total of 84 no. apartments over retail/restaurant uses, as follows: Block 70: Existing 4 storey over basement block (4,779 sq.m) containing 1,065 sq.m of retail space at ground floor and 3,060 sq.m of office space over floors 1-3 to be converted and extended to a 5 storey over basement block (5,715 sq.m) consisting of 43 no. apartments (comprising 13 no. 1 bed & 30 no. 2 bed apartments) with ancillary accommodation, community rooms, associated balconies and roof terraces over 5 levels, including 3 no. retail units (totalling 328 sq.m) at ground floor and fronting onto the plaza. The revised Block 70 includes a new set back level at fifth floor (936 sq.m) which accommodates 9 of the 43 no. apartments. Block 72: Existing 4 storey over basement block (4,235 sq.m) containing a 370 sq.m restaurant, 484 sq.m of retail space and 2,733 sq.m of office space over floors 1-3, to be converted and extended to a 5 storey over basement block (4,985 sq.m) consisting of 41 no. apartments (comprising 21 no. 1 bed & 20 no. 2 bed apartments), with ancillary accommodation, community rooms, associated balconies and roof terraces over 5 levels and including a restaurant (370 sq.m) at ground floor and 1 no. retail unit (171.5 sq.m) fronting onto the plaza. The revised Block 72 includes a new set back level at fifth floor (750 sq.m) which accommodates 8 of the 41 no. apartments. Permission is also sought for modifications to the existing basement accommodation to provide bin stores and bicycle parking, designation of 84 no. existing basement car parking spaces for the proposed residential accommodation at a rate of 1 per apartment, minor revisions to podium level landscaping and all associated site and development works.",
        "address": "Blocks 70 & 72, Park West Avenue and Park West Road, Park West, Dublin 12",
        "Applicant": null,
        "received": "2018-08-27",
        "status": null,
        "decision_date": "2018-10-18",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.33106179,
        "longitude": -6.37182824,
        "last_updated": "2018-11-03",
        "area ha": 1.27,
        "no of units": 84,
        "agent": "BMA Planning",
        "owner": "Marblegate Limited",
        "apartments": 84,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 34,
        "apt.2_bed": 50,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Retail 500sqm\r\nRestaurant 270 sqm",
        "ref": "3798/18"
      },
      "uid": "dbd88513efde939537d93f5c516ebe65",
      "id": 109
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.247224119,
          53.396203645
        ]
      },
      "properties": {
        "uid": "dcef6f3f5d90b39da9901cf3b59bed18",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "2713/17",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=2713/17&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Permission for development at a site located at Santry Avenue and Swords Road, Santry, Dublin 9. The site is generally bound to the east by Swords road, to the south by St. John's Business Court, to the southwest by Santry Hall Industrial Estate, to the west by Santry Avenue Industrial Estate, and to the north by Santry Avenue and Heiton Buckleys Builders Merchants. The proposed development (c.25,083 sq m total gfa above basement car park, and excluding plant, bin stores and bike stores), generally comprises: the partial demolition (c.7,781 sq m gfa) of an existing 8-bay warehouse (c.9,539 sq m gfa), and the construction of: 1 no. 5-storey mixed use building fronting Swords Road (Block A: c.5,932 sq m gfa in total), including 3 no. retail/commercial units (c.502 sq m) at ground level and 48 no. residential units in levels above; 1 no. 5-storey residential building (Block B: c.5,233 sq m gfa, 47 no. residential units); 1 no. 5-storey mixed use building (Block C:c.5,383 sq m gfa in total), including 2 no. office units (c.373 sq m gfa) and 1 no. crèche (c.331 sq m gfa) at ground floor, and 42 no. residential units from ground to 4th floor levels; the refurbishment of the partially retained and reclad double height warehouse (2-bays, 1,758 sq m gfa) with new 4-storey extension, to accommodate commercial office use (Block D: c.6,733 sq m gfa in total); and a new 4-storey commercial office building (Block E: c.1,802 sq m gfa in total); The proposed development accommodates 137 no. residential units in total (25 no. 3-bed, 88 no. 2-bed and 24 no. 1-bed); And all ancillary and associated site development works, including: new vehicular and pedestrian access via Swords Road at the north east corner of the site, and environmental improvements along the Swords Road frontage; upgrading of existing vehicular and pedestrian access via Santry Avenue; new basement car park (c.3,988 sq m) accessed via ramp under Block A accommodating 122 no. car parking spaces (to include 6 no. disabled access), 100 no. bicycle parking spaces, plant, etc.; 151 no. surface car parking spaces (to include 7 no. disabled access); 100 no. surface bicycle spaces; bin storage at ground level in Blocks B and C; surface water attenuation tank; and, hard and soft landscaping, lighting and boundary treatment works; all on a site of c. 1.9Ha.",
        "address": "Santry Avenue and Swords Road, Santry, Dublin 9.",
        "Applicant": null,
        "received": "2018-02-13",
        "status": null,
        "decision_date": "2018-03-12",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.39620365,
        "longitude": -6.247224119,
        "last_updated": "2018-03-31",
        "area ha": 1.9,
        "no of units": 137,
        "agent": "Stephen Little & Associates",
        "owner": "Carnamadra Ltd",
        "apartments": 137,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 24,
        "apt.2_bed": 88,
        "apt.3_bed": 25,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Creche 331 (56 spaces)\r\nOffice 8,717sqm\r\nRetail 502 sqm",
        "ref": "2713/17"
      },
      "uid": "dcef6f3f5d90b39da9901cf3b59bed18",
      "id": 110
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.466683297,
          53.277109215
        ]
      },
      "properties": {
        "uid": "de0c6ca5f56f7c79b10114aa16ebcc59",
        "25PLUS": "yes - withdrawn",
        "la": "south dublin",
        "file_num": "SD18A/0413",
        "url": "http://www.sdublincoco.ie/Planning/Details?p=98&regref=SD18A%2F0413",
        "dev_desc": "Construction of a residential development comprising 93 units in total consisting of 36 four bed units and 57 three bed units, all in a mix of terrace and semi-detached units and of a height of two storeys (including second floor accommodation in roof space with dormer windows and roof lights); new priority access from Stoney Hill Road to the development; new linear park to the south of the site (as an extension to that proposed in Phase 1) together with other public open spaces, landscaping including boundary treatment, underground services and utilities and road and footpaths on the site; 186 surface car parking spaces will be provided for the development; total gross floor area of the proposed residential development will be circa 13,418.71 sq.m; 2 storey crèche building of 620sq.m located on an existing undeveloped portion of the Peyton site located to the west of Stoney Hill Road; crèche include 10 car parking spaces and 20 bicycle parking spaces; development includes all associated and ancillary works on a circa 4.33 hectare site comprising 4.14 hectares located to the east of Stoney Hill Road and 0.19 hectares comprising an existing undeveloped portion of the Peyton Residential Estate located to the west of the existing roundabout north of Stoney Hill Road. The site to the east is bounded to the west by Stoney Hill Road and greenfields lands which are subject to a current Phase 1 application under Reg. SD18A/0364 to the north by the existing Rathcoole Park residential estate and to the east and south by undeveloped lands; the site also includes part of Stoney Hill Road and the roadway at the eastern side of Rathcoole Park; this application comprises Phase 2 of an overall residential development of the lands.",
        "address": "Stoney Hill Road, Rathcoole, Co Dublin",
        "Applicant": "Romeville Developments Ltd.",
        "received": "2018-11-16",
        "status": null,
        "decision_date": "2019-04-25",
        "decision_due": "2018-12-13",
        "decision_code": "WITHDRAW THE APPLICATION",
        "decision": "none",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.27710922,
        "longitude": -6.466683297,
        "last_updated": "2020-03-14",
        "area ha": null,
        "no of units": null,
        "agent": null,
        "owner": "Romeville Developments Ltd.",
        "apartments": null,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": null,
        "apt.2_bed": null,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": null,
        "ref": "SD18A/0413"
      },
      "uid": "de0c6ca5f56f7c79b10114aa16ebcc59",
      "id": 111
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.259048247,
          53.402151727
        ]
      },
      "properties": {
        "uid": "dfa6b1383d985f87389984b8510ebd37",
        "25PLUS": "yes",
        "la": "fingal",
        "file_num": "F19A/0401",
        "url": "http://planning.fingalcoco.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=F19A/0401&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "The proposed development is Phase 1 of a 2 Phase masterplan for a mixed residential and commercial scheme on an overall site of c.1.5 hectares, including adjoining lands to the west bound by Northwood Crescent, to the south and west and the north by the Crescent Office Building (Northwood Crescent, Northwood, Santry, Dublin 9). The proposed Phase 1 development will comprise the construction of 2 no. blocks comprising a residential and commercial office development, respectively, with a new proposed shared access road from Northwood Road to the east. The residential development component will comprise a 4 to 7 storey block (c. 8,745 sq.m, gross floor area) over podium level (8 storeys over ground in total) to include: 99 apartments consisting of 10 no. studio units, 35 no. one-bedroom units, 41 no. two-bedroom units, 13 no. three-bedroom units; plant rooms; entrance lobby and internal circulation space; internal waste collection area; residential amenity space; ESB sub-station; switch room; private open space in the form of balconies and terraces (808 sq.m); communal amenity space with children's play area, formal planting and lawn at podium level (1,159 sq.m); 102 no. residential car parking spaces (including 5 no. accessible car parking spaces); 3 no. car sharing parking spaces; 226 residential cycle parking spaces; 4 no. motorbike parking spaces; a four storey commercial office block (c. 3,030 sq.m gross floor area) with 36 no. car parking spaces, 53 no. cycle parking spaces, and all other ancillary spaces including reception area, staff changing and shower facilities, toilets; circulation areas, ESB substation, waste collection area; switch room and plant room; relocation of existing zebra crossing to facilitate the proposed site access road at Northwood Road (to the east); and closure of an existing site access at Northwood Crescent (to the south). The development will also consist of the provision of external circulation areas; pedestrian footpaths; lighting; all hard and soft landscaping; planting; boundary treatments; green roofs; changes in level; and all other associated site excavation works, site development works and site services above and below ground. Add Info received 16th January 2020. Add Info deemed Significant 20th January 2020. Revised Public Notices received 27th January 2020.",
        "address": "Lands located at the southwestern junction of Northwood Avenue and Northwood Road, Northwood, Santry, Dublin 9.",
        "Applicant": "Kategale Limited",
        "received": "2019-08-30",
        "status": "Decision Made by Fingal County Council",
        "decision_date": "2020-02-24",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.40215173,
        "longitude": -6.259048247,
        "last_updated": "2020-03-14",
        "area ha": 0.97,
        "no of units": 99,
        "agent": "Tom Phillips & Associates",
        "owner": "Kategale Limited",
        "apartments": 99,
        "houses": null,
        "student": null,
        "studio": 10,
        "apt.1_bed": 35,
        "apt.2_bed": 41,
        "apt.3_bed": 13,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Office 3030 sqm\r\nOther 8745 sqm",
        "ref": "F19A/0401"
      },
      "uid": "dfa6b1383d985f87389984b8510ebd37",
      "id": 112
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.243183327,
          53.345606958
        ]
      },
      "properties": {
        "uid": "e3a5c23fa4307db31ad93b301de02edd",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "DSDZ2906/18",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=DSDZ2906/18&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "PROTECTED STRUCTURE; The application relates to a proposed development within the North Lotts and Grand Canal Dock Strategic Development Zone Planning Scheme area. The proposed development will consist of; The demolition of existing structures on site on a phased basis which includes the red brick single storey building fronting Sir John Rogerson's Quay (nos.20 - 24), warehouse and annexes to the rear of the 3 storey original office building fronting Sir John Rogerson's Quay (25 - 27); 8 -.10 Hanover Street East, 11 & 11a and 14 Lime Street; provision of 134 no. residential units over ground to set back seventh floor level comprising 20 no. 1 bedroom apartments, 102 no. 2 bedroom apartments, and 12 no 3 bedroom apartments; Balconies on west (Lime Street) and south (Hanover St. East) elevations at all levels and also on the east elevation facing into internal courtyard at all levels; Retail/Retail Services/Offices on Hanover St. East measuring 470 sqm; Basement to extend the full length of Lime Street and will include gym + changing facilities, a community room, 238 no. residential bicycle parking and 200 commercial bicycle parking spaces, staff facilities, storage and waste storage, residents storage space; Provision of 73 no. car parking spaces, including 54 no. spaces for residential use (to include 6 no. car club spaces) and 19 no. spaces for commercial use & plant rooms at basement level. This basement plan is an amendment proposed to supersede the basement plan of the approved adjacent commercial building as per Reg. Ref. DSDZ2252/18; Vehicular entrance to the basement from Lime Street; All other ancillary site development works, site services, a sub-station, plant at basement, boundary treatments & landscaping including a new west-east pedestrian route linking Lime St to Whitaker Square, roof garden of 185 sq m on eastern block facing the internal courtyard, 112 no. surface level bicycle parking spaces; Ancillary signage (c. 100 sq m). The site will be developed over two phases as follows: Phase 1: Demolition of existing warehouse excluding warehouse along Lots 3,5 and 7 on the eastern boundary. Phase 1 building works will include Lime Street block and partial build of Hanover Street East block including ground floor commercial units. Basement, landscaping, vehicular access and separate pedestrian ramp to access from Lime Street. Phase 2: Demolition of warehouse along Lot's3,5 and 7. Phase 2 building works will include completion of Hanover Street East block including ground floor commercial units and Whitaker Lane Block. Landscaping work will be completed and pedestrian ramp access will be extended to link Lime Street and Whitaker Lane.",
        "address": "20-24, Sir John Rogerson's Quay, (a protected structure), 25-27 Sir John Rogerson's Quay, 1-5, 11/11A, 12-14 Lime Street, Lime Court and at 8-10 Hanover Stret East, Dublin 2",
        "Applicant": null,
        "received": "2018-05-02",
        "status": null,
        "decision_date": "2018-06-26",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.34560696,
        "longitude": -6.243183327,
        "last_updated": "2018-07-14",
        "area ha": 0.43,
        "no of units": 134,
        "agent": "Marlet Property Group Limited",
        "owner": "Balark Investments Limited",
        "apartments": 134,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 20,
        "apt.2_bed": 102,
        "apt.3_bed": 12,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Retail 976sqm",
        "ref": "DSDZ2906/18"
      },
      "uid": "e3a5c23fa4307db31ad93b301de02edd",
      "id": 113
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.467879107,
          53.27777253
        ]
      },
      "properties": {
        "uid": "e67d7d3e3aceb15b5648c6483dfee98c",
        "25PLUS": "yes",
        "la": "south dublin",
        "file_num": "SD18A/0364",
        "url": "http://www.sdublincoco.ie/Planning/Details?p=99&regref=SD18A%2F0364",
        "dev_desc": "The demolition of 3 dwellings and the construction of a residential development comprising of 99 residential units in total, consisting of 60 dwellings and 39 apartments; the 60 dwellings comprise of 38 four bed units and 22 three bed units, all in a mix of terrace and semi-detached units and of a height of two storeys (including second floor accommodation in roof space with dormer windows and roof lights); the apartments are located in a single four storey block over part basement level and including a setback at third floor level, located to the north-west of the site to the east and with access from Stoney Hill Road; the apartments comprise of 11 one bedroom units, 19 two bed units and 9 three bed units; new priority access to the new development, in addition to a separate access to the apartment building, linear park to the south together with other public open spaces, landscaping including boundary treatment, underground services and utilities and road and footpaths on the site; 128 surface car parking spaces will be provided and 41 basement car parking spaces and 32 bicycle parking spaces beneath the apartment building; the total gross floor area will be circa 12,538sq.m; 2 storey crèche building of 620sq.m located on an existing undeveloped portion of Peyton site located to the west of Stoney Hill Road; the crèche includes 10 car parking spaces and 20 bicycle parking spaces; including all associated and ancillary works all on a circa 4.36 hectare site comprising 4.17 hectares located to the east of Stoney Hill Road and 0.19 hectares comprising an undeveloped portion of the Peyton Residential Estate located to the west of the roundabout north of Stoney Hill Road; the site to the east is bounded to the west by Stoney Hill Road, to the north by the Rathcoole Park residential estate and to the east and south by undeveloped lands; the application site includes 3 existing houses and includes part of Stoney Hill Road and the roadway at the eastern side of Rathcoole Park.",
        "address": "Stoney Hill Road, Rathcoole, Co Dublin",
        "Applicant": "Romeville Development Ltd.",
        "received": "2018-10-08",
        "status": null,
        "decision_date": "2019-04-25",
        "decision_due": "2018-11-04",
        "decision_code": "WITHDRAW THE APPLICATION",
        "decision": "none",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.27777253,
        "longitude": -6.467879107,
        "last_updated": "2020-02-08",
        "area ha": 4.36,
        "no of units": 99,
        "agent": null,
        "owner": "Romeville Development Ltd.",
        "apartments": 39,
        "houses": 60,
        "student": null,
        "studio": null,
        "apt.1_bed": 11,
        "apt.2_bed": 19,
        "apt.3_bed": 9,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": 22,
        "house.4_bed": 38,
        "house.4+_bed": null,
        "other notes": "no other development",
        "ref": "SD18A/0364"
      },
      "uid": "e67d7d3e3aceb15b5648c6483dfee98c",
      "id": 114
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.247542474,
          53.334142157
        ]
      },
      "properties": {
        "uid": "eb647fec30544fba6a54d8ab7b432995",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "4807/19",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=4807/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "PROTECTED STRUCTURE: A reduction from 20 no. x residential units to 18 residential units, (a quantity reduction of units is required to bring existing, undersized unit sizes up to current minimum sizes and standards) incorporating modifications and improvements to the existing residential accommodation on all floor levels to the three buildings. The proposed mix of the 18 no. x proposed apartments will be 11 no. x 1 bedroom units, 6 no. x 2 bedroom units and 1 no. x 3 bedroom unit. Other works include: External alterations will comprise (1) The provision of new projecting windows to rear returns: (2) Provision of new external platform lift to front lightwell to no.2 Wilton Place; (3) Provision of 2 no. external cast iron balconies to first floor of rear to no.'s 2 and no.3; (4) Roof repair and maintenance works: (5) Replacement of non-original uPVC and single glazed timber windows to the rear returns with painted timber framed double glazed windows; (6) removal of plastic soil vent pipes to rear facades; (7) Replacement of uPVC rainwater pipe with steel/cast iron pipes; (8) Replacement uPVC rooflight to rear return of no.4 Wilton Place with latern type rooflight to replicate rooflights of no.2 and no.3; (9) Replacement of rooflights over stair to no. 2 and no.4 Stair Halls with 1 sq.M of glazed authomatic opening vents; (10) Removal of non-original windows to rear facade, (11) Replacement of non-original galvanised steel stairs to all three front lightwells with new painted steel stairs with stone treads. Internal alterations will comprise of (a) Provision of new internal passenger lift installed within previous stairwell to no.3 where original staircase has been removed; (b) Removal of non-original walls, floors, boxing out and services throughout; (c) Modifications to internal walls and openings (d) Extension of 13 sq.m to first floor of rear return to no.2 Wilton Place; (e) Upgrading fire and acoustic performance of existing suspended timer floors; (f) Provision of new insulated concrete slab to lower ground floor level, including new tanking membrane to slab; (g) Installation of damp-roofing and breathable dry-lining to lower ground floor walls; (h) Re-alignment of stair to third floor to no.2 and no.4; (i) Provision of new services throughout including new services risers and all ancillary works necessary to facilitate the development.",
        "address": "Nos 2, 3 and 4, Wilton Place, Dublin 2",
        "Applicant": null,
        "received": "2019-12-20",
        "status": null,
        "decision_date": "2020-02-21",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.33414216,
        "longitude": -6.247542474,
        "last_updated": "2020-03-07",
        "area ha": 0.05,
        "no of units": 18,
        "agent": "Lawrence and Long Architects",
        "owner": "IPUT PLC",
        "apartments": 18,
        "houses": 0,
        "student": null,
        "studio": null,
        "apt.1_bed": 11,
        "apt.2_bed": 6,
        "apt.3_bed": 1,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Reduction from original 20 to 18 units",
        "ref": "4807/19"
      },
      "uid": "eb647fec30544fba6a54d8ab7b432995",
      "id": 115
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.334249741,
          53.326932244
        ]
      },
      "properties": {
        "uid": "ed7e1a3d2ab63aa9f179d30a34789ea4",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "2319/18",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=2319/18&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "Development at this 2.62 ha site. The proposed development seeks amendments to previously permitted residential development, Reg. Ref. 4244/15, as subsequently amended under Reg.Refs. 2438/17, 2875/17 and 3940/17. The proposed amendments comprise of: i) Provision of an additional setback floor on the north-east elevation of Block A increasing the height from 6 no. storeys as permitted to 7 no. storeys as proposed, all to provide for 55 no. units (25 no. 1-bed, 29 no. 2-bed and 1 no. 3-bed); ii) Revised design and layout of permitted 4-storey Block B to provide for 16 no. units (5 no. 1-bed, 7 no. 2-bed and 4 no. 3-bed) iii) Revised design, layout and position of west portion of permitted 7 storey Block C to provide for 73 no. units (8 no. 1-bed, 51 no. 2-bed and 14 no. 3-bed); iv) Amendments to all elevations of Blocks A, B and C incorporating new and revised balconies/ terraces generally on all floors; v) Revised hard and soft landscaping masterplan; and vi) All associated site development works and ancillary infrastructure and site services to facilitate the proposed development. The proposed amendments will provide for an increase of 4 no. units in Block B (from 12 no. as permitted to 16 no. as proposed), an increase of 6 no. units in Block A (from 49 no. as permitted to 55 no. as proposed) and an increase of 6 no. units in Block C (from 67 no. as permitted to 73 no. as proposed).",
        "address": "Site at Carriglea Industrial Estate, Muirfield Drive, Naas Road, Dublin 12",
        "Applicant": null,
        "received": "2018-12-21",
        "status": null,
        "decision_date": "2019-01-25",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.32693224,
        "longitude": -6.334249741,
        "last_updated": "2019-02-09",
        "area ha": 2.62,
        "no of units": 55,
        "agent": "Marlet Property Group Limited",
        "owner": "Crekav Trading GP Limited",
        "apartments": 55,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 25,
        "apt.2_bed": 29,
        "apt.3_bed": 1,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "no other dev",
        "ref": "2319/18"
      },
      "uid": "ed7e1a3d2ab63aa9f179d30a34789ea4",
      "id": 116
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.288484738,
          53.341841331
        ]
      },
      "properties": {
        "uid": "fb121469185d8677147f954f24c2be87",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "3209/19",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=3209/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "PROTECTED STRUCTURE: Atlas GP Limited intend to apply for a 10 year permission for development on a site of c. 1.3872 hectares (net area 1.3240 hectares) at Grand Canal Harbour, Grand Canal Place, Dublin 8. The site is bounded by a Protected Structure (stone warehouse) fronting onto Grand Canal Place to the north; by Grand Canal Place to the east; by James's Avenue and vehicular access to Westcourt residences to the west; and by the grounds of a former Dublin City Council halting site accessed off Grand Canal Place to the south. The proposed development will supersede the previously permitted development, Reg. Ref. 3855/09, which provided for the demolition of existing structures on site (total GFA of 9,330sqm); retention, renovation, refurbishment and extension of the protected structure (RPS No. 3275) as part of a mixed use development in six blocks, over basement. Similarly, the proposed development will consist of a mixed use development in five blocks, over basement. Block 3/4 shall divide into two blocks at upper levels. The residential component shall be 'Build to Rent' scheme of 550 no. residential units with associated resident support facilities and resident services and amenities. Of the 550 no. residential units, 428 no. will be one bedroom units and 122 no. two bedroom units. Other uses (7,289 sqm) within the proposed development shall be retail, medical, cafes, restaurant, childcare facility and co-working spaces. The proposed development will provide for a water feature to the south of the protected structure to represent the historic use of Grand Canal Harbour. Building height shall range from three storeys to thirteen storeys. Communal terraces, roof gardens shall be provided at roof level on Block 1, Block 2, Block 3/4 and Block 6. Balconies will be provided on all external elevations, save for Block 5 where the protected structure is located. Basement: the basement will be reduced in size from the permitted 8,149sqm to 5,572sqm with water attenuation tank as proposed. The basement will include 50 no. car parking spaces, 737 no. cycle parking spaces, and associated repair areas, plant and services, bin storage, waste compactor and other storage areas for residents' support facilities. Block 1: shall provide for a 696sqm retail unit, a cafe of 144sqm, ESB substation and switchroom, and 84 sqm of residents' support services at ground floor to 126 no. residential units. The block shall be 11 storeys, with maximum parapet height of 57.10mOD. A communal roof garden for residents shall be provide along with an internal atrium feature and a semi open winter garden. Block 2: shall provide for residents' amenities (1,187sqm), childcare facility(224sqm) with dedicated outdoor space of 123sqm, ESB substation and switchroom, and 2 no. lobby entrances to 170 no. residential units. The block shall be 11 storeys with a maximum parapet height of 59.4mOD. At the 8th & 9th floors, the floor area is reduced to provide for communal terraces. A communal roof garden for residents shall be provided above the 11th storey with a semi open winter garden. Block 3/4: shall provide for a restaurant (454sqm), 157sqm of retail/non-retail service, ESB substation and switchroom, and two no. lobbies providing access to 133 residential units at ground floor, 1,707sqm of office space at ground and first floor. At 6th floor, the floorplate reduces to allow 2 smaller footprint blocks to emerge. Block 3 shall continue to 9 storeys while Block 4 shall continue to 13 storeys, with maximum height of 64.08mOD. Communal roof gardens for residents will be accessed from floor 6,9, and above the final storey. A semi open winter garden will be provided on the roof of Block 4. Block 5: works to an existing four-storey warehouse building (c.1396sqm), a protected structure (RPS no. 3275), including the demolition of an existing single storey structure (c.255sqm) adjoining the building to the west & the removal of 6 no.dormer roof windows, metal bars to first floor window opes on north and south elevations, roller shutter door on north elevation, 1 no. window ope on north elevation, all internal stairs & the reinstatement of window opes on north, south and west elevations & the alteration of roof rafters & the refurbishment of external and internal stone/brick work, internal timber floors, internal timber doors and structural steelwork & the refurbishment/ replacement of slate roof finishes, roof vents, eaves rail guardings, rainwater goods, windows & the re-positioning of internal timber hoppers & the addition of 10no. roof dormer windows, 3 no. new window opes on north elevation and 4 no. new window opes on south elevation, 1 no. stair/lift core, 2 no. new entrances on north elevation including the excavation of the entire ground floor, new floor plate to section of second floor level (c.181sqm), new internal partition walls, new door opes to internal stone/brick work walls & the construction of 1 no. new three-storey extension (c.698sqm) adjoining the building to the west. The building will have a total gross floor area of c.2277sqm and will provide 1 no. retail unit (c.154sqm), 1 no. cafe unit (c.215sqm), 1 no. co-working office unit (c.1,376sqm) and 1 no. medical centre (c.532sqm). Block 6: shall provide for the basement access ramp which runs underneath the building, resident support facility (104sqm) use, ESB substation and switchroom, and two lobbies to residential units (111 no.) at ground floor. Medical use (1,630sqm) over ground and first floor, with apartments also to be provided at first floor. Apartments shall be provided for the rest of the building, which is seven storeys in total. A communal roof garden with semi open winter garden shall be provided for residents. The parapet height of Block 6 is 45.40 OD, with a corner at south at 46.075OD. Ancillary works, servicing and plant, pedestrian circulation, landscaping, cycle parking (118 at ground level to give a total of 855 spaces), vehicular set down, waste marshalling area, ventilation opes, and all associated site works. Total gross floor area of proposed redevelopment is 49,710sq.m. An Environmental Impact Assessment Report and Natura Impact Statement will be submitted to the planning authority with the application and we be made available for inspection or purchase at a fee not exceeding the reasonable cost of making a copy at the offices of the Planning Authority.",
        "address": "Grand Canal Harbour, Grand Canal Place, Dublin 8",
        "Applicant": null,
        "received": "2019-10-01",
        "status": null,
        "decision_date": "2019-11-25",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.34184133,
        "longitude": -6.288484738,
        "last_updated": "2019-12-14",
        "area ha": 1.321,
        "no of units": 550,
        "agent": "John Spain Associates ",
        "owner": "Atlas GP Ltd",
        "apartments": 550,
        "houses": null,
        "student": null,
        "studio": null,
        "apt.1_bed": 428,
        "apt.2_bed": 122,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Childcare 224 sqm\r\nRestaurant 454sqm\r\nMedical 1,630 sqm",
        "ref": "3209/19"
      },
      "uid": "fb121469185d8677147f954f24c2be87",
      "id": 117
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.078363076,
          53.389168841
        ]
      },
      "properties": {
        "uid": "fd3d3d897040ebbfac0bee16e1c35434",
        "25PLUS": "need to add to ABP SHD list\r\nhttp://www.pleanala.ie/casenum/306102.htm\r\nNeed to get location",
        "la": "fingal",
        "file_num": "SHD/009/19",
        "url": "http://planning.fingalcoco.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=SHD/009/19&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "To view the full Strategic Housing Development and application please visit: www.claremontshd.ie Demolition of all structures on site (c8,162sq.m. GFA) and excavation of a basement. The proposed development comprises of the provision of a mixed use development of residential/retail/restaurant/cafe uses and a creche in 4 no. blocks (A to D), over part basement Blocks A, B, C and D with a height up to a maximum of seven storeys of apartments over lower ground floor and basement car parking levels (a total of eight storeys over basement level).. The residential component will consist of 512 no. residential units. The proposed development includes the provision of two vehicular entrances on to the Howth Road, excavation of basement to provide for car parking , plant, waste storage and ancillary use. Additional car parking spaces shall be provided at lower ground floor level. A total of 439 no. car parking spaces and 1,335 no. bicycle parking spaces, including 49 no. bicycle spaces to cater for the retail units and creche shall be provided. One vehicular access is located at Block A, serving car parking spaces. The second is at Block C, providing access to the basement, residential and retail parking, and a service area for the retail units. A service route will be provided along part of the northern perimeter of the site with access from the western end of the site at a junction with Howth Road and at the main vehicular entrance at Block C. A publicly accessible walkway/cycleway to the north of the site shall be provided at podium level. A civic plaza will be provided between Blocks D and C, and a landscaped park to the west of Block A. A channel to the sea for the Bloody Stream with associated riparian strip shall be incorporated as a feature within a designed open space between Blocks A and B. Communal gardens will be provided for Blocks A, B and C. The residential component consists of 512 no. residential units, which includes 4 no. studio, 222 no. one bed, 276 no. two bed, 10 no. three bed apartments, and communal facilities of 708sq.m. Ground floor units onto the Howth Road will have own door access. The units will be served by balconies or terraces on all elevations. Block A, with a maximum height of seven storeys of apartments over lower ground level car park (a total of eight storeys), will provide for 234 residential units, with residents' amenities to include a gym, residents' lounge, residents' support office, and 2 no. residents' multi-purpose rooms. Block B, with a maximum height of seven storeys of apartments over lower ground and basement car park (a total of eight storeys over basement), shall provide for 154 units, residents' lounge, residents' multi-purpose room and creche of 236sq.m. with outdoor play area. Own door access will be provided at ground floor. Block C, with a maximum height of seven storeys over basement car parking (a total of seven storeys) will provide for 83 no. residential units in two wings over a retail unit and Block D, with a maximum of 6 storeys over basement, shall provide for 41 no. residential units over retail units. The commercial component in Blocks C and D consists of 4 no. units with 2,637sq.m. gross floor area. In Block C, it consists of a 1,705sq.m. anchor unit, accessed from the civic plaza. In Block D, it consists of a restaurant (243sq.m.) and retail unit (603sq.m.) and café (86sq.m.). The restaurant and retail units are accessed from Howth Road, and the café is accessed from the upper level of the civic plaza. The proposed development includes the provision of public and communal open space, green roofs, landscaping, boundary treatments, set down locations, substations, meter rooms, waste management and all ancillary site works, including upgrading of the public paths along Howth Road and relocation of bus stop in new setback with a bus shelter. Two set down areas are provided at either end of the site. The gross floor area of the proposed development is 48,252sq.m. (excluding car parking) on a site of 2.68ha. The site is zoned Town and District Centre in the Fingal Development Plan 2017-2023, under whic the proposed uses are permitted in principle. The application contains a statement indicating why permission should be granted for the proposed development, having regard to a consideration specified in section 37(2)(b) of the Planning & Development Act 2000, as amended, notwithstanding that the proposed development materially contravenes a relevant development plan or local area plan other than in relation to the zoning of the land. An environmental impact assessment report and a Natura impact statement have been prepared in respect of the proposed development. The application together with the environmental impact statement report and Natura impact statement may be inspected, or purchased at a fee not exceeding the reasonable cost of making a copy, during public hours at the offices of An Bord Pleanála and Fingal County Council. The application may also be inspected online at the following website set up by the applicant: www.claremontshd.ie",
        "address": "Former Techrete Site/Beshoff Motors & Garden Centre, Howth Road, Howth, Co. Dublin, D13 V883",
        "Applicant": "Atlas GP Ltd.",
        "received": "2019-12-09",
        "status": null,
        "decision_date": null,
        "decision_due": null,
        "decision_code": null,
        "decision": "none",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.38916884,
        "longitude": -6.078363076,
        "last_updated": "2019-12-28",
        "area ha": 2.68,
        "no of units": 512,
        "agent": "John Spain Associates ",
        "owner": "Atlas GP Ltd. ",
        "apartments": 512,
        "houses": 0,
        "student": 0,
        "studio": 4,
        "apt.1_bed": 222,
        "apt.2_bed": 276,
        "apt.3_bed": 10,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": null,
        "house.4_bed": null,
        "house.4+_bed": null,
        "other notes": "Childcare facilities (* no. of childcare spaces) *insert no.\r\nof childcare spaces\r\n236 sqm\r\n(57 no. childcare\r\nspaces)\r\nRetail 2,308 sqm\r\nRestaurant and cafe 329 sqm",
        "ref": "SHD/009/19"
      },
      "uid": "fd3d3d897040ebbfac0bee16e1c35434",
      "id": 118
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -6.25751091,
          53.31969503
        ]
      },
      "properties": {
        "uid": "fe8d5a296d5970f87bfcb357e9d5dff2",
        "25PLUS": "yes",
        "la": "dublin city",
        "file_num": "4011/18",
        "url": "http://www.dublincity.ie/swiftlg/apas/run/WPHAPPDETAIL.DisplayUrl?theApnID=4011/18&backURL=Search Criteria > Search Criteria'>Search Results",
        "dev_desc": "PROTECTED STRUCTURE: Permission is sought by Seabren Developments Ltd. for the development of a site of c.0.50 ha comprising a commercial premises former Deignan Bros Limited (Eircode D06 H026) and curtilage to the rear of Annesley Park bounded by existing pedestrian lanes to the rear of Killeen Road, Ormond Road and Annesley Park, with access from Dunville Close, and alterations to boundary of No. 1 Annesley Park, (Eircode D06 XW97) a Protected Structure, Ranelagh, Dublin 6. The development will consist of the demolition of all buildings on the former commercial site to the rear and the construction of a new residential development with access from the existing vehicular access road along Dunville Close, The proposed development includes widening the access road along Dunville Close, including demolition of boundary wall and shed to the rear and side of No. 1 Annesley Park (Eircode D06 XW97), Dublin 6, a Protectred Structure. The development will comprise 20 no. residential houses consisting of 11 no. 3 storey 4 bed houses and 9 number 2.5 storey 3 bed houses ranging in size from circa 187 sqm to 145 sqm each with rear gardens and terraces with (opaque glazed screening). Each house will have a parking space to the front together with 2 number visitor spaces for the development and bicycle parking, bin storages areas. The proposal also includes all asssociated site development works, roads and paths, landscaping boundary treatment, including works and repairs of existing boundary walls, rear pedestrian access to each dwelling, public lighting and piped service provision.",
        "address": "1 Annesley Park, Dublin 6",
        "Applicant": null,
        "received": "2019-02-05",
        "status": null,
        "decision_date": "2019-03-04",
        "decision_due": null,
        "decision_code": "GRANT PERMISSION",
        "decision": "grant",
        "has_geo": 1,
        "abp_ref": null,
        "latitude": 53.31969503,
        "longitude": -6.25751091,
        "last_updated": "2020-06-20",
        "area ha": 0.5,
        "no of units": 20,
        "agent": "Doyle Kent PP Ltd",
        "owner": "Seabren Developments",
        "apartments": 0,
        "houses": 20,
        "student": null,
        "studio": null,
        "apt.1_bed": null,
        "apt.2_bed": null,
        "apt.3_bed": null,
        "apt.4_bed": null,
        "apt.4+_bed": null,
        "house.1_bed": null,
        "house.2_bed": null,
        "house.3_bed": 8,
        "house.4_bed": 11,
        "house.4+_bed": null,
        "other notes": "No other development",
        "ref": "4011/18"
      },
      "uid": "fe8d5a296d5970f87bfcb357e9d5dff2",
      "id": 119
    }
  ]
}
